/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable-next-line no-unused-vars */
import React from 'react';

export const locale = {
  "locales": ["pl"],
  "messages": {
    "editor": {
      "first_name": "Imię i nazwisko",
      "name": "Nazwa",
      "subject": "Przedmiot",
      "message": "Wiadomość",
      "custom_dropdown": "niestandardowy dropdown",
      "custom_label": "Własne oznakowanie",
      "set_autoplay": "Autoplay",
      "autoplay_info": "Uwaga! Niektóre przeglądarki w większości przypadków nie pozwalają na autoplay. Jednak wyciszone autoodtwarzanie jest zawsze dozwolone.",
      "set_muted": "Wyciszenie",
      "data_policy_info": "Informacja o ochronie danych osobowych",
      "fill_data_policy_before_save": "Przed zapisaniem proszę całkowicie wypełnić dane dotyczące ochrony danych. Znajdziesz je w ustawieniach",
      "data_protection_officer": "Inspektor ochrony danych",
      "data_protection_authority": "Organ ochrony danych",
      "button_font_color": "Kolor czcionki",
      "set_label_dropdown": "Proszę przypisać etykietę do rozwijanej listy",
      "set_label_custom_field": "Proszę przypisać etykietę dla pola wejściowego",
      "empty_field": "wolne pole",
      "custom_field": "niestandardowe pole",
      "change_label": "Zmień etykietę",
      "edit_label": "Etykieta",
      "salutation": "Salutacja",
      "title": "Tytuł",
      "link_title": "Oznaczenie łącza",
      "main_text": "Tekst główny",
      "more_text": "dalszy tekst",
      "create_text": "Utwórz tekst",
      "edit_text_slider": "Nie utworzono jeszcze żadnego elementu tekstowego",
      "edit_rss_elements": "Nie wybrano jeszcze żadnych elementów formularza, kliknij tutaj, aby dodać.",
      "rss_settings": "Ustawienia kanałów RSS",
      "select_rss": "Możesz wybrać kanał RSS z szablonów",
      "available_rss": "Dostępne kanały RSS",
      "load_rss_part_1": "Wybrano następujący kanał RSS.",
      "load_rss_part_2": "Kliknij na przycisk \"Pobierz kanały RSS\", aby załadować kanały",
      "load_rss_feeds": "Pobierz kanały RSS",
      "color": "Kolor",
      "background_color": "Kolor tła",
      "distance_to_border": "Odległość do krawędzi",
      "color_of_qrcode": "Kolor kodu QR",
      "click_me": "Kliknij mnie",
      "new_menu_item": "Nowa pozycja menu1",
      "external": "zewnętrzna",
      "imprint": "Imprint1",
      "privacy": "Ochrona danych1",
      "january": "Styczeń",
      "february": "Luty",
      "march": "Marzec",
      "april": "Kwiecień",
      "may": "Maj",
      "june": "Czerwiec",
      "july": "Lipiec",
      "august": "Sierpień",
      "september": "Wrzesień",
      "october": "Październik",
      "november": "Listopad",
      "december": "Grudzień",
      "monday": "Poniedziałek",
      "tuesday": "Wtorek",
      "wednesday": "Środa",
      "thursday": "Czwartek",
      "friday": "Piątek",
      "saturday": "Sobota",
      "sunday": "Niedziela",
      "edit_date": "Edycja nominacji",
      "oclock": "Zegar",
      "filter_selection": "Wybór filtra",
      "use_filter": "Zastosuj",
      "sample_picture_found": "Znaleziono przykładowy obraz",
      "already_edited_in_another_tab": "Ta edycja jest już edytowana w innej zakładce.",
      "information_for_contact": "Dane do formularza kontaktowego",
      "mail_receiver": "Odbiorca poczty elektronicznej",
      "google_analytics": "Google Analytics",
      "measurement_id": "ID pomiaru dla Google Analytics",
      "new_picture_inserted": "Wstawione nowe zdjęcie",
      "text_changed": "Tekst zmieniony",
      "edit_title": "Kliknij tutaj, aby edytować tytuł",
      "edit_description": "Kliknij tutaj, aby edytować opis zdjęcia",
      "edit_copyright": "Kliknij tutaj, aby edytować prawa autorskie",
      "no_changes": "Bez zmian",
      "changes_on_document": "Zmiany w dokumencie",
      "changes_on_page": "Zmiany na stronie",
      "page": "Strona",
      "choose_button_label": "Proszę wybrać etykietę dla przycisku",
      "edit_calendly": "Kliknij tutaj, aby edytować ustawienia dla Calendly",
      "exchanged_with_page": "wymieniony ze stroną",
      "upload_failed": "Przesyłanie nie powiodło się",
      "try_again": "Proszę spróbować ponownie.",
      "saving_failed": "Zapisanie nie powiodło się",
      "new_page_inserted": " nowa strona/nowe strony wstawione po stronie",
      "delete_pages": "Usuń strony",
      "all_content_deleted": "Strony i cała zawartość na nich zostanie usunięta",
      "yes_delete": "Tak, usuń",
      "pages_deleted": " Strona/i usunięte, według stron",
      "rather_not": "Lepiej nie",
      "new_here": "Jesteś tu nowy?",
      "first_start": "Wygląda na to, że otworzyłeś nasz nowy edytor po raz pierwszy. Czy chciałbyś się przedstawić?",
      "yes_absolutely": "Tak, absolutnie",
      "im_fine": "Zarządzam",
      "no_page_definitions_found": "Nie znaleziono definicji stron!",
      "move_up": " Przesuń stronę(y) w górę",
      "side_position_fixed": "Pozycja boczna stała",
      "generated_in_pdf": "Strony są automatycznie generowane w PDF",
      "move_down": " Przesuń stronę(y) w dół",
      "by": "Na stronie",
      "add_page": " Strony wkładane",
      "remove_page": " Usuń strony",
      "unsaved_changes": "Masz niezapisane zmiany",
      "i_have_it": "Ok, teraz mam to!",
      "document_pictures": "Obrazy w dokumencie",
      "used_images": "Wykorzystane obrazy",
      "take_a_photo": "Zrób zdjęcie",
      "unused_images": "Nieużywane obrazy",
      "content_is_saved": "Zawartość jest zapisywana",
      "page_arrangement": "Układ stron",
      "print_sheet_view": "Widok arkusza wydruku",
      "view_safety_distance": "Wyświetlanie odległości bezpieczeństwa",
      "view_structure": "Widok struktury",
      "start_tutorial": "Rozpocząć samouczek",
      "adjust_by_window": "Dopasowanie strony do okna",
      "adjust_by_width": "Dopasowanie strony do szerokości",
      "adjust_by_height": "Dopasowanie strony do wysokości",
      "delete_content": "Usuń zawartość",
      "delete_selected_content_block": "Usuwa to wybrany blok treści i jego zawartość (obrazy, teksty).",
      "reset_content": "Wyzerować zawartość",
      "reset_content_block_to_root": "Resetuje to wybrany blok treści i jego zawartość (obrazy, teksty) do stanu pierwotnego.",
      "yes_reset": "Tak, reset",
      "copy_full_content": "Kopiowanie całej zawartości strony",
      "paste_content": "Wklejanie zawartości ze schowka",
      "enlarge_block": "Powiększ blok",
      "shrink_block": "Zmniejszyć blok",
      "text_overflow": "Przepełnienie tekstu",
      "initial_image_available": " Dostępny obraz początkowy",
      "paste_content_after": "Wklejanie zawartości ze schowka po tych",
      "deselect_element": "Odznacz element",
      "select_element": "Wybierz element",
      "block_can_not_move": "Blok nie może zostać przesunięty",
      "up": "W górę",
      "reset_block": "Blok resetowania",
      "change_backgroundcolor": "Zmiana koloru tła",
      "change_fontcolor": "Zmiana koloru czcionki",
      "copy_block": "Blok do kopiowania",
      "delete_block": "Usuń blok",
      "down": "Down",
      "product_in_cart": "Produkt w koszyku",
      "added_to_cart": " został dodany do Twojego koszyka.",
      "great": "Świetnie!",
      "to_cart": "Do koszyka",
      "are_you_sure": "Jesteś pewien?",
      "reset_to_selected_status": "Dokument jest resetowany do wybranego stanu",
      "abort": "Anuluj",
      "reset_to_version": "Reset do wersji",
      "choose_a_campaign": "Wybierz kampanię",
      "name_for_edition": "Nazwa dla tej edycji",
      "save_to": "Zapisz jako...",
      "save": "Zapisz",
      "settings": "Ustawienia",
      "short_summary": "Krótkie podsumowanie",
      "keywords_separated": "Słowa kluczowe oddzielone przecinkiem",
      "serial_letter": "Łączenie poczty",
      "activate_serial_letter": "Aktywuj list formalny",
      "serial_letter_database": "Łączenie poczty z bazą danych",
      "serial_letter_database_upload_info": "Przesyłanie obsługuje następujące formaty plików - .xlsx, .xls i .csv",
      "serial_letter_info": "Proszę wpisać placeholdery do komórek pierwszego wiersza w bazie danych. Poniżej należy wpisać odpowiednie wartości.",
      "preview_of_database": "Podgląd bazy danych",
      "serial_letter_database_upload": "Prześlij",
      "no_error": "Bez błędu",
      "error": "Błąd",
      "information_for_imprint": "Szczegóły dotyczące nadruku",
      "responsible_for_content": "Odpowiedzialny za treść",
      "company_association": "Firma / Stowarzyszenie",
      "street": "Ulica",
      "zip_code": "Kod pocztowy",
      "city": "Lokalizacja",
      "email": "Adres e-mail",
      "phone_number": "Telefon",
      "data_protection_information": "Informacje o ochronie danych osobowych",
      "responsible": "Odpowiedzialny",
      "change": "Zmiana",
      "export_image": "Eksportuj obraz",
      "preview": "Podgląd",
      "preview_button": "Podgląd przycisków",
      "print_pdf": "Drukuj PDF",
      "initialize": "Zainicjuj!",
      "order": "Zamówienie",
      "versions": "Wersje",
      "currently_used_image": "Aktualnie używany obraz",
      "upload_new_image": "Prześlij nowe zdjęcie",
      "new_cut": "Wycięcie",
      "take_on": "Przejąć kontrolę",
      "choose_file": "Wybierz plik",
      "image_description": "Opis obrazu",
      "image_upload": "Przesyłanie zdjęć",
      "mediathek": "Biblioteka multimediów",
      "pixabay": "Pixabay",
      "add_content": "Dodaj treść",
      "copied_content_block": "Skopiowany blok treści",
      "unsaved_content": "Masz niezapisane zmiany! Czy naprawdę chcesz odejść od redaktora?",
      "filter_settings": "Ustawienia filtra",
      "filter_grayscale": "Grayscale",
      "filter_sepia": "Sepia",
      "filter_blur": "rozmycie",
      "filter_brightness": "Jasność",
      "filter_contrast": "Kontrast",
      "filter_hueRotate": "Obrót odcienia",
      "filter_invert": "Odwróć kolory",
      "filter_opacity": "Przejrzystość",
      "filter_saturate": "Nasycenie",
      "filter_default": "Standard",
      "filter_set": "Posted",
      "work_surface": "W tym miejscu znajduje się powierzchnia robocza1.",
      "work_surface_description": "W tym miejscu odbywa się proces projektowania. Można tu wstawiać i edytować obrazy, teksty i elementy.",
      "page_navigation": "Oto nawigacja na stronie",
      "page_navigation_description": "Można tutaj przełączać się pomiędzy poszczególnymi stronami i dodawać, usuwać lub zamieniać ze sobą strony.",
      "content_blocks": "Tutaj znajdziesz bloki treści",
      "content_blocks_description": "Tutaj możesz wstawiać różne elementy graficzne i tekstowe do swoich materiałów reklamowych, klikając na nie. W przypadku braku miejsca na materiałach reklamowych, w każdej chwili można usunąć zbędne elementy.",
      "screen_view": "Tutaj można zmienić widok ekranu.",
      "screen_view_description": "Tutaj możesz zmienić widok swoich mediów internetowych. 100% zawsze stanowi oryginalny rozmiar ogłoszenia.",
      "error_display": "Tutaj wyświetlane są błędy.",
      "error_display_description": "System powiadamia tutaj o wykryciu przepełnienia tekstu lub innego błędu technicznego.",
      "options": "Tutaj znajdziesz opcje dla swoich materiałów reklamowych.",
      "options_description": "Kliknij na przycisk podglądu, aby wygenerować podglądowy PDF lub na przycisk zamówienia, aby umieścić materiał reklamowy w koszyku. Dzięki opcji \"Zapisz jako\" możesz skopiować swój materiał reklamowy do innej kampanii.",
      "tutorial_end": "To był nasz redaktor w pigułce!",
      "tutorial_end_description": "Teraz możesz szybko i łatwo zaprojektować swoje materiały reklamowe zgodnie z projektem korporacyjnym.",
      "content_block_copied": "Skopiowany blok treści",
      "content_blocks_switched": "Zamienione bloki treści",
      "content_block_reset": "Resetowanie bloku treści",
      "content_block_resize": "Zmiana rozmiaru bloku treści",
      "content_block_removed": "Usunięto blok treści",
      "no_place": "Brak miejsca",
      "content_block_inserted": "Wstawiony blok treści",
      "no_dates_available": "Brak dostępnych dat, kliknij tutaj, aby je dodać.",
      "new_date": "Nowa data",
      "edit_dates": "Edycja terminów",
      "date_description": "Opis nominacji",
      "add": "Dodaj",
      "no_dates_availableTwo": "Brak dostępnych terminów",
      "date_title": "Tytuł nominacji",
      "date_place": "Miejsce wyznaczenia",
      "date_from": "On/Down",
      "date_to": "Do",
      "no_forms": "Nie wybrano jeszcze żadnych elementów formularza, kliknij tutaj, aby dodać",
      "read_privacy_policy": "Zapoznałem się i zrozumiałem politykę prywatności.",
      "contact_form_settings": "Ustawienia formularza kontaktowego",
      "dropdown_settings": "Ustawienia rozwijania",
      "add_options": "Dodaj opcje",
      "dropdown_label": "Etykieta rozwijana",
      "dropdown_option_fields": "Pola opcji rozwijanych",
      "pls_choose": "Proszę wybrać element formularza",
      "pls_chooseTwo": "Proszę wybrać żądane elementy formularza kontaktowego",
      "send": "Zgłoś",
      "google_maps_element_settings": "Ustawienia lokalizacji Mapy Google",
      "no_location": "Nie dodałeś jeszcze adresu, kliknij tutaj aby edytować",
      "found_textoverflow": "Stwierdzono przepełnienie tekstu",
      "minimum_size": "Minimalna wielkość",
      "too_low_resolution": "Obraz ma zbyt małą rozdzielczość!",
      "set_scale_free": "Włącz swobodne skalowanie",
      "unset_scale_free": "Dezaktywuj darmowe skalowanie",
      "no_images_selected": "Nie wybrano jeszcze żadnych zdjęć, kliknij tutaj, aby dodać",
      "gallery_settings": "Ustawienia galerii",
      "add_image": "Dodaj obraz",
      "add_image_front": "Dodaj zdjęcie na początku",
      "add_image_back": "Dodaj zdjęcie na końcu",
      "slider_images_invert": "Odwróć kolejność obrazów",
      "image_text_settings": "Ustawienia tekstu obrazu",
      "change_slider": "Aby zmienić tytuł lub opis kliknij na odpowiedni tekst w suwaku",
      "change_image_title": "Zmiana tytułu zdjęcia",
      "change_image_description": "Zmiana opisu zdjęcia",
      "image_copyright": "Prawo autorskie do zdjęć",
      "slider_settings": "Ustawienia suwaka",
      "new_titel": "Nowy tytuł",
      "new_link_title": "Nowy tytuł linku",
      "edit_text_title": "Tytuł edycji",
      "edit_text_link": "Edytuj link",
      "edit_link_title": "Edytuj tytuł linku",
      "edit_text_text": "Edycja tekstu",
      "add_element": "Dodaj pozycję",
      "add_element_before": "Dodaj element z przodu",
      "add_element_after": "Dodaj element z tyłu",
      "edit_text_of_element": "Aby edytować teksty, kliknij na odpowiedni tekst w suwaku",
      "invert_elements": "Odwrócenie kolejności",
      "edit_nav": "Edycja nawigacji",
      "term": "Oznaczenie",
      "link": "Link",
      "actions": "Działania",
      "content_of_QRCode": "Jakie treści powinny znaleźć się w kodzie QR:",
      "address_of_website": "Wpisz adres strony internetowej:",
      "name_surname": "Imię i nazwisko",
      "business_card": "Wizytówka",
      "must_url": "Musi to być adres URL",
      "position": "Pozycja",
      "phone": "Telefon",
      "website": "Strona internetowa",
      "address": "Adres",
      "email_message": "Wiadomość e-mail",
      "text": "Tekst",
      "recipient_email_address": "Adres e-mail odbiorcy",
      "reference": "Przedmiot",
      "content": "Treść",
      "your_text": "Twój tekst",
      "add_QRCode": "Wstaw kod QR",
      "no_preview_of_twitter": "Niestety nie ma możliwości wyświetlenia tutaj Twittera, proszę skorzystać z funkcji podglądu strony.",
      "no_preview_of_calendly": "Niestety nie ma możliwości wyświetlenia w tym miejscu Calendly, proszę skorzystać z funkcji podglądu strony.",
      "twitter_link": "Link do Twittera zamieszczony:",
      "social_media_settings": "Ustawienia mediów społecznościowych",
      "calendly_settings": "Ustawienia Calendly",
      "button_settings": "Ustawienia przycisków",
      "action_button_content_text": "Kliknij tutaj, aby edytować ustawienia dla przycisku akcji",
      "action_button_link_element": "Odniesienie do elementu",
      "action_button_external_link": "Odniesienie do linku zewnętrznego",
      "action_button_or": "lub",
      "button_color": "Kolor guzika",
      "add_social_media_account": "Nie dodano jeszcze żadnego konta w mediach społecznościowych, kliknij tutaj, aby je wybrać.",
      "choice_of_provider": "Wybór dostawców mediów społecznościowych",
      "embed_code": "Kod osadzony z kanału mediów społecznościowych",
      "link_to_your_page": "Link do Twojej strony na",
      "link_to_your_calendly_page": "Link do Twojej strony w Calendly",
      "link_to_your_page_two": "Link do Twojej strony",
      "video_settings": "Ustawienia wideo",
      "add_video": "Nie wybrano jeszcze żadnego filmu, kliknij tutaj, aby go wstawić",
      "choice_video_provider": "Dostawca wideo selekcji",
      "upload_video": "Prześlij film",
      "choice_mp4_file": "Wybierz plik wideo (.mp4)",
      "delete_children_of_parents": "Uwaga: To jest element nadrzędny. Jeśli go usuniesz, wszystkie powiązane elementy dziecięce również zostaną usunięte.",
      "nav_type": "Typ",
      "nav_type_url": "URL",
      "nav_type_page": "Strona",
      "nav_type_page_prefix": "Strona"
    },
    "medialibrary": {
      "new_folder": "Nowy folder",
      "sorting": "Sortowanie",
      "directories": "Katalogi",
      "medialibrary": "Biblioteka multimediów",
      "media": "Media",
      "upload_media": "Prześlij media",
      "sorting_description": "Należy pamiętać, że sortowanie odbywa się według nazwy pliku, a nie według zdefiniowanego tytułu.",
      "sorting_info_text": "Wybierz kolejność sortowania folderów i nośników. Sortowanie zestawu obowiązuje również w obrębie wszystkich wywołań folderów.",
      "paste": "Wkładka",
      "info": "Uwaga!",
      "info_text": "Jeden lub więcej plików już istnieje. Nie zostały one ponownie wgrane.",
      "back_to_root": "Powrót do katalogu głównego",
      "directory_by": "Katalog z",
      "created_by": "Stworzony przez",
      "no_folder_created": "Nie utworzono żadnych folderów",
      "no_media_found": "Brak nośników w folderze",
      "upload_processing": "Twoje pliki są przetwarzane",
      "not_uploaded": "Nie można załadować mediów!",
      "close": "Zamknij",
      "preview": "Podgląd obrazu/wideo",
      "name": "Nazwa",
      "upload_info": "Info",
      "options": "Opcje",
      "status": "Status",
      "adjust_meta": "Dostosuj metadane",
      "title": "Tytuł",
      "description": "Opis",
      "save": "Zapisz",
      "create_new_directory": "Utwórz nowy katalog",
      "directory_name": "Nazwa katalogu",
      "rename_folder": "Zmień nazwę folderu",
      "copyright": "Copyright",
      "upload": "Prześlij",
      "wastebasket": "Kosz na śmieci",
      "are_you_sure_erase_file": "Czy na pewno chcesz trwale usunąć plik?",
      "are_you_sure_erase_folder": "Czy na pewno chcesz nieodwracalnie usunąć folder?",
      "erase": "Usuń"
    },
    "meta": {
      "campaigns": {
        "title": "Kampanie",
        "description": "Kampanie",
        "name": "Kampanie"
      },
      "productShop": {
        "title": "Sklep",
        "description": "Szukasz towaru? W takim razie trafiłeś we właściwe miejsce.",
        "name": "Artykuł"
      },
      "carShop": {
        "title": "Pojazdy Sklep",
        "description": "Szukasz swojego wymarzonego samochodu? W takim razie już teraz zapoznaj się z naszymi pojazdami.",
        "name": "Pojazdy"
      },
      "car_detail_search": {
        "title": "Nie jesteś pewien, który samochód Ci odpowiada? Skorzystaj z naszej wyszukiwarki samochodów, aby znaleźć idealny samochód dla siebie",
        "description": "Szukasz samochodu o specyficznych wymaganiach, ale nie wiesz dokładnie jakiego auta potrzebujesz? Wybierz typ pojazdu, układ napędowy i poziom wyposażenia.",
        "name": "Szczegółowe wyszukiwanie"
      },
      "car_brands": {
        "title": "Wybierz swoją markę",
        "description": "Wybierz swoją markę i odkryj najlepsze oferty na rynku.",
        "name": "Wybór marki"
      },
      "car_models": {
        "title": "Wybierz model swojej {brandName}",
        "description": "Wybierz model od najbardziej popularnego {modelOne} do {modelTwo}.",
        "name": "Modele"
      },
      "car_model_drive": {
        "title": "Wybierz rodzaj paliwa i skrzyni biegów dla Twojego {brandName} {modelName}.",
        "description": "Mamy do dyspozycji {brandName} {modelName} z silnikami {fuelTypes}. Dostępne typy przekładni to {gearboxTypes}.",
        "name": "Rodzaj paliwa"
      },
      "car_model_equipment": {
        "title": "Wybierz poziom wyposażenia dla swojego samochodu {brandName} {modelName}.",
        "description": "Wybierz spośród Budget, Family, Comfort lub Business. Najpopularniejszy, Comfort, oferuje czujniki parkowania, Bluetooth i inne.",
        "name": "Sprzęt"
      },
      "favorites": {
        "title": "Twoje ulubione, zapisane na później",
        "description": "Świetnie, że zachowałeś niektóre z naszych najlepszych pozycji na później. Teraz spróbuj wybrać ten, który chcesz.",
        "name": "Ulubione"
      },
      "cart": {
        "title": "Koszyk",
        "description": "Koszyk",
        "name": "Koszyk"
      },
      "checkout": {
        "title": "Kasa",
        "description": "Kasa",
        "name": "Kasa"
      },
      "clients": {
        "title": "Klienci",
        "description": "Klienci",
        "name": "Klienci"
      },
      "client_details": {
        "title": "Firma",
        "description": "Firma",
        "name": "Firma"
      },
      "leads": {
        "title": "Leady",
        "description": "Leady",
        "name": "Leady"
      },
      "lead_details": {
        "title": "Lead",
        "description": "Lead",
        "name": "Lead"
      },
      "cars": {
        "title": "Pojazdy",
        "description": "Pojazdy",
        "name": "Pojazdy"
      },
      "car_overview": {
        "title": "Przegląd pojazdów",
        "description": "Przegląd pojazdów",
        "name": "Przegląd pojazdów"
      },
      "car_details": {
        "title": "Pojazd",
        "description": "Pojazd",
        "name": "Pojazd"
      },
      "pages": {
        "title": "Strona",
        "description": "Strona",
        "name": "Strona"
      },
      "page_details": {
        "title": "Strona",
        "description": "Strona",
        "name": "Strona"
      },
      "profile": {
        "title": "Profil",
        "description": "Profil",
        "name": "Profil"
      },
      "locations": {
        "title": "Lokalizacje",
        "description": "Lokalizacje",
        "name": "Lokalizacje"
      },
      "company_locations": {
        "title": "Lokalizacje",
        "description": "Lokalizacje",
        "name": "Lokalizacje"
      },
      "data_push": {
        "title": "Przesunięcie danych",
        "description": "Przesunięcie danych",
        "name": "Przesunięcie danych"
      },
      "white_label_projects": {
        "title": "Projekty typu white label",
        "description": "Projekty typu white label",
        "name": "Projekty typu white label"
      },
      "users": {
        "title": "Użytkownik",
        "description": "Użytkownik",
        "name": "Użytkownik"
      },
      "user_details": {
        "title": "Użytkownik",
        "description": "Użytkownik",
        "name": "Użytkownik"
      },
      "user_import": {
        "title": "Importuj użytkownika",
        "description": "Importuj użytkownika",
        "name": "Importuj użytkownika"
      },
      "teams": {
        "title": "Zespoły",
        "description": "Zespoły",
        "name": "Zespoły"
      },
      "questionnaires": {
        "title": "Kwestionariusze",
        "description": "Kwestionariusze",
        "name": "Kwestionariusze"
      },
      "questionnaire_details": {
        "title": "Kwestionariusz",
        "description": "Kwestionariusz",
        "name": "Kwestionariusz"
      },
      "document_types": {
        "title": "Rodzaje dokumentów",
        "description": "Rodzaje dokumentów",
        "name": "Rodzaje dokumentów"
      },
      "document_type_details": {
        "title": "Rodzaj dokumentu",
        "description": "Rodzaj dokumentu",
        "name": "Rodzaj dokumentu"
      },
      "templates": {
        "title": "Szablony",
        "description": "Szablony",
        "name": "Szablony"
      },
      "cms_elements": {
        "title": "Elementy CMS",
        "description": "Elementy CMS",
        "name": "Elementy CMS"
      },
      "cms_element_details": {
        "title": "Element CMS",
        "description": "Element CMS",
        "name": "Element CMS"
      },
      "brands": {
        "title": "Marki",
        "description": "Marki",
        "name": "Marki"
      },
      "models": {
        "title": "Modele",
        "description": "Modele",
        "name": "Modele"
      },
      "categories": {
        "title": "Kategorie",
        "description": "Kategorie",
        "name": "Kategorie"
      },
      "category_details": {
        "title": "Kategoria",
        "description": "Kategoria",
        "name": "Kategoria",
        "authorization_on_mobile_device": "Autoryzacja na urządzeniach mobilnych",
        "hide_category": "Ukryj kategorię"
      },
      "attributes": {
        "title": "Atrybuty",
        "description": "Atrybuty",
        "name": "Atrybuty"
      },
      "attribute_details": {
        "title": "Atrybut",
        "description": "Atrybut",
        "name": "Atrybut"
      },
      "attribute_groups": {
        "title": "Grupy atrybutów",
        "description": "Grupy atrybutów",
        "name": "Grupy atrybutów"
      },
      "dynamic_data_definitions": {
        "title": "Dynamiczne definicje danych",
        "description": "Dynamiczne definicje danych",
        "name": "Dynamiczne definicje danych"
      },
      "pipelines": {
        "title": "Rurociągi",
        "description": "Rurociągi",
        "name": "Rurociągi"
      },
      "pipeline_details": {
        "title": "Rurociąg",
        "description": "Rurociąg",
        "name": "Rurociąg"
      },
      "items": {
        "title": "Produkty",
        "description": "Produkty",
        "name": "Produkty"
      },
      "item_details": {
        "title": "Produkt",
        "description": "Produkt",
        "name": "Produkt"
      },
      "calendar": {
        "title": "Kalendarz",
        "description": "Kalendarz",
        "name": "Kalendarz"
      },
      "orders": {
        "title": "Zamówienia",
        "description": "Zamówienia",
        "name": "Zamówienia"
      },
      "settings": {
        "title": "Ustawienia",
        "description": "Ustawienia",
        "name": "Ustawienia"
      },
      "four_zero_four": {
        "title": "404",
        "description": "404",
        "name": "404"
      },
      "account": {
        "title": "Konto",
        "description": "Konto",
        "name": "Konto"
      },
      "forgot_password": {
        "linktext": "Zapomniałeś hasła?",
        "title": "Zapomniane hasło",
        "description": "Zapomniane hasło",
        "name": "Zapomniane hasło"
      },
      "renew_password": {
        "title": "Odnów hasło",
        "description": "Odnów hasło",
        "name": "Odnów hasło"
      },
      "new_password_after_reset": {
        "title": "Nowe hasło po resecie",
        "description": "Nowe hasło po resecie",
        "name": "Nowe hasło po resecie"
      },
      "pricing": {
        "title": "Ceny",
        "description": "Ceny",
        "name": "Ceny"
      },
      "signedup": {
        "title": "Zarejestrowany",
        "description": "Zarejestrowany",
        "name": "Zarejestrowany"
      },
      "go_pro": {
        "title": "Go pro",
        "description": "Go pro",
        "name": "Go pro"
      },
      "paypal": {
        "title": "Płać za pomocą Paypal",
        "description": "Płać za pomocą Paypal",
        "name": "Płać za pomocą Paypal"
      },
      "lead_catchers": {
        "title": "Łapacze ołowiu",
        "description": "Łapacze ołowiu",
        "name": "Łapacze ołowiu"
      },
      "bills": {
        "title": "Rachunki",
        "description": "Rachunki",
        "name": "Rachunki"
      },
      "integrations": {
        "title": "Integracje",
        "description": "Integracje",
        "name": "Integracje"
      },
      "order_complete": {
        "title": "Zamówienie zrealizowane. Bardzo dziękuję",
        "description": "Zamówienie zrealizowane. Bardzo dziękuję",
        "name": "Zamówienie zrealizowane. Bardzo dziękuję"
      },
      "order_details": {
        "title": "Szczegóły zamówienia",
        "description": "Szczegóły zamówienia",
        "name": "Szczegóły zamówienia"
      },
      "my_company": {
        "title": "Moja firma",
        "description": "Moja firma",
        "name": "Moja firma"
      },
      "white_label_plugins": {
        "title": "Wtyczki typu white label",
        "description": "Wtyczki typu white label",
        "name": "Wtyczki typu white label"
      },
      "plugins": {
        "title": "Wtyczki Creacheck",
        "description": "Wtyczki Creacheck",
        "name": "Wtyczki Creacheck"
      },
      "bill_details": {
        "title": "Szczegóły faktury",
        "description": "Szczegóły faktury",
        "name": "Szczegóły faktury"
      },
      "activate_plugin": {
        "title": "Aktywuj wtyczkę",
        "description": "Aktywuj wtyczkę",
        "name": "Aktywuj wtyczkę"
      },
      "model_groups": {
        "title": "Grupy modeli",
        "description": "Grupy modeli",
        "name": "Grupy modeli"
      },
      "model_group_details": {
        "title": "Szczegóły dotyczące grupy modeli",
        "description": "Szczegóły dotyczące grupy modeli",
        "name": "Szczegóły dotyczące grupy modeli"
      },
      "model_assets": {
        "title": "Obrazy modeli",
        "description": "Obrazy modeli",
        "name": "Obrazy modeli"
      },
      "model_asset_details": {
        "title": "Model Szczegóły obrazu",
        "description": "Model Szczegóły obrazu",
        "name": "Model Szczegóły obrazu"
      },
      "lead_per_mail_rules": {
        "title": "Zasady Lead by email",
        "description": "Zasady Lead by email",
        "name": "Zasady Lead by email"
      },
      "car_rental": {
        "title": "Bezpieczna i szybka rezerwacja w {miejscu}. {count} samochody do wyboru",
        "description": "Zarezerwuj swój samochód szybko i bezpiecznie. Uwierz nam, wynajem samochodu jeszcze nigdy nie był tak łatwy i szybki.",
        "name": "Wynajem"
      },
      "failed_refunds": {
        "title": "Nieudane zwroty",
        "description": "Nieudane zwroty",
        "name": "Nieudane zwroty"
      },
      "companySignup": {
        "title": "Rejestracja dla firm",
        "description": "Zarejestruj swoją firmę i korzystaj z najnowszego ekosystemu dla dealerów samochodowych",
        "name": "Rejestracja dla firm"
      },
      "price_negotiations": {
        "title": "Negocjacje cenowe",
        "description": "Negocjacje cenowe",
        "name": "Negocjacje cenowe"
      },
      "price_negotiation_details": {
        "title": "Negocjacje cenowe",
        "description": "Negocjacje cenowe",
        "name": "Negocjacje cenowe"
      },
      "communities": {
        "title": "Lista społeczności",
        "description": "Lista społeczności",
        "name": "Lista społeczności"
      },
      "car_service_locations": {
        "title": "Lokalizacje, w których można umówić się na wizytę w serwisie",
        "description": "Lokalizacje",
        "name": "Lokalizacje"
      },
      "car_service_resources": {
        "title": "Wybierz doradcę serwisowego",
        "description": "Konsultant ds. usług",
        "name": "Konsultant ds. usług"
      },
      "car_service_free_slots": {
        "title": "Wybierz wolny przedział czasowy do zaparkowania samochodu",
        "description": "Przedział czasowy",
        "name": "Przedział czasowy"
      },
      "car_service_client_data": {
        "title": "Zaloguj się lub zarejestruj, aby zarezerwować wizytę",
        "description": "Login",
        "name": "Login"
      },
      "car_service_car_data": {
        "title": "Wprowadź dane pojazdu, aby zarezerwować usługę",
        "description": "Dane pojazdu",
        "name": "Dane pojazdu"
      },
      "car_service_summary": {
        "title": "Ostatni krok - Sprawdź swoje dane i wybór",
        "description": "Sprawdź",
        "name": "Sprawdź"
      },
      "car_services": {
        "title": "Usługi warsztatowe",
        "description": "Usługi",
        "name": "Usługi"
      },
      "car_service_stations": {
        "title": "Stanowiska warsztatowe",
        "description": "Stacje robocze",
        "name": "Stacje robocze"
      },
      "document_templates": {
        "title": "Szablony dokumentów",
        "description": "Szablony dokumentów",
        "name": "Szablony dokumentów"
      },
      "document_template_details": {
        "title": "Szablon dokumentu",
        "description": "Szablon dokumentu",
        "name": "Szablon dokumentu"
      },
      "provisionServiceDocuments": {
        "title": "Komisje"
      },
      "commissionServiceDocuments": {
        "title": "Dokumenty Komisji"
      }
    },
    "sort": {
      "relevance": "Znaczenie",
      "username": "Email",
      "lastName": "Nazwisko",
      "cdate": "Najpierw najświeższe",
      "cdateDesc": "Najpierw najświeższe",
      "dueDate": "Termin płatności",
      "fav": "Najpopularniejsze",
      "priceAsc": "Najniższa cena",
      "rentPriceAsc": "Najniższa cena",
      "priceDesc": "Najwyższa cena",
      "rentPriceDesc": "Najwyższa cena",
      "priority": "Priorytet",
      "mdate": "Ostatnia aktualizacja",
      "countryName": "Kraj",
      "vat": "VAT",
      "sumGross": "Kwota"
    },
    "jobTypes": {
      "wedding": "Ślub",
      "family_portrait": "Portret rodzinny",
      "maternity": "Macierzyństwo",
      "newborn": "Noworodek",
      "couple": "Para",
      "pet": "Pet",
      "commercial_advertising": "Komercyjne / reklamowe",
      "fashion": "Moda",
      "model_portfolio": "Wzorcowa teczka",
      "event": "Wydarzenie",
      "headshots": "Strzały w głowę",
      "real_estate_and_architecture": "Nieruchomości i architektura",
      "other": "Inne"
    },
    "pipelineEvent": {
      "afterLeadCreated": "Stworzony zgodnie z prowadzeniem",
      "afterJobAccepted": "przyjęty po pracy",
      "beforeJobScheduled": "przed planowaną pracą",
      "afterJobScheduled": "po wykonaniu planowanej pracy",
      "afterGalleryCreated": "utworzony po galerii",
      "afterPreviousStage": "Po poprzednim etapie"
    },
    "paymentEvents": {
      "beforeJobDate": "przed datą rozpoczęcia pracy",
      "onJobDate": "w dniu pracy",
      "afterJobDate": "według daty pracy",
      "afterInvoiceDate": "Po dacie wystawienia faktury"
    },
    "autocomplete": {
      "placeholder": "Wybierz...",
      "noResultsText": "Nie znaleziono żadnych wyników",
      "loadingPlaceholder": "Sklep"
    },
    "salesDoc": {
      "debtor_number": "Numer klienta",
      "order_number": "Numer zamówienia",
      "order_totals": "Sumy zamówień",
      "quote_from": "Ze strony",
      "quote": "Oferta",
      "quote_for": "Oferta dla",
      "quotes": "Oferty",
      "new_quote": "Nowa oferta",
      "invoice_from": "Ze strony",
      "invoice": "Faktura",
      "tax_invoice": "Faktura",
      "order": "Zamówienie",
      "credit_note": "Nota kredytowa",
      "credit_notes": "Kredyty",
      "invoice_for": "Faktura za",
      "invoices": "Rachunki",
      "new_invoice": "Nowa faktura",
      "cancellation_invoice_to": "Faktura za odstąpienie od umowy dla",
      "cancellation_invoice": "Faktura za anulowanie",
      "to_refunded": "Wciąż do zwrotu:",
      "positions": "Stanowiska",
      "issued": "Wydane",
      "cancelled": "STORNO",
      "billing_period": "Okres rozliczeniowy",
      "pro_rate": "proporcjonalnie",
      "name": "Nazwa",
      "description": "Opis",
      "quantity": "Ilość",
      "unit_price": "Cena jednostkowa",
      "inc_tax": "Podatki wliczone",
      "exc_tax": "Bez podatków",
      "subtotal": "Suma cząstkowa",
      "total": "Kwota ogółem",
      "amount_due": "Suma netto",
      "total_due": "Kwota faktury",
      "target": "Klient",
      "due_date": "W dniu",
      "to_pay": "Jeszcze do zapłaty:",
      "payed": "Płatne",
      "payment": "Płatność",
      "download_csv_ready": "Zakończono eksport CSV",
      "no_vat_eu_country": "Zwolnione z podatku dostawy wewnątrzwspólnotowe wg § 4 nr 1b UstG",
      "no_vat_non_eu_country": "Nieopodatkowana dostawa eksportowa zgodnie z § 6 UstG",
      "invoice_date": "Data faktury",
      "thanks_for_order": "Dziękujemy za złożone zamówienie. O ile nie zaznaczono inaczej, realizacja powyższych usług nastąpi w dniu wystawienia niniejszej faktury.",
      "bill_by_date": "Prosimy o przelanie kwoty, podając numer faktury, na poniższe konto do dnia %data%:",
      "intended_use": "Przeznaczenie",
      "paid_with_cash_cc": "Faktura została opłacona gotówką / kartą EC",
      "amount_from_credit_card": "Kwota %amount% zostanie pobrana z Twojej karty kredytowej.",
      "amount_from_paypal": "Kwota %amount% zostanie pobrana z Twojej paypal.",
      "debit_from_account": "Kwota %amount% zostanie pobrana z Twojego konta.",
      "register_and_taxes": "Rejestr handlowy i podatki",
      "managing_director": "Dyrektor Zarządzający"
    },
    "paymentStatus": {
      "late": "Późno",
      "paid": "Płatne",
      "unpaid": "Nieopłacone",
      "inProgress": "W trakcie realizacji"
    },
    "shopItem": {
      "plus_shipping": "plus koszty wysyłki",
      "variants_possible": "Istnieje kilka możliwości wyboru"
    },
    "sepaAgreement": {
      "sepa_direct_debit_mandate": "Upoważnienie do Polecenia Zapłaty SEPA (Upoważnienie do Polecenia Zapłaty)",
      "mandate_reference": "Odniesienie do mandatu",
      "will_be_communicated_separately": "zostanie przekazany oddzielnie",
      "payee": "Odbiorca",
      "creditor": "Wierzyciel",
      "payer": "Płatne",
      "i_allow_payee_direct_debit": "Niniejszym upoważniam odbiorcę do pobierania płatności z mojego rachunku w formie polecenia zapłaty do czasu odwołania. Jednocześnie instruuję moją instytucję kredytową, aby honorowała polecenia zapłaty zaciągnięte na mój rachunek przez odbiorcę.",
      "note_i_can_claim_reimbursement_within_eight_weeks": "Uwaga: Mogę zażądać zwrotu obciążonej kwoty w ciągu ośmiu tygodni, licząc od daty obciążenia. Obowiązują warunki uzgodnione z moją instytucją kredytową.",
      "document_issued_electronically_and_valid_without_signature": "To pismo zostało stworzone maszynowo i jest ważne również bez podpisu",
      "shortening_notice_period": "Skrócenie okresu wypowiedzenia",
      "deadline_for_advance_information_of_direct_debit_is_shortened_to_one_day": "Termin na wcześniejsze zgłoszenie Polecenia Zapłaty SEPA zostaje skrócony do jednego dnia.",
      "i_issue_sepa_direct_debit_mandate": "Niniejszym udzielam pełnomocnictwa do realizacji polecenia zapłaty SEPA"
    },
    "sad": {
      "offer": "Oferta",
      "modification": "Zmiana",
      "order": "Zamówienie",
      "offers": "Oferty",
      "orders": "Zamówienia",
      "offer_short": "Ang.",
      "order_short": "Najlepsza.",
      "conversion_rate_short": "CR",
      "conversion_rate": "Wskaźnik konwersji",
      "last_offer_date": "Ostatnia oferta",
      "last_offer_date_short": "Last Ang.",
      "car_data": "Dane pojazdu",
      "class": "Klasa",
      "model_name": "Nazwa modelu",
      "model_name_short": "Nazwa modelu (krótka)",
      "model_range": "Seria",
      "body_design": "Kształt ciała",
      "car_color": "Kolor",
      "base_price": "Cena podstawowa",
      "list_price": "Cena katalogowa",
      "optional_equipment": "Wyposażenie specjalne",
      "incl": "incl.",
      "factory_discount": "Osiedle fabryczne",
      "cash_discount": "Rabat gotówkowy",
      "volume_discount": "Rabat ilościowy",
      "transportation_costs": "Koszty przeniesienia",
      "price_reduction": "Obniżenie ceny",
      "car_image": "Obraz pojazdu z konfiguratora",
      "discount": "Estate",
      "sales_price": "Cena sprzedaży",
      "max_speed": "Prędkość maksymalna",
      "car_acceleration": "Przyspieszenie (0 - 100)",
      "online_code": "Kod online",
      "sales_activity": "Działalność handlowa",
      "last_modified": "Ostatnia zmiana",
      "offer_date": "Data oferty",
      "order_date": "Data zamówienia",
      "order_location": "Lokalizacja zamówienia",
      "pre_contract_nr": "V nr zamówienia.",
      "pre_contract_date": "V order dat.",
      "contract_nr": "Nr zamówienia.",
      "shipment_place": "Miejsce dostawy",
      "shipment_key": "Klucz dostawy",
      "special_agreement": "Umowa specjalna",
      "contact_person": "Kontakt",
      "customer_account_number": "Konto dłużnika nr.",
      "financing": "Finansowanie",
      "leasing": "Leasing",
      "financing_product": "Produkt",
      "paid_deposit": "Depozyt",
      "paid_deposit_leasing": "Specjalna opłata leasingowa",
      "credit_amount": "Całkowita kwota pożyczki",
      "monthly_rate": "Stawka miesięczna",
      "contract_duration": "Czas trwania",
      "total_mileage": "Przebieg",
      "purchase_price": "Cena zakupu",
      "annual_percentage_rate": "Efektywna roczna stopa procentowa",
      "nominal_interest_percentage_rate": "Oprocentowanie debetu wiązane p.a.",
      "debit_interest_percentage_rate": "Odsetki nominalne p.a.",
      "total_amount": "Kwota ogółem",
      "final_instalment": "Ostatnia rata",
      "application_date": "Data zastosowania",
      "application_approval_date": "Data zatwierdzenia",
      "application_rejection_date": "Data odrzucenia",
      "client_private": "Prywatny",
      "client_business": "Handlowy",
      "monthly_leasing_rate": "Miesięczna stawka leasingowa",
      "monthly_financing_rate": "Miesięczna stopa finansowania",
      "monthly_insurance_rate": "Miesięczna składka na ubezpieczenie pojazdów mechanicznych",
      "no_winleas_data_available": "Brak dostępnych danych WinLEAS",
      "winleas_data_available": "Dane dotyczące finansowania (F) i / lub leasingu (L) dostępne w systemie WinLEAS",
      "discount_cash": "Kasa",
      "discount_volume": "Ilość / rabat dla przetwórcy",
      "discount_environmental": "Premia środowiskowa",
      "discount_additional": "Warunki dodatkowe",
      "deduction": "Rabat",
      "deduction_mbl": "Tee MBL",
      "deduction_mbl_interest": "Dyskonto odsetkowe MBL",
      "deduction_consultant": "Doradca trójki",
      "deduction_consultant_interest": "Stopa procentowa doradca dyskontowy",
      "commission": "Komisja",
      "commission_standard": "Standard",
      "commission_addition_deduction": "Góra / Dół",
      "commission_subsequent_scope_of_supply": "Więcej. Zakres dostawy",
      "commission_total": "Razem",
      "subsidy": "Dotacja",
      "subsidy_contract_partner": "Wiceprezes ds. dotacji",
      "subsidy_factory": "Fabryka subsydiów",
      "subsidy_mbvd": "Dotacja MBVD",
      "shortcut_lp_kp": "LP/KP",
      "campaign": "Działanie",
      "service_rate": "Stawka za usługę",
      "residual_value": "Wartość rezydualna",
      "table_residual_value": "Pozostała wartość tabeli",
      "residual_value_change": "Zmiana wartości rezydualnej",
      "ref": "Odnośnie",
      "net": "netto",
      "gross": "brutto",
      "list_price_short": "LP",
      "sales_price_short": "KP",
      "note_save": "Zapisz notatkę",
      "notes": "Uwagi",
      "salesman": "Sprzedawca",
      "salesman_blacklist": "Sprzedawca (czarna lista)",
      "salesman_number": "Nr sprzed.",
      "salesman_number_short": "Nie.",
      "enterprise_number": "Nr operacyjny.",
      "Mercedes": "Mercdes",
      "Smart": "Smart",
      "equipment_line": "Linia",
      "packages": "Pakiety",
      "upholstery": "Poduszka",
      "single_equipments": "Inne",
      "included_in": "zawarty w",
      "store": "Oddział",
      "save_filterset": "Zapisz zestaw filtrów",
      "internal_activity": "Działalność wewnętrzna",
      "offer_made": "Oferta stworzona",
      "in_progress": "W trakcie realizacji",
      "predecessor_offer": "Oferta poprzednika / duplikat",
      "lost": "Utracona działalność",
      "ordered": "Zlecenie wykonane",
      "canceled": "Zamówienie anulowane"
    },
    "rad": {
      "earnings": "Wydajność",
      "occupancy_rate": "Wykorzystanie mocy produkcyjnych",
      "amount": "Kwota"
    },
    "external_account_status": {
      "login_fail": "Proszę sprawdzić dane dostępowe! W przeciwnym razie nie można odczytać więcej danych.",
      "login_warning": "Proszę sprawdzić dane dostępowe!",
      "login_valid": "Dostęp do danych prawidłowy",
      "last_successful_login": "Ostatnie udane logowanie"
    },
    "initialize": "Init",
    "customer": "Firma",
    "customer_": "Klient",
    "select_mandant": "Wybierz klienta",
    "initial_title": "Tytuł początkowy nośnika reklamy",
    "will_be_shown_to_the_user_in_frontend": "Jest wyświetlany użytkownikowi w frontend",
    "producttemplate_data_saved": "Zapisane dane szablonu",
    "product_size": "Format/wielkość produktu",
    "template_upload_files": "Wybierz plik(i) do przesłania",
    "example_of_product_size": "np: DIN A4, DIN long...",
    "output_format": "Format wyjściowy",
    "product_size_width": "Szerokość w pikselach",
    "product_size_height": "Wysokość w pikselach",
    "template_folder": "Ścieżka szablonu",
    "template_dpi": "DPI dla wyjścia",
    "template_upload": "Prześlij",
    "template_pageSpace": "Przestrzenie kratowe",
    "output_exportType": "Typ wyjścia",
    "template_fonts": "Czcionki",
    "template_fontSizeMin": "Wielkość czcionki min.",
    "template_styles": "Dane CSS & LESS",
    "template_fontSizeMax": "Wielkość czcionki max.",
    "template_init_amount_of_pages": "Liczba stron początkowych",
    "template_page_add_increase": "Seitensprung",
    "template_pageMaxAmount": "Liczba stron max.",
    "template_pageMinAmount": "Liczba stron min.",
    "template_pageTop": "Wyściełanie górne",
    "template_pageBottom": "Wyściełane dno",
    "template_pageFirst": "Numer strony Strona tytułowa",
    "template_pageFirstFixed": "Poprawiono stronę tytułową",
    "template_pageLast": "Numer strony Ostatnia strona",
    "template_pageLastFixed": "Ostatnia strona poprawiona",
    "template_endless": "Niekończąca się strona",
    "template_fixed": "Strona naprawiona",
    "template_sample_page": "Numer strony Treść standardowa",
    "font_colors": "Kolory tekstu",
    "back_colors": "Kolory tła",
    "client_logo": "Logo firmy",
    "template_pageNumber": "Numer strony",
    "page_names": "Ustawienia strony",
    "add_contentBlock": "Dodaj blok treści",
    "css": "Ogólne CSS",
    "cssPDF": "CSS tylko dla wyjścia PDF",
    "cssPrintPDF": "CSS tylko dla wydruków PDF",
    "cssWebsite": "CSS dla wyjścia jako strona internetowa",
    "chosenItem": "Aktualny wybór produktów",
    "pdf_price": "Cena PDF",
    "auflagen": "Cyrkulacja",
    "print_prices": "Ceny podstawowe",
    "proof_base_price": "Sprawdzenie podstawowych danych dotyczących cen",
    "new_proof_base_price": "Sprawdzenie nowych danych dotyczących ceny bazowej",
    "get_vendor_price": "Uzyskać ceny",
    "add_variant_line": "Dodaj linię",
    "get_vendor_prices": "Cena - zadzwoń do dostawcy",
    "get_vendor_id": "Zapytanie o ID produktu dostawcy",
    "no_vendor_id": "Brak ustawionego ID produktu dostawcy!",
    "cc_item_id": "ID produktu CreaCheck",
    "vendor_item_id": "Identyfikator produktu Dostawca",
    "vendor_item_name": "Nazwa produktu Dostawca",
    "vendor_item_missing_attributes": "Nie można znaleźć ceny dla tej kombinacji atrybutów.",
    "vendor_item_save_attributes": "Proszę wybrać atrybuty!",
    "vendor": "Dostawca",
    "internal_item_id": "Identyfikator wewnętrzny",
    "select_vendor_product": "Wybierz grupę produktów",
    "item_type": "Rodzaj produktu",
    "print_item": "Produkt do druku",
    "website_item": "Strona internetowa",
    "normal_item": "Inny produkt",
    "not_more_pages": "Nie można utworzyć więcej nazw stron niż wynosi liczba możliwych stron!",
    "info_title_page": "Strony tytułowej nie można przenieść ani usunąć",
    "info_last_page": "Ostatniej strony nie można przenieść ani usunąć",
    "page_definition_page_count_info": "Numer strony 0 = wartość domyślna dla wszystkich stron bez definicji, ostatnia dla ostatniej strony",
    "padding_on_top": "Odstęp górny",
    "padding_on_bottom": "Odstęp poniżej",
    "padding_on_left": "Odstęp w lewo",
    "padding_on_right": "Rozstawienie w prawo",
    "delimitation_of_grid_blocks": "Bloki rastrowe mogą być dodawane bez ograniczeń. Strona staje się wtedy coraz dłuższa.",
    "fixed_page": "Strona jest stała i nie można jej przenieść.",
    "page_definition": "Definicja strony",
    "add_definition": "Dodaj definicję",
    "page_default_value": "Numer strony 0 = wartość domyślna dla wszystkich stron bez definicji",
    "page_count": "Liczba stron",
    "page_widths": "Szerokości boczne",
    "page_heights": "Wysokości boczne",
    "no_special_formatting": "Brak specjalnego formatowania",
    "min_max_font_size": "Min-/Max-FontSize",
    "activate_min_max_font_size": "Włącz lub wyłącz Min-/Max-FontSize",
    "filename": "Nazwa pliku",
    "for_user": "Dla użytkowników",
    "user_can_use_font": "Użytkownik może używać tej czcionki w edytorze",
    "import_successful": "Import zakończony, spójrz na pozostałe zakładki",
    "import_resets_template": "Import resetuje szablon, musi on zostać ponownie zainicjowany, wszystkie istniejące edycje klienta z tym szablonem stają się bezużyteczne!",
    "problem": "Wystąpił problem",
    "reading_pages": "Strony do czytania",
    "done": "Gotowe",
    "versions": "Wersje",
    "template_not_edited": "Ten szablon nie był jeszcze edytowany.",
    "dataProof_infoText": "W ramach ręcznej kontroli danych nasi eksperci sprawdzają dla Państwa wszystkie kryteria techniczne etapu przygotowania do druku. Należą do nich: możliwość druku, zgodność ze wszystkimi specyfikacjami technicznymi oraz subiektywny efekt kolorystyczny. Bardziej szczegółowe informacje na temat sprawdzania danych można znaleźć w dziale FAQ.",
    "media_library": "Biblioteka multimediów",
    "count": "Numer",
    "welcome_message": "Witaj, {name}",
    "email": "Email",
    "website": "Strona internetowa",
    "phone": "Telefon",
    "fax": "Fax",
    "password": "Hasło",
    "repeat_password": "Powtórzenie hasła",
    "company": "Firma",
    "companies": "Firmy",
    "first_name": "Imię i nazwisko",
    "last_name": "Nazwisko",
    "street": "Ulica",
    "house_number": "Numer domu",
    "apartment_number": "Numer mieszkania",
    "zip_code": "Kod pocztowy",
    "city": "Miasto",
    "country": "Kraj",
    "currency": "Waluta",
    "previous_year": "Poprzedni rok",
    "vat_name": "Nazwa VAT",
    "vat_id_name": "Numer identyfikacyjny VAT Nazwa",
    "vat_id": "NIP",
    "vat_rates": "Stawki VAT",
    "coc_number": "Numer COC",
    "registered_at": "Zarejestrowany w",
    "page": "Strona",
    "page_of": "z",
    "save": "Zapisz",
    "save_and_email": "Zapisz i wyślij pocztą elektroniczną",
    "add": "Dodaj",
    "add_client": "Dodaj firmę",
    "add_user": "Dodaj użytkownika",
    "add_product": "Dodaj produkt",
    "add_producttemplate": "Dodaj szablon",
    "add_question": "Dodaj pytanie",
    "add_option": "Dodaj opcję",
    "add_questionnaire": "Dodaj kwestionariusz",
    "add_template": "Dodaj szablon",
    "add_position": "Dodaj pozycję",
    "add_pipeline": "Dodaj rurociąg",
    "add_quote": "Dodaj ofertę",
    "add_invoice": "Dodaj fakturę",
    "add_stage": "Dodać scenę",
    "add_gallery": "Dodaj galerię",
    "add_job": "Dodaj pracę",
    "add_payment_schedule": "Dodaj plan płatności",
    "add_payment": "Dodaj płatność",
    "add_location": "Dodaj lokalizację",
    "add_data_definition": "Dodaj definicję danych",
    "add_car": "Dodaj pojazd",
    "add_document": "Dodaj dokument",
    "add_document_type": "Dodaj typ dokumentu",
    "add_team": "Dodaj zespół",
    "add_brand": "Dodaj markę",
    "add_model": "Dodaj model",
    "add_model_group": "Dodaj grupę modeli",
    "add_model_asset": "Dodaj obraz modelu",
    "add_category": "Dodaj kategorię",
    "add_attribute": "Dodać nieruchomość",
    "add_attribute_group": "Dodaj grupę atrybutów",
    "add_value": "Dodaj wartość",
    "add_variant": "Dodaj wariant",
    "add_lead": "Dodaj ołów",
    "add_task": "Dodaj zadanie",
    "add_page": "Dodaj stronę",
    "add_data_push": "Dodaj dane pchające",
    "add_white_label": "Dodaj projekt white label",
    "add_menu_element": "Dodaj pozycję menu",
    "add_secondary_menu_element": "Dodaj drugorzędną pozycję menu",
    "add_cms_element": "Dodaj element CMS",
    "add_lead_catcher": "Dodaj ołowianego łapacza",
    "add_white_label_plugin": "Dodaj wtyczkę White Label",
    "add_lead_per_mail_rule": "Dodaj regułę \"lead by email",
    "add_message": "Dodaj wiadomość",
    "add_car_service": "Dodaj usługę",
    "add_car_service_station": "Dodaj stanowisko pracy",
    "add_team_member": "Dodaj członka zespołu",
    "add_document_template": "Dodaj szablon dokumentu",
    "add_lead_autoresponse": "Dodaj Lead Autoresponse",
    "add_main_menu_version": "Dodaj wersję menu głównego",
    "add_lead_tagger": "Dodaj Lead Tagger",
    "add_lead_assignment_strategy": "Dodaj strategię przydziału",
    "add_escalation_rule": "Dodaj regułę eskalacji",
    "add_coupon": "Dodaj voucher",
    "add_company": "Dodaj firmę",
    "add_item": "Dodaj produkt",
    "add_manual_entry": "Dodaj ręczne wprowadzanie danych",
    "send_message": "Wyślij wiadomość",
    "send": "Wyślij",
    "details": "Szczegóły",
    "delete": "Usuń",
    "or": "lub",
    "actions": "Działania",
    "client": "Firma",
    "job": "Praca",
    "active_jobs": "Aktywne miejsca pracy",
    "questionnaire": "Kwestionariusz",
    "review_and_send": "Sprawdź i wyślij",
    "download": "Pobierz",
    "duplicate": "Duplikat",
    "client_name": "Nazwa",
    "address": "Adres",
    "title": "Tytuł",
    "uploading": "Prześlij",
    "status": "Status",
    "next_stage": "Następny etap",
    "type": "Typ",
    "schedule": "Plan lekcji",
    "location": "Lokalizacja",
    "sent_on": "Wysłane w dniu",
    "name": "Nazwa",
    "description": "Opis",
    "bill_number": "Numer faktury",
    "quote_number": "Numer oferty",
    "do_sort": "Sortuj",
    "date": "Data",
    "gallery": "Galeria",
    "questionnaires": "Kwestionariusze",
    "job_takes_whole_day": "Ta praca zajmuje cały dzień",
    "from": "Ze strony",
    "to": "Do",
    "question": "Pytanie",
    "subject": "Temat",
    "content": "Treść",
    "template": "Szablon",
    "stage_has_due_date": "Ten poziom ma termin płatności",
    "stage_sends_automated_email": "Ten etap wysyła automatyczną wiadomość e-mail",
    "day": "Dzień",
    "days": "Dni",
    "hours": "Godziny",
    "review": "Sprawdź",
    "timezone": "Strefa czasowa",
    "client_since": "Firma dodana na",
    "user_since": "Użytkownik od",
    "payment_instructions": "Przekazy pieniężne",
    "bank_name": "Nazwa banku",
    "debtor_number": "Dłużnik-Id",
    "account_holder": "Posiadacz rachunku",
    "account_number": "Numer rachunku",
    "bank_location": "Lokalizacja banku",
    "bank_code_number": "Kod banku",
    "iban": "IBAN",
    "swift_bic": "SWIFT/BIC",
    "company_logo": "Logo firmy",
    "percent_of_order": "Procentowy udział w zamówieniu",
    "percent_of_remaining_balance": "Procent salda",
    "amount": "Kwota",
    "due": "Due",
    "payment_schedule": "Plan płatności",
    "record_payment": "Płatność za dziennik",
    "mark_as_unpaid": "Oznaczenie jako nieopłacone",
    "close": "Zamknij",
    "yes": "Tak",
    "want_to_mark_the_payment_as_paid": "Czy naprawdę chcesz oznaczyć tę płatność jako zapłaconą?",
    "want_to_mark_the_payment_as_unpaid": "Czy naprawdę chcesz oznaczyć tę płatność jako niezapłaconą?",
    "payment_marked_as_paid": "Płatność zarejestrowana",
    "payment_marked_as_unpaid": "Płatność oznaczona jako niezapłacona",
    "overdue_payments": "Zaległe płatności",
    "next_payment": "Następna wypłata",
    "quote_accepted": "Oferta przyjęta",
    "quote_rejected": "Oferta odrzucona",
    "todays_tasks": "Dzisiejsze zadania",
    "overdue_tasks": "Zadania zaległe",
    "overdue_and_upcoming_payments": "Zaległe i nadchodzące płatności",
    "jobs_in_progress": "Prace w toku",
    "appointments": "Daty",
    "appointment": "Powołanie",
    "last_update": "Ostatnia aktualizacja",
    "mark_as_completed": "Oznaczenie jako zakończone",
    "want_to_mark_stage_complete": "Czy chcesz oznaczyć etap jako zakończony?",
    "stage_marked_complete": "Etap oznaczony jako zakończony",
    "gallery_download": "Pobierz obraz",
    "gallery_sharing": "Udostępnij galerię",
    "gallery_social_media": "Zdjęcia w mediach społecznościowych",
    "preview": "Podgląd",
    "invoice_preview": "Podgląd faktury",
    "preview_pdf": "Podgląd PDF",
    "message": "Wiadomość",
    "signup": "Zarejestruj się",
    "continue": "Kontynuuj",
    "password_assistance": "Pomoc dotycząca hasła",
    "password_renewing": "Nowe hasło",
    "not_any_user_information": "Brak informacji o użytkowniku.",
    "failed_redirection": "Przekazywanie nie powiodło się.",
    "renew_password": "Zanim będziesz mógł się zalogować, musisz ustawić nowe hasło. Właśnie wysłaliśmy do Ciebie maila z instrukcją.",
    "get_new_password": "Poproś o nowe hasło",
    "set_new_password": "Ustaw nowe hasło",
    "forgot_password": {
      "infotext": "Jeśli nie pamiętasz swojego hasła, możesz je zresetować tutaj. Prosimy o wpisanie w poniższym formularzu swojego zarejestrowanego adresu e-mail i kliknięcie \"Kontynuuj\". Następnie wyślemy Ci e-mail z dalszymi informacjami.",
      "infotext_robethood": "Jeśli nie pamiętasz swojego hasła, możesz je zresetować tutaj. Proszę wpisać swój zarejestrowany adres e-mail w poniższym formularzu i kliknąć \"Kontynuuj\". Następnie wyślemy Ci wiadomość e-mail z dalszymi informacjami.",
      "info_email_not_used": "Jeśli nie używasz już adresu e-mail związanego z Twoim kontem Creacheck, skontaktuj się z nami poprzez nasz formularz kontaktowy: {link}.",
      "info_email_not_used_robethood": "Jeśli nie używasz już adresu e-mail powiązanego z Twoim kontem, skontaktuj się z nami za pośrednictwem naszego formularza kontaktowego: {link}.",
      "enter_new_password": "Przed Tobą tylko ten krok, aby zalogować się do Creacheck. Wystarczy dwukrotnie wpisać nowe hasło. To takie proste."
    },
    "thanks_for_signing_up": "Dzięki za rejestrację",
    "confirm_your_email": "Potwierdź swój adres e-mail",
    "signed_up_gratulations": "Witamy w CreaCheck. Aby zakończyć proces rejestracji, wysłaliśmy do Ciebie wiadomość e-mail. Proszę o potwierdzenie rejestracji.",
    "signed_up_gratulations_robethood": "Witamy na naszej stronie internetowej. Wysłaliśmy Ci wiadomość e-mail w celu zakończenia procesu rejestracji. Proszę o potwierdzenie rejestracji.",
    "check_email_for_message_from_us": "Proszę sprawdzić swoją skrzynkę mailową.",
    "check_email_for_message_from_us_robethood": "Proszę sprawdzić swoją skrzynkę mailową",
    "new_clients": "Nowi klienci",
    "users": "Użytkownik",
    "user": "Użytkownik",
    "won_from_count_leads": "Won z {count} prowadzi.",
    "deals_won_out_of_count": "Deals won by {count}",
    "new_badge": "Nowy",
    "answer_badge": "Odpowiedź",
    "accept": "Przyjmij",
    "reject": "Spadek",
    "quote_rejected_on_date": "Oferta odrzucona w dniu {data}",
    "quote_accepted_on_date": "Oferta przyjęta w dniu {data}",
    "want_to_accept_the_quote": "Czy chcesz przyjąć ofertę? Wykonawca zostanie bezpośrednio poinformowany o Państwa decyzji.",
    "want_to_reject_the_quote": "Czy chcesz odrzucić ofertę? Wykonawca zostanie bezpośrednio poinformowany o Państwa decyzji.",
    "want_to_convert_quote_to_invoice": "Czy chciałbyś zamienić tę ofertę na fakturę?",
    "convert_quote_to_invoice": "Konwersja oferty na fakturę",
    "convert_to_invoice": "Konwersja do faktury",
    "convert_quote_from_template": "Konwersja oferty do innego szablonu",
    "completed_on_date": "Zakończono w dniu {data}",
    "due_date_on_date": "Due date {data}",
    "due_date": "Termin płatności",
    "current_stages_due_date": "Termin zakończenia bieżącego etapu",
    "go_pro": "Go Pro",
    "recent_activity": "Ostatnia aktywność",
    "load_more": "Załaduj więcej",
    "your_galleries": "Twoje galerie",
    "unread_by_you": "Nieprzeczytane przez ciebie",
    "count_images": "{count} obrazy",
    "view": "Zobacz",
    "filled_out_on": "Zakończono w dniu",
    "filled_out_by": "Wypełnione z",
    "you_answered_the_questionnaire_on_date": "Odpowiedziałeś na kwestionariusz w dniu {data}.",
    "company_sent_a_questionnaire": "{firma} wysłała kwestionariusz i prosi o odpowiedzi",
    "allow_to_download_full_res": "Umożliwić klientowi pobranie zdjęć w pełnej rozdzielczości",
    "allow_to_share_with_friends": "Umożliwić klientowi dzielenie się galerią z przyjaciółmi",
    "allow_to_share_on_social_media": "Umożliwić klientowi udostępnianie zdjęć za pośrednictwem mediów społecznościowych",
    "got_it": "OK",
    "learn_more": "Dowiedz się więcej",
    "this_website_uses_cookies": "Nasza strona używa plików cookie, aby zapewnić Ci najlepsze doświadczenia na naszej stronie.",
    "are_you_sure": "Jesteś pewien?",
    "no": "Nie",
    "closed_please_add_timeframe": "<span><span className='text-danger semi-bold'>Zamknięte</span> - proszę o dodanie przedziału czasowego</span>.",
    "not_active_please_add_timeframe": "<span><span className='text-danger semi-bold'>Nieaktywne</span> - proszę dodać ramy czasowe</span>.",
    "note": "Uwaga",
    "change_password": "Zmiana hasła",
    "roles": "Ceny",
    "active_set": "Aktualna prenumerata",
    "infos": "Informacje",
    "documents": "Dokumenty",
    "document": "Dokument",
    "financial": "Finansowy",
    "bookingAccountNumber": "Konto pocztowe",
    "costAccountNumber": "Centrum kosztów",
    "locations": "Lokalizacje",
    "white_label": "Biała etykieta",
    "show_password_text": "Pokaż tekst hasła",
    "parent": "Rodzic",
    "change_parent": "Zmiana Rodzica",
    "cancel": "Anuluj",
    "timeline_undo": "Undo",
    "confirm_action_ramifications": "Proszę potwierdzić, że rozumie Pan/Pani konsekwencje swojego działania",
    "client_will_not_be_visible_in_search_results": "Wybrany klient nie jest już widoczny w wyszukiwaniu klientów",
    "changing_parent_takes_a_while": "Zmiana prekursora może zająć trochę czasu",
    "load_message_from_template": "Załaduj wiadomość z szablonu",
    "questions": "Pytania",
    "search": "Szukaj",
    "search_for": "Szukaj",
    "dynamic_data_definitions": "Dynamiczne definicje danych",
    "dynamic_data_definition": "Dynamiczne definiowanie danych",
    "data_identifier": "Identyfikator danych",
    "cars": "Pojazdy",
    "rentals": "Wynajem",
    "no_car_available": "Brak dostępnego samochodu",
    "file": "Plik",
    "files": "Pliki",
    "teams": "Zespoły",
    "team": "Zespół",
    "document_types": "Rodzaje dokumentów",
    "document_type": "Rodzaj dokumentu",
    "system_type": "Typ systemu",
    "brands": "Marki",
    "models": "Modele",
    "model": "Model",
    "model_groups": "Grupy modeli",
    "model_group": "Grupa modelowa",
    "model_assets": "Obrazy modeli",
    "model_asset": "Obraz modelu",
    "categories": "Kategorie",
    "attributes": "Atrybuty",
    "attribute": "Atrybut",
    "values": "Wartości",
    "value": "Wartość",
    "select_category": "Wybierz kategorię",
    "position": "Pozycja",
    "color": "Kolor",
    "car": "Produkt",
    "category": "Kategoria",
    "brand": "Marka",
    "required": "Pole obowiązkowe",
    "multilanguage": "Wiele języków",
    "seo": "SEO",
    "page_title": "Tytuł strony",
    "keywords": "Słowa kluczowe",
    "item": "Artykuł",
    "sku": "SKU",
    "variants": "Warianty",
    "variant": "Wariant",
    "price": "Cena",
    "prices": "Ceny",
    "variant_attributes": "Atrybuty wariantu",
    "no_value_set": "Brak ustawionej wartości",
    "identification": "Identyfikacja",
    "templates": "Szablony",
    "vin": "FIN",
    "leads": "Leady",
    "lead": "Lead",
    "order_it": "Zamówienie",
    "order": "Zamówienie",
    "orders": "Zamówienia",
    "images": "Zdjęcia",
    "image": "Obraz",
    "upc": "UPC",
    "visibility": "Widoczność",
    "show_item_online": "Produkt widoczny w Internecie",
    "use_as_resource": "Wykorzystanie jako źródło",
    "stock_and_prices": "Zapasy i ceny",
    "sales_price": "Cena sprzedaży",
    "sales_point": "Dystrybucja",
    "warehouse": "Obóz",
    "stock_level": "Zapasy",
    "rent_price": "Cena wynajmu",
    "pseudo_price": "Pseudo cena",
    "express_price": "Cena ekspresowa",
    "overnight_price": "Cena za nocleg",
    "sameday_price": "Cena jednodniowa",
    "basic_price": "Cena podstawowa",
    "weekday_price": "Cena tygodniowa",
    "weekend_price": "Cena weekendowa",
    "week_price": "Cena tygodniowa",
    "month_price": "Cena miesięczna",
    "unit_of_measure": "Jednostka miary",
    "basic_unit": "Jednostka podstawowa",
    "packaging_unit": "Jednostka opakowania",
    "subscribe": "Subskrybuj",
    "all": "Wszystkie",
    "pipeline": "Rurociąg",
    "pipelines": "Rurociągi",
    "default_team": "Zespół standardowy",
    "select_pipeline": "Wybierz rurociąg",
    "please_select_pipeline_first": "Proszę najpierw wybrać rurociąg",
    "view_type": "Zobacz",
    "stage": "Poziom",
    "stages": "Kroki",
    "properties": "Właściwości",
    "unassigned": "Bez przydziału",
    "assignee": "Redaktor",
    "order_type": "Rodzaj zamówienia",
    "internal_comment": "Komentarz wewnętrzny",
    "comments": "Uwagi",
    "comment": "Komentarz",
    "no_comments_yet": "Nie ma jeszcze żadnych komentarzy",
    "show_all_comments": "Pokaż wszystkie komentarze",
    "people": "Ludzie",
    "watchers": "Obserwator",
    "dates": "Daty",
    "date_created": "Utworzony",
    "date_updated": "Aktualizacja",
    "closed": "Zamknięte",
    "start_watching_lead": "Zacznij oglądać ten trop",
    "stop_watching_lead": "Przestańcie oglądać ten trop",
    "no_longer_watching_lead": "Nie obserwujesz już tego tropu",
    "watching_lead": "Obserwujesz ten trop",
    "wrote_comment": "Napisał komentarz",
    "replied_to_comment": "Odpowiedział na komentarz",
    "language": "Język",
    "languages": "Języki",
    "primary_language": "Język główny",
    "secondary_languages": "Języki średnie",
    "won": "Won",
    "lost": "Zaginiony",
    "change_pipeline": "Rurociąg zmian",
    "change_stage": "Poziom zmian",
    "switch_team": "Zespół ds. zmian",
    "open": "Otwórz",
    "budget": "Budżet",
    "always_available": "Zawsze dostępny",
    "default_location": "Standardowa lokalizacja",
    "selected_category_has_no_attributes": "Wybrana kategoria nie ma żadnych atrybutów",
    "car_overview": "Przegląd pojazdów",
    "make_reservation": "Rezerwa",
    "reservation": "Rezerwacja",
    "cms_pages": "Strony",
    "grid_fluid": "Płyn",
    "grid_normal": "Normalna",
    "cms_add_container": "Dodaj pojemnik",
    "cms_add_row": "Dodaj linię",
    "cms_add_element": "Dodaj pozycję",
    "media_files": "Pliki multimedialne",
    "upload": "Prześlij",
    "page_design": "Projekt strony",
    "translations": "Tłumaczenia",
    "translate": "Przetłumacz",
    "category_filters": "Filtr kategorii",
    "attribute_groups": "Grupy atrybutów",
    "select_attribute": "Wybierz atrybut",
    "display": "Obecna",
    "select_multiple": "Wybór wielokrotny",
    "use_null_as_min_val": "Ustawić 0 jako minimum",
    "filter": "Filtr",
    "do_filter": "Filtr",
    "mobile_phone": "Telefon komórkowy",
    "mark_lead_won": "Oznaczyć prowadzenie jako wygrane",
    "mark_lead_lost": "Zaznacz ołów jako zaginiony",
    "mark_lead_deleted": "Oznacz lead jako usunięty",
    "reopen_lead": "Ponownie otworzyć ołów",
    "won_reason": "Powód wygranej",
    "lost_reason": "Powód przegranej",
    "delete_reason": "Powód usunięcia",
    "reopen_reason": "Powód wznowienia działalności",
    "no_reason_specified": "Nie podano przyczyny",
    "lead_marked_won": "Ołów oznaczony wygrał. Gratulacje",
    "lead_marked_lost": "Ołów oznaczony jako utracony",
    "lead_marked_deleted": "Ołów oznaczony jako skreślony",
    "lead_reopened": "Ołów wznowiony",
    "stage_changed": "Zmiana poziomu ołowiu",
    "pipeline_changed": "Zmieniona trasa wiodąca",
    "team_changed": "Lead przypisany do innego zespołu",
    "current_pipeline": "Obecny rurociąg",
    "current_stage": "Obecny poziom",
    "file_extension": "Przedłużenie",
    "file_size": "Rozmiar",
    "file_uploaded": "Załadowane",
    "no_client_assigned": "Brak przypisanego klienta",
    "no_products_assigned": "Brak przypisanych produktów",
    "no_order_assigned": "Brak przydzielonego zlecenia",
    "planned_duration_in_days": "Planowany czas trwania (dni)",
    "lead_budget_must_be_set": "Należy ustalić budżet wiodący",
    "client_must_be_assigned": "Klient musi być przypisany",
    "order_must_be_assigned": "Zamówienie musi zostać przydzielone",
    "product_must_be_assigned": "Produkt musi być przypisany",
    "lead_has_to_have_following_documents": "Lead musi posiadać następujące dokumenty (dokumenty muszą być ważne)",
    "client_has_to_have_following_documents": "Klient musi posiadać następujące dokumenty (dokumenty muszą być ważne)",
    "count_days": "{liczba, mnoga, jeden {# dzień} inne {# dni}}",
    "longer": "Dłuższy",
    "date_from": "Data od",
    "time_from": "Czas od",
    "date_to": "Data do",
    "time_to": "Czas do",
    "rate": "Stawka",
    "car_rental_weekday": "Wynajem - stawka tygodniowa",
    "car_rental_weekend": "Wynajem - stawka weekendowa",
    "car_rental_week": "Wynajem - stawka tygodniowa",
    "car_rental_month": "Czynsz - stawka miesięczna",
    "document_overdue_please_review": "Dokument przeterminowany. Proszę przejrzeć",
    "count_cars": "{liczba, liczba mnoga, jeden {# pojazd} inne {# pojazdy}}",
    "count_products": "{liczba, liczba mnoga, jeden {# produkt} inne {# produkty}}",
    "we_found_count_cars": "Znaleźliśmy {liczba, mnoga, jeden {# pojazd} inne {# pojazdy}",
    "we_found_count_products": "Znaleźliśmy {liczba, liczba mnoga, jeden {# produkt} inne {# produkty}}",
    "delete_all_filters": "Wyczyść wszystkie filtry",
    "image_recognition_tags": "Tagi rozpoznane na podstawie obrazu",
    "username": "Nazwa użytkownika",
    "handover_must_be_performed": "Protokół przekazania pojazdu musi być wypełniony",
    "document_pages": "Strony dokumentu",
    "pages": "Strony",
    "handover": "Przekazanie",
    "mileage": "Przebieg",
    "client_documents": "Dokumenty klienta",
    "lead_documents": "Dokumenty wiodące",
    "fuel_level": "Poziom paliwa",
    "start_editing": "Rozpocznij edycję",
    "design": "Projekt",
    "responsive": "Responsywna",
    "back": "Powrót",
    "use_text_description": "Użyj opisu tekstowego",
    "use_visual_builder": "Użyj wizualnego konstruktora",
    "set_image": "Ustawić obraz",
    "select_image": "Wybierz zdjęcie",
    "uploaded_by_me": "Załadowane przeze mnie",
    "current_item": "Artykuł bieżący",
    "current_page": "Bieżąca strona",
    "difficulties": "Trudności",
    "damages": "Szkody",
    "damage_note": "Zawiadomienie o szkodzie",
    "no_damages_in_protocol": "Brak uszkodzeń w protokole",
    "add_damage": "Dodać uszkodzenia",
    "my_company": "Moja firma",
    "user_administration": "Zarządzanie użytkownikami",
    "client_administration": "Zarządzanie kontaktami",
    "crm_administraion": "Zarządzanie CRM",
    "content_administration": "Zarządzanie treścią",
    "product_administration": "Zarządzanie produktem",
    "producttemplate_administration": "Zarządzanie szablonami",
    "car_service_administration": "Zarządzanie warsztatem",
    "site_administration": "Administracja stronami internetowymi",
    "data_push": "Przesunięcie danych",
    "client_has_no_ancestors": "Klient nie ma przodków",
    "domain": "Domena",
    "entity": "Podmiot",
    "event": "Wydarzenie",
    "endpoint_url": "URL punktu końcowego",
    "authentication": "Uwierzytelnianie",
    "headers": "Nagłówki",
    "none": "Nie",
    "social_media": "Media społecznościowe",
    "style": "Styl",
    "html_header": "Nagłówek HTML",
    "custom_html_header": "Własny nagłówek HTML",
    "css_file_name": "Niestandardowa nazwa pliku CSS",
    "custom_css": "Własny CSS",
    "custom_less": "Custom LESS",
    "custom_css_mail": "Niestandardowy CSS dla e-maili",
    "main_menu": "Menu główne",
    "menu_css_class": "Klasa CSS menu głównego",
    "menu_css_class_scroll": "Klasa CSS menu głównego podczas przewijania",
    "white_label_projects": "Projekty typu white label",
    "imprint": "Nadruk",
    "terms_of_service": "AGB",
    "rental_terms_of_service": "Ogólne warunki wynajmu",
    "car_sales_terms_of_service": "Ogólne warunki sprzedaży pojazdów używanych",
    "item_sales_terms_of_service": "Ogólne warunki sprzedaży produktów",
    "privacy_policy": "Ochrona danych",
    "cancellation_policy": "Polityka anulowania",
    "footer": "Stopka",
    "hide_footer": "Ukryj stopkę",
    "unknown_property": "Nieznany parametr",
    "unknown": "nieznany",
    "price_from": "z",
    "price_to": "do",
    "slider_from": "z",
    "slider_to": "do",
    "within": "w ramach",
    "of": "z",
    "within_count_km_of_place": "w obrębie {liczba} km od {miejsca}",
    "click_to_start_geolocation": "Kliknij tutaj, aby rozpocząć geolokalizację",
    "geolocation_error": "Mieliśmy problem z rozpoznaniem Twojej pozycji lub Twoja pozycja nie jest znana. Proszę wprowadzić swoją pozycję ręcznie.",
    "count_km_from": "km od",
    "car_power": "Power",
    "car_power_unit": "PS",
    "car_gear": "Przekładnia",
    "car_capacity": "Wyporność",
    "car_capacity_unit": "cm³",
    "car_fueltype": "Rodzaj paliwa",
    "car_type": "Typ pojazdu",
    "car_num_previous_owners": "Liczba właścicieli pojazdów",
    "car_num_doors": "Liczba drzwi",
    "car_num_seats": "Liczba miejsc",
    "car_emission_class": "Klasa zanieczyszczeń",
    "car_condition": "Stan pojazdu",
    "car_construction_year": "Rok produkcji",
    "car_color_manufacturer": "Kolor (producent)",
    "car_parking_assistance": "Pomoc w parkowaniu",
    "car_interior_material": "Materiał, z którego wykonane są elementy wyposażenia wnętrza",
    "car_airbags": "Poduszki powietrzne",
    "car_air_conditioning": "Klimatyzacja",
    "car_environment_badge": "Odznaka środowiskowa",
    "car_co2_emissions": "emisja CO2",
    "car_co2_emissions_unit": "g/km",
    "car_fuel_consumption": "Konsumpcja",
    "car_fuel_consumption_unit": "l/100km",
    "combined": "połączone",
    "combined_short": "grzebień.",
    "urban": "w mieście",
    "extra_urban": "poza miastem",
    "energy_efficiency_class": "Klasa efektywności energetycznej",
    "technical_data": "Dane techniczne",
    "first_registration": "Rejestracja wstępna",
    "proceed_to_checkout": "Kasa",
    "home": "Strona główna",
    "checkout": "Kasa",
    "your_cart": "Twój koszyk",
    "your_car": "Twój samochód",
    "your_data": "Twoje dane",
    "services": "Serwis",
    "shipping_information": "Ruch",
    "payment_details": "Płatność",
    "summary": "Podsumowanie",
    "find_out_more": "Dowiedz się więcej",
    "qty": "Ilość",
    "checkout_next": "Dalej",
    "checkout_previous": "Powrót",
    "please_select": "Proszę wybrać",
    "enum_many_glue": ",",
    "enum_last_glue": " oraz",
    "enum_end": " wybierz",
    "show_details": "Pokaż szczegóły",
    "add_to_cart": "Dodaj do koszyka",
    "show_cart": "Pokaż koszyk",
    "cart": "Koszyk",
    "missingQuantity": {
      "cart": "koszyk"
    },
    "cart_is_empty": "Koszyk jest pusty",
    "item_already_in_cart": "Ten artykuł jest już w Twoim koszyku",
    "remove": "Usuń",
    "removed_from_cart": "został usunięty z koszyka",
    "continue_with_login": "Kontynuuj logowanie",
    "dont_have_an_account": "Nie ma jeszcze konta",
    "continue_without_login": "Kontynuuj bez logowania",
    "already_have_an_account_enter_username_and_password": "Masz już konto? Proszę wpisać swoją nazwę użytkownika i hasło w poniższym formularzu.",
    "continue_without_login_and_register": "Możesz kontynuować proces zakupu i utworzyć swoje konto tutaj.",
    "continue_booking_without_login_and_register": "Możesz kontynuować proces rezerwacji i utworzyć swoje konto tutaj",
    "online_discount": "Rabat internetowy",
    "your_personal_data": "Twoje dane osobowe",
    "login_data": "Dane dostępowe",
    "shipping": "Wysyłka",
    "payment_cash": "Gotówka",
    "payment_creditCard": "Karta kredytowa",
    "payment_payPal": "PayPal",
    "payment_wire_transfer": "Przelew bankowy",
    "payment_bill": "Faktura",
    "choose_different_payment_method": "Wybierz inną metodę płatności",
    "i_will_pick_up_my_car": "Odbiorę swój samochód",
    "i_will_pick_up_my_order": "Odbiorę swoje zamówienie",
    "i_want_my_car_delivered": "Chciałbym, aby mój pojazd został dostarczony.",
    "i_want_my_order_delivered": "Chciałbym, aby moje zamówienie zostało dostarczone",
    "we_could_not_calculate_route_to_address": "Nie udało się wyznaczyć trasy do podanego adresu. Proszę sprawdzić i spróbować ponownie.",
    "credit_card_holder": "Uchwyt na kartę kredytową",
    "credit_card_number": "Numer karty kredytowej",
    "car_registration": "Rejestracja pojazdów",
    "car_insurance": "Ubezpieczenie samochodu",
    "service_provided_in_country_by_company": "Usługa świadczona w {kraju} przez {firmę}.",
    "i_wish_to_have_car_registered": "Tak, chciałbym skorzystać z usługi rejestracji",
    "i_wish_to_get_car_insurance": "Chciałbym wykupić ubezpieczenie samochodu",
    "today": "Dzisiaj",
    "in_10_days": "Za 10 dni",
    "your_money_is_safe_with_us": "Twoje pieniądze są u nas bezpieczne",
    "car_transport": "Transport samochodowy",
    "delivery": "Dostawa",
    "decide_car_delivery_or_pickup": "Do Ciebie należy decyzja, czy chcesz odebrać samochód samodzielnie, czy zlecić jego dostarczenie. Tak czy inaczej, samochód będzie w idealnym stanie, czysty i z pełnym bakiem.",
    "secured_payment_until_car_is_delivered": "Bezpieczny proces płatności do momentu dostarczenia pojazdu",
    "e_payment_to_reserve_car_and_secure_services": "Płatność elektroniczna w celu rezerwacji samochodu i zabezpieczenia wybranych usług",
    "e_payment_credit_card_paypal": "Płatność elektroniczna (karta kredytowa lub PayPal)",
    "multiple_secure_options_to_pay_for_the_car": "Bezpieczne opcje płatności za samochód (przelew, gotówka przy odbiorze)",
    "buy_car_by_clicking_button": "Możesz kupić ten samochód teraz, klikając na przycisk poniżej",
    "payment_with_credit_card_ending_last4_expiring_exp_month_exp_year_issued_to_card_holder": "Płatność kartą kredytową kończącą się w {last4} i wygasającą w {expMonth}/{expYear} wydaną dla {cardHolder}",
    "click_on_paypal_checkout_to_continue": "Proszę kliknąć na przycisk Paypal Checkout, aby kontynuować.",
    "paypal_is_approved_continue_to_summary": "Twoja płatność PayPal została zaakceptowana. Prosimy o kontynuowanie podsumowania w celu zakończenia zamówienia i autoryzacji płatności.",
    "link": "Link",
    "hide_on_devices": "Ukryj na urządzeniach",
    "mobile_phones": "Telefony komórkowe",
    "tablets": "Tablety",
    "desktop_pcs": "Komputery stacjonarne",
    "show_content_on_mouse_over": "Pokaż zawartość po najechaniu myszką",
    "menu_content": "Zawartość menu",
    "link_to_page": "Link do strony",
    "page_has_no_translations": "Ta strona nie ma tłumaczeń",
    "search_results": "Wyniki wyszukiwania",
    "press_enter_to_search": "Naciśnij klawisz Enter, aby wyszukać",
    "no_results_found": "Nie znaleziono żadnych wyników",
    "create_new_entry_now": "Możesz teraz utworzyć nowy wpis:",
    "no_results_for_your_search": "Nie znaleźliśmy żadnych wyników dla Twojego zapytania",
    "change_image": "Zmiana obrazu",
    "employee_data": "Dane o pracownikach",
    "newsletter": "Zgoda na otrzymywanie newslettera",
    "editorAutosave": "Automatyczne zapisywanie w edytorze",
    "is_profile_public": "Czy profil jest publiczny?",
    "parent_page": "Strona główna",
    "cms_elements": "Elementy CMS",
    "cms_element": "Element CMS",
    "new_lead_from_website": "Nowy lead ze strony internetowej",
    "website_settings": "Ustawienia strony internetowej",
    "profile": "Profil",
    "my_bills": "Moje rachunki",
    "integrations": "Integracje",
    "email_templates": "Szablony wiadomości e-mail",
    "cms_templates": "Szablony CMS",
    "cms_template": "Szablon CMS",
    "select_brand": "Wybierz markę",
    "all_brands_visible": "Wszystkie znaki są widoczne",
    "contact_us": "Skontaktuj się z nami",
    "thank_you": "Bardzo dziękuję",
    "thank_you_for_contacting_us": "Dziękujemy za kontakt z nami. Otrzymaliśmy Twoją prośbę i skontaktujemy się z Tobą tak szybko jak to możliwe.",
    "cms_standard": "Standard",
    "select_element": "Wybierz element CMS",
    "divider": "Rozdzielacz",
    "testimonial": "Zalecenie",
    "hero_unit": "Element bohatera",
    "image_carousel": "Slider",
    "call_to_action": "Wezwanie do działania",
    "bar_counter": "Lada barowa",
    "products": "Produkty",
    "producttemplates": "Szablony",
    "single_product": "Pojedynczy produkt",
    "single_producttemplate": "Pojedynczy szablon",
    "lead_form": "Forma ołowiu",
    "image_carousel_element": "Obraz suwaka",
    "cms_grid": "Kontener",
    "cms_row": "Linia",
    "cms_col": "Kolumna",
    "text_color": "Kolor tekstu",
    "bar_counter_now": "Teraz",
    "shadow": "Cień",
    "no_shadow": "Nie ma cienia",
    "small": "Mała",
    "big": "Duża",
    "rounded_corners": "Zaokrąglone narożniki",
    "no_rounded_corners": "Brak zaokrąglonych rogów",
    "image_position": "Pozycja obrazu",
    "icon": "Ikona",
    "icon_class": "Klasa ikony (CSS)",
    "position_top": "Top",
    "position_left": "Linki",
    "bar_color": "Barwa barowa",
    "bar_background_color": "Kolor tła paska",
    "button_icon": "Symbol przycisku",
    "button_text": "Tekst przycisku",
    "full_height": "Pełna wysokość",
    "padding_top": "Odległość górna",
    "padding_bottom": "Odległość poniżej",
    "lead_source": "Źródło wiodące",
    "change_item": "Zmiana artykułu",
    "show_infos_on_top": "Pokaż informacje powyżej",
    "show_infos_on_bottom": "Informacje o pokazie poniżej",
    "condensed": "Skondensowany",
    "assign_item": "Przyporządkuj produkt",
    "image_animation": "Animacja obrazu",
    "no_animation": "Brak animacji",
    "fade_in": "Zanikanie",
    "from_left": "Od lewej",
    "from_right": "Od prawej",
    "from_top": "Z góry",
    "from_bottom": "Od dołu",
    "image_gallery": "Galeria zdjęć",
    "elements": "Elementy",
    "accordion": "Akordeon",
    "map": "Mapa",
    "height": "Wysokość",
    "video": "Wideo",
    "link_to_video": "Link do filmu",
    "video_possible_sources": "Obsługiwane są filmy z następujących portali:: YouTube, Vimeo, Dailymotion",
    "autoplay": "Automatyczne odtwarzanie",
    "aspect_ratio": "Współczynnik kształtu",
    "image_compare": "Porównaj obraz",
    "second_image": "Drugi obraz",
    "login_form": "Formularz logowania",
    "button_signin": "Zaloguj się",
    "alternative_login": "...lub w loży z:",
    "alternative_login_long": "Użyj naszej funkcji logowania społecznościowego",
    "login_with": "Zaloguj się za pomocą",
    "show_facebook_login": "Pokaż login Facebooka",
    "show_google_login": "Pokaż login Google",
    "signup_form": "Formularz rejestracyjny",
    "signup_legal_explanation": "Rejestracja - deklaracja prawna",
    "signup_agreement_text": "Rejestrując się, wyrażam zgodę na {terminy}.",
    "contact_agreement_text": "Zapoznałem się i zrozumiałem zasady {data_use}.",
    "signup_agreement_text_terms": "Ogólne zasady i warunki",
    "signup_agreement_text_data_use": "Polityka prywatności",
    "signup_agreement_text_cancellation_policy_and_form": "Polityka anulowania i formularz anulowania",
    "will_become_link_with_title_title": "link z tytułem: {title}",
    "show_only_when_user_logged_id": "Pokaż tylko jeśli użytkownik jest zalogowany",
    "car_rental_form": "Formularz wynajmu samochodu",
    "car_search_form": "Formularz wyszukiwania samochodów",
    "car_search_funnel": "Konfigurator wyszukiwania samochodów",
    "background_image": "Tapeta",
    "background_color": "Kolor tła",
    "same_col_height": "Ta sama wysokość kolumny",
    "pick_up_and_drop_off": "Odbiór i zwrot",
    "pick_up_time": "Czas odbioru",
    "drop_off_time": "Czas powrotu",
    "get_a_quote": "Określenie cen",
    "select_location": "Proszę wybrać lokalizację",
    "type_address_to_start_search": "Proszę podać adres, aby rozpocząć wyszukiwanie",
    "menu_version": "Wersja menu",
    "menu_transparent": "Przezroczysta",
    "menu_dark": "Ciemne",
    "menu_light": "Jasne",
    "logo_version": "Wersja logo",
    "logo_default": "Użyj standardowego logo",
    "logo_scroll": "Użyj logo przewijania",
    "select_a_pick_up_location": "Proszę najpierw wybrać miejsce odbioru",
    "could_not_find_location_please_enter_more_details": "Nie mogliśmy znaleźć lokalizacji. Proszę podać miejsce odbioru z dalszymi szczegółami",
    "client_not_found": "Nie znaleziono klienta",
    "order_will_directly_be_marked_paid": "Zamówienie jest oznaczone jako zapłacone bezpośrednio",
    "invoice_will_directly_be_marked_paid": "Faktura jest oznaczona jako zapłacona bezpośrednio",
    "rental_period": "Okres wynajmu",
    "change_booking_dates": "Zmiana danych dotyczących rezerwacji",
    "per_day": "za dzień",
    "buy_now": "Kup teraz",
    "book_now": "Zarezerwuj teraz",
    "rent_car_now": "Wynajmij teraz",
    "commit_to_buy": "Zamówienie z obowiązkiem zapłaty",
    "back_to_cart": "Powrót do koszyka",
    "equipment": "Sprzęt",
    "technical_specifications": "Dane techniczne",
    "cancel_checkout_question": "Anulować kasę?",
    "how_it_works": "Jak to działa",
    "secure_payment": "Bezpieczna płatność",
    "top_services": "Górne usługi",
    "if_you_buy_this_car_you_will_get_lots_of_services": "Kupując ten samochód, nie bój się formalności. Na Państwa życzenie możemy zorganizować rejestrację, ubezpieczenie i kredyt samochodowy. Wystarczy wybrać żądaną usługę przy kasie.",
    "need_more_info_question": "Czy potrzebujesz więcej informacji?",
    "contact_dealer": "Dealer kontaktowy",
    "move_around_to_see_changes": "Przesuń się, aby zobaczyć zmiany",
    "lead_catchers": "Łapacze ołowiu",
    "lead_catcher": "Główny łapacz",
    "advanced_routing": "Zaawansowany routing",
    "add_route": "Dodaj trasę",
    "source": "Źródło",
    "can_be_ordered_online": "Możliwość zamówienia online",
    "count_years_warranty": "{count} {count, liczba mnoga, jeden {ear} inne {ears}} Gwarancja",
    "amount_online_advantage": "{korzyść online",
    "your_order": "Twoje zamówienie",
    "file_name": "Nazwa pliku",
    "tags": "Tagi",
    "save_and_set_image": "Zapisz i ustaw",
    "choose_or_drop_file_to_upload": "Wybierz lub przeciągnij plik na stronę, aby go przesłać.",
    "media_formats_supported": "JPG i PNG obsługiwane.",
    "max_file_upload_size": "Maksymalny rozmiar pliku to 15 MB",
    "no_files_found": "Nie znaleziono żadnych plików.",
    "upload_file_by_dragging_over": "Prześlij plik, po prostu przeciągając go na stronę",
    "your_car_is_ready_to_check_out": "Twój wymarzony samochód jest gotowy na Ciebie",
    "choosing_one_of_our_cars_is_a_good_decision": "Jeszcze tylko kilka kroków do wymarzonego pojazdu. Skorzystaj z naszych zalet online.",
    "your_car_will_be_delivered_to_you": "Twój pojazd zostanie dostarczony do wybranego miejsca",
    "your_will_get_a_amount_discount_for_ordering_online": "W przypadku zamówień internetowych otrzymasz rabat w wysokości {kwoty}",
    "you_will_receive_extended_warranty": "Otrzymujesz przedłużoną gwarancję",
    "you_will_get_exclusive_offers_when_using_our_app": "Otrzymuj ekskluzywne oferty podczas korzystania z naszej aplikacji mobilnej",
    "you_dont_risk_when_ordering_online": "Zamawiając online nie ryzykujesz wiele.",
    "your_car_rent_is_nearly_done": "Twój samochód jest już prawie gotowy!",
    "please_continue_with_booking_and_payment": "Prosimy o kontynuowanie rezerwacji i płatności. Zapewnimy, że Twój samochód będzie gotowy w wybranym terminie odbioru. Rezerwacja online to oszczędność czasu!",
    "please_provide_address_delivery_method_payment": "Podaj swój adres, wybierz sposób wysyłki i szczegóły płatności.",
    "your_information_is_safe_with_us": "Twoje informacje są u nas bezpieczne.",
    "we_offer_parcel_shipment_for_just_amount": "Dla Państwa wygody oferujemy przesyłkę pocztową dla wszystkich naszych zamówień za jedyne {kwota}.",
    "free_delivery_on_all_our_orders": "Oferujemy darmową dostawę na wszystkie nasze zamówienia.",
    "get_your_car_delivered": "Dostawa",
    "cant_pick_your_car_yourself_we_got_you_covered": "Co się stanie, jeśli znajdziesz swój wymarzony samochód i nie będziesz mógł go odebrać samodzielnie? Bez obaw. Mamy rozwiązanie. Po zarejestrowaniu i ubezpieczeniu samochodu, kierowca umówi się z Państwem na termin dostawy i zaparkuje samochód na Państwa podjeździe.",
    "we_are_more_than_happy_to_show_you_around_your_new_car": "Oczywiście, nie możemy się doczekać, aby powitać Cię osobiście i pokazać Ci Twój nowy samochód.",
    "we_can_complete_your_order_in_shop_for_pickup": "Ale jeśli chcesz, możemy zrealizować Twoje zamówienie w naszym sklepie i możesz je odebrać, gdy będziesz miał czas.",
    "we_will_inform_you_when_we_complete_order_for_pickup": "Poinformujemy Cię o tym, gdy zrealizujemy Twoje zamówienie. Następnie będziemy cierpliwie czekać, aż go odbierzesz.",
    "we_will_ship_your_order_to_provided_address": "Twoje zamówienie wyślemy firmą DHL na podany przez Ciebie adres. Poinformujemy Cię, gdy zamówienie zostanie wysłane. Otrzymasz również numer śledzenia zamówienia.",
    "we_calculated_route_from_car_to_you": "Wyznaczyliśmy trasę z miejsca, w którym znajduje się samochód, do podanego przez Ciebie adresu. Wygląda na to, że nasz kierowca musi przejechać {distance} km, aby przywieźć samochód pod Twoje drzwi wejściowe.",
    "service_includes": "Usługa obejmuje:",
    "driver_will_call_you_and_schedule_delivery": "Nasz kierowca zadzwoni do Ciebie i dostarczy samochód, kiedy będzie Ci to najbardziej odpowiadało.",
    "your_car_will_be_washed": "Twój samochód jest myty",
    "your_car_will_be_fully_tanked": "Twój samochód jest zatankowany",
    "you_will_get_quick_tour_around_car": "Dostaniesz krótką wycieczkę po samochodzie",
    "you_can_pick_up_car_yourself": "Czy masz jeszcze jakieś pytania? Nasz zespół chętnie pomoże.",
    "only_one_step_left": "Jeszcze tylko jeden krok!",
    "check_if_everything_is_correct_and_provide_payment_data": "Proszę sprawdzić, czy wszystko się zgadza, podać nam dane do płatności i złożyć zamówienie.",
    "terms_of_contract_for_additional_services": "Warunki umowne dla usług dodatkowych",
    "terms_of_use_marketplace": "Warunki korzystania z targowiska",
    "for_the_sales_of_used_vehicles": "Sprzedaż pojazdów używanych",
    "for_the_rental_of_vehicles": "Wynajem pojazdów",
    "your_payment_schedule": "Przebieg płatności",
    "shipping_pickup": "Kolekcja",
    "shipping_parcel": "Pakiet",
    "shipping_transport": "Transport",
    "car_interior": "Wnętrze",
    "car_exterior": "Wyposażenie zewnętrzne",
    "we_are_processing_your_order_please_wait": "Realizujemy Twoje zamówienie. Proszę czekać...",
    "we_are_processing_your_booking_please_wait": "Przetwarzamy Twoją rezerwację. Proszę czekać...",
    "your_order_was_completed_successfully": "Twoje zamówienie zostało pomyślnie zrealizowane.",
    "we_created_a_user_profile": "Stworzyliśmy dla Ciebie profil użytkownika",
    "check_your_email": "Sprawdź swoją skrzynkę odbiorczą",
    "your_orders": "{liczba, liczba mnoga, jeden {numer zamówienia} inne {numer zamówienia}}:",
    "first_experience_with_our_shop_saved_profile": "Wygląda na to, że to Twoje pierwsze doświadczenie z naszym sklepem internetowym. Udało nam się zapisać informacje o Twoim profilu w naszej bazie danych. Aby kontynuować realizację zamówienia, prosimy o sprawdzenie skrzynki pocztowej i potwierdzenie adresu e-mail.",
    "order_details_sent_to_email_check_history_for_details": "Wszystkie szczegóły zamówienia zostały wysłane na Twój adres e-mail. Historię i status zamówienia można w każdej chwili przejrzeć na swoim koncie użytkownika.",
    "timeline": "Oś czasu",
    "promotions": "Działania",
    "payment_method": "Sposób płatności",
    "first_payment": "1. płatność",
    "second_payment": "2. płatność",
    "shipping_method": "Sposób wysyłki",
    "payment_1_e_payment_to_secure_your_order": "Wpłata za pomocą płatności elektronicznej w celu rezerwacji pojazdu.",
    "payment_2_choose_payment_method_for_the_car": "Wybierz metodę płatności dla swojego pojazdu.",
    "payment_escrow": "Rachunek powierniczy",
    "payment_car_credit": "Finansowanie",
    "full_refund": "Pełny zwrot pieniędzy",
    "partial_refund": "Częściowy zwrot kosztów",
    "cancel_order": "Anulowanie zamówienia",
    "create_shipping": "Tworzenie wysyłki",
    "schedule_car_registration": "Zatwierdzenie",
    "schedule_transport": "Zaplanuj transport",
    "is_published": "Jest publikowany",
    "no_salesman_available": "W tej chwili nie ma dostępnego sprzedawcy",
    "any_questions": "Pytania?",
    "feel_free_to_ask_our_online_sales_team": "Wystarczy skontaktować się z naszym zespołem sprzedaży online",
    "please_complete_your_details": "Proszę uzupełnić swoje dane",
    "registration_is_stressfull_get_your_car_registered": "Dla niektórych osób rejestracja samochodu jest stresująca i czasochłonna. Zarejestruj swój samochód na swoje nazwisko bez żadnych kłopotów.",
    "review_your_order": "Sprawdź swoje zamówienie",
    "in_order_to_confirm_identity_please_complete_your_details": "Aby potwierdzić Twoją tożsamość, potrzebujemy kilku dodatkowych informacji:",
    "payment_instructions_will_be_provided_after_seller_accepts_order": "Sprzedawca przekaże Ci szczegółowe instrukcje dotyczące płatności po zaakceptowaniu Twojego zamówienia.",
    "nationality": "Narodowość",
    "date_of_birth": "Data urodzenia",
    "place_of_birth": "Miejsce urodzenia",
    "discover_more": "Odkryj więcej",
    "more_of_product": "Więcej {produkt}",
    "more_of_product_in_city": "Więcej {produkt} w {miasto}",
    "order_placed": "Złożone zamówienie",
    "show_order_details": "Pokaż szczegóły zamówienia",
    "white_label_plugins": "Wtyczki typu white label",
    "white_label_plugin": "Plugin typu white label",
    "enhance_chedri_project_with_plugins": "Poprawić doświadczenie Creacheck z wtyczkami",
    "plugin": "Wtyczka",
    "plugins": "Wtyczki",
    "enhance_your_project_with_plugins": "Możesz wybrać, ile funkcjonalności Creacheck potrzebujesz. Sprawdź dostępne wtyczki, ich funkcje i ceny.",
    "week": "Tydzień",
    "month": "Miesiąc",
    "quarter": "Kwartał",
    "year": "Rok",
    "more_infos": "Więcej informacji",
    "less_infos": "Mniej informacji",
    "activate_plugin": "Aktywuj wtyczkę",
    "partially_activate_plugin": "Podpisać aktywację wtyczki",
    "terminate_plugin": "Zakończ wtyczkę",
    "detailed_description": "Opis szczegółowy",
    "installation_instructions": "Instrukcja montażu",
    "you_are_not_an_adminitrator": "Nie jesteś administratorem",
    "creditor_id": "Identyfikator wierzyciela",
    "i_understand_the_cost_and_want_activate_plugin": "Rozumiem koszty i chciałbym aktywować wtyczkę",
    "i_understand_the_running_cost_when_terminating_plugin": "Rozumiem koszty naliczane na koniec okresu rozliczeniowego",
    "are_you_sure_you_want_to_terminate_plugin": "Czy naprawdę chcesz zatrzymać wtyczkę?",
    "security_settings": "Ustawienia bezpieczeństwa",
    "limit_write_rights": "Ograniczenie uprawnień do zapisu",
    "limit_read_rights": "Ograniczenie praw do czytania",
    "edit_your_company_data": "Tutaj możesz edytować dane swojej firmy. Zmiana danych kontaktowych i finansowych wykorzystywanych do rozliczeń",
    "latest_order": "Ostatnie zamówienie",
    "latest_orders": "Ostatnie zamówienia",
    "latest_invoices": "Najnowsze faktury",
    "latest_editions": "Ostatnia edycja",
    "overdue_invoices": "Należne faktury",
    "view_all": "Pokaż wszystko",
    "i_accept": "przyjmuję",
    "accept_terms_before_continuing": "Zanim przejdziesz dalej, musisz zaakceptować nasze OWU i politykę prywatności.",
    "approve_car_sale": "Zatwierdzić sprzedaż samochodu",
    "enter_vin_number": "Wprowadzić numer podwozia pojazdu",
    "mark_as_paid": "Oznaczenie jako zapłacone",
    "enter_ein_number": "Wprowadź elektroniczne potwierdzenie ubezpieczenia",
    "send_payment_instructions": "Wysyłaj przekazy pieniężne",
    "submit_vin_number": "Wysłać numer podwozia pojazdu",
    "approve_and_inform_client": "Zatwierdzenie i poinformowanie klienta",
    "submit_ein_number": "Wyślij elektroniczne potwierdzenie ubezpieczenia",
    "ein": "Elektroniczne potwierdzenie ubezpieczenia",
    "payment_reference": "Odniesienie do płatności",
    "upload_sales_cotract": "Prześlij umowę sprzedaży",
    "cancellation_reason": "Powód anulowania",
    "enter_bank_data": "Wprowadź dane bankowe",
    "pickup_invite": "Zaproszenie do odbioru",
    "mark_picked_up": "Oznaczenie jako zebrane",
    "refunds": "Refundacje",
    "sent_on_date": "Wysłane w dniu {data}",
    "not_sent_yet": "Jeszcze nie wysłane",
    "pick_up_location": "Lokalizacja kolekcji",
    "emails": "E-maile",
    "use_following_list_to_personalize_your_emails": "Wykorzystaj poniższą listę do personalizacji e-maili:",
    "recipients_first_name": "Imię i nazwisko odbiorcy",
    "recipients_last_name": "Nazwisko odbiorcy",
    "senders_company_name": "Nazwa firmy nadawcy",
    "system_mail_registration_description": "Wysyłane, gdy nowy użytkownik rejestruje się na stronie internetowej",
    "system_mail_invitation_description": "Wysyłane, gdy pracownik tworzy nowego użytkownika z adresem e-mail",
    "system_mail_car_rental_pickup_reminder_description": "Wysłane na dzień przed odebraniem przez klienta wypożyczonego samochodu.",
    "system_mail_car_rental_dropoff_reminder_description": "Wysłane na dzień przed tym, jak klient odstawi wypożyczony samochód.",
    "terms_of_use": "Warunki użytkowania",
    "contract": "Umowa",
    "order_data_processing": "Umowa o realizację zamówienia",
    "i_read_and_accept_plugins_terms_of_use": "Przeczytałem i zrozumiałem warunki użytkowania i wyraźnie je akceptuję.",
    "i_read_and_accept_plugins_contract": "Przeczytałem i zrozumiałem umowę i wyraźnie ją akceptuję.",
    "i_read_and_accept_plugins_order_data_processing": "Zapoznałem się z przetwarzaniem danych dotyczących zamówienia i wyraźnie je akceptuję.",
    "send_activation_request": "Wyślij prośbę o aktywację",
    "missing_companys_bank_data": "Wygląda na to, że brakuje nam danych bankowych twojej firmy.",
    "you_can_fill_missing_data_in_settings": "W {settings} można wprowadzić brakujące dane.",
    "not_sole_representative_click_below_to_request_plugin_activation": "Użytkownik nie jest upoważniony do samodzielnego aktywowania wtyczek. Kliknij na przycisk, aby aktywować wtyczkę. Uprawniony użytkownik jest proszony o zakończenie procesu aktywacji.",
    "not_authorized_click_below_to_request_plugin_activation": "Nie masz uprawnień do aktywacji wtyczek. Kliknij przycisk, aby wysłać żądanie aktywacji do uprawnionych użytkowników.",
    "select": "Wybierz",
    "enter_app_secret": "Wprowadź sekret aplikacji",
    "enter_page_access_token": "Wprowadź Token dostępu do strony",
    "legal": "Prawna",
    "activation_pending": "Aktywacja w toku",
    "termination_pending": "Wypowiedzenie w toku",
    "form_contains_errors": "Są pewne problemy w formularzu",
    "internal_car_reference": "Wewnętrzne odniesienie do samochodu",
    "system_debtor_number": "Numer klienta systemu",
    "internal_company_reference": "Wewnętrzna referencja przedsiębiorstwa",
    "internal_location_reference": "Wewnętrzne odniesienie do lokalizacji",
    "show_notes": "Notatki z pokazów",
    "show_my_notes": "Pokaż moje notatki",
    "show_by_me": "Pokaż ode mnie",
    "items": "Produkty",
    "send_text_message": "Wyślij SMS",
    "wrote_message": "Wiadomość napisana",
    "sent_text_message": "Wysłana wiadomość SMS",
    "wrote_note": "Uwaga napisana",
    "please_check_document_check_expiration_date": "Proszę o sprawdzenie dokumentu. Upewnij się, że widziałeś ten dokument. Sprawdź datę ważności",
    "i_reviewed_the_document": "Sprawdziłem ten dokument",
    "receive_updates_in_messenger": "Czy chcesz otrzymywać aktualizacje w Messengerze?",
    "weve_received_your_request_and_will_contact_you": "Otrzymaliśmy Twoje zapytanie i skontaktujemy się z Tobą tak szybko, jak to będzie możliwe.",
    "response_text": "Tekst odpowiedzi",
    "entries": "Wpisy",
    "timeline_block": "Blok osi czasu",
    "external_accounts": "Konta zewnętrzne",
    "send_copy_to_me": "Wyślij mi kopię",
    "user_tracking": "Śledzenie użytkownika",
    "select_model": "Wybierz model",
    "select_model_group": "Wybierz grupę modeli",
    "equipment_level_budget": "Budżet",
    "equipment_level_family": "Rodzina",
    "equipment_level_comfort": "Komfort",
    "equipment_level_business": "Biznes",
    "salutation": "Salutacja",
    "getting_started": "Pierwsze kroki",
    "set_your_locations": "Ustaw swoje lokalizacje",
    "set_up_locations_for_your_car_business_set_services_opening_hours_upload_photos": "Każdy pojazd potrzebuje lokalizacji, z której klienci mogą wybierać. Przejdź do ustawień, gdzie możesz ustawić wszystkie lokalizacje, które chcesz. Możesz tam zdecydować, jakie usługi oferujesz w każdej lokalizacji, ustalić godziny otwarcia i przesłać zdjęcia, które pomogą klientom znaleźć Twój sklep.",
    "now_that_locations_are_set_create_users_so_they_can_work_together": "Teraz, gdy Twoi klienci wiedzą, gdzie prowadzisz działalność, daj nam znać, kto dla Ciebie pracuje. Proszę utworzyć użytkowników, aby mogli współpracować przy użyciu technologii Creacheck",
    "cms_content": "Zawartość CMS",
    "this_is_blank_page_use_editor_to_create_great_one": "To jest pusta strona. W naszym edytorze wizualnym możesz stworzyć piękną stronę z grafiką, piękną typografią i kompatybilną ze wszystkimi urządzeniami.",
    "cars_to_sell": "Pojazdy na sprzedaż",
    "your_business_is_car_sales_but_there_are_no_cars_create_yourself_or_use_import": "Wasza działalność polega na sprzedaży pojazdów. Naszym zadaniem jest ułatwić Ci to zadanie. Do tej pory nie wprowadziłeś do naszego systemu żadnych pojazdów. W tym celu wystarczy skorzystać z wygodnego importu pojazdów lub wprowadzić pojazdy ręcznie.",
    "create_manually": "Utwórz ręcznie",
    "import": "Import",
    "car_import": "Pojazdy importowane",
    "most_car_dealers_use_mobilede_enter_your_interface_username_and_password_to_import": "Jak się dowiedzieliśmy, większość dealerów samochodowych wykorzystuje mobile.de do prezentacji swoich samochodów. Więc najprawdopodobniej masz dostęp do usługi internetowej. Proszę wprowadzić nazwę użytkownika i hasło. Zaimportujemy wszystkie Twoje samochody automatycznie i utrzymamy Twoją ofertę w synchronizacji. Jeśli masz wiele danych do logowania, możesz wpisać ich więcej w swoim profilu.",
    "we_will_import_count_cars_for_this_username": "Dla tej nazwy użytkownika zaimportujemy {count} samochodów",
    "mobile_de_username": "Mobile.de Nazwa użytkownika API sprzedawcy",
    "mobile_de_password": "Mobile.de Seller API Password",
    "missing_bank_data": "Brakujące dane bankowe",
    "we_dont_have_your_bank_data": "Najwyraźniej nie mamy twoich danych bankowych",
    "monthly_billing_relies_on_sepa_direct_debit_fill_in_bank_data_in_settings": "Nasze miesięczne rozliczenie odbywa się na podstawie polecenia zapłaty SEPA. Ponieważ nie posiadamy danych bankowych, nie możesz korzystać z wielu naszych wtyczek. Przejdź do ustawień i wprowadź swoje dane bankowe.",
    "fill_in_bank_data": "Wprowadź dane bankowe",
    "sepa_mandate": "Mandat SEPA",
    "sepa_mandates": "Uprawnienia SEPA",
    "missing_sepa_mandate": "Brakuje nam mandatu SEPA",
    "changed_bank_data_please_generate_new_sepa_mandate": "Wygląda na to, że niedawno zmieniłeś numer konta bankowego. Aby zautomatyzować nasz miesięczny proces rozliczeniowy i stworzyć mniej stresu dla Ciebie, prosimy o utworzenie nowego mandatu SEPA.",
    "generate_sepa_mandate_now": "Wygenerowanie nowego mandatu SEPA",
    "columns": "Kolumny",
    "send_doc_as_message": "Wyślij dokument do klienta (e-mail)",
    "job_title": "Nazwa stanowiska",
    "service_point": "Serwis",
    "rental_point": "Podstawa wynajmu",
    "seller_data": "Dane sprzedawcy",
    "car_location": "Lokalizacja pojazdu",
    "save_data_before_nav_to_pathname": "Twoje dane nie zostaną zapisane. Czy chcesz przełączyć się na {pathname} bez zapisywania?",
    "share": "Podziel się",
    "assignee_changed_from_assignee_to_assignee": "Agent został zmieniony z %oldAssignee% na %newAssignee%.",
    "stage_changed_from_name_to_name": "Poziom został zmieniony z %oldName% na %newName%.",
    "handover_filled_out": "Protokół przekazania pojazdu został wypełniony",
    "data_changed": "Dane zaktualizowane",
    "key": "Kluczowy",
    "old_value": "Stara wartość",
    "new_value": "Nowa wartość",
    "no_details_available": "Szczegółowe informacje nie są dostępne",
    "services_we_offer_in_city": "Usługi, które oferujemy dla Państwa w {miejscowości}",
    "damages_present": "Obecne uszkodzenie",
    "user_is_online": "Użytkownik jest online",
    "user_is_offline": "Użytkownik jest offline",
    "click_to_start_chat": "Kliknij tutaj, aby rozpocząć czat",
    "click_to_view_chat_history": "Kliknij tutaj, aby zobaczyć historię czatu",
    "theme_colors": "Kolory tematyczne",
    "logos": "Loga",
    "send_invitation_with_username_and_password": "Wyślij zaproszenie z nazwą użytkownika i hasłem",
    "cookie_settings": "Szczegóły dotyczące plików cookie",
    "accept_only_necessary_cookies": "Akceptuj tylko niezbędne pliki cookie",
    "accept_all_cookies": "Zaakceptuj wszystkie pliki cookie",
    "privacy_preference_center": "Centrum preferencji w zakresie ochrony danych",
    "your_privacy": "Twoja prywatność",
    "basic_information_on_cookies": "Kiedy odwiedzasz stronę internetową, informacje mogą być przechowywane lub dostępne w Twojej przeglądarce, zwykle w formie plików cookie. Informacje te mogą dotyczyć Ciebie, Twoich preferencji lub Twojego urządzenia. Informacje te są wykorzystywane głównie po to, aby strona działała zgodnie z oczekiwaniami. Informacje te zazwyczaj nie identyfikują bezpośrednio użytkownika, ale mogą zapewnić bardziej spersonalizowane doświadczenie internetowe. Ponieważ szanujemy Twoje prawo do prywatności, możesz wybrać, aby nie zezwolić na niektóre rodzaje plików cookie. Wybierz kategorię, aby dowiedzieć się więcej i zmienić nasze ustawienia domyślne. Jednak zablokowanie niektórych rodzajów plików cookie może wpłynąć na Twoje doświadczenia związane z korzystaniem z witryny i świadczonych przez nas usług.",
    "necessary_cookies": "Niezbędne pliki cookie",
    "performance_cookies": "Pliki cookie dotyczące wydajności",
    "targeting_cookies": "Kierunkowe pliki cookie",
    "always_active": "Zawsze aktywny",
    "cookies_used": "Stosowane pliki cookies",
    "necessary_cookies_information": "Te pliki cookies są niezbędne do funkcjonowania strony internetowej i nie mogą być wyłączone w naszych systemach. Zazwyczaj są one ustawiane tylko w odpowiedzi na działania podejmowane przez użytkownika, które odnoszą się do żądania usługi, takie jak ustawienie preferencji prywatności, zalogowanie się lub wypełnienie formularzy. Możesz ustawić swoją przeglądarkę tak, aby blokowała te pliki cookie lub informowała o nich, ale niektóre części strony internetowej nie będą działać. Te pliki cookie nie przechowują żadnych informacji umożliwiających identyfikację osoby.",
    "save_settings": "Zapisz ustawienia",
    "save_and_continue": "Zapisz i kontynuuj",
    "priority": "Priorytet",
    "closed_leads": "Zamknięte tropy",
    "show": "Zobacz",
    "hide": "Chowaj i szukaj",
    "first_registration_from": "Pierwsza rejestracja od",
    "first_registration_to": "Pierwsza rejestracja do",
    "power_from": "Moc silnika od",
    "power_to": "Moc silnika do",
    "mileage_from": "Przebieg od",
    "mileage_to": "Przebieg do",
    "included_mileage": "{kilometr",
    "really_cancel": "Naprawdę poronić?",
    "unsaved_information_will_be_lost": "Niezapisane dane zostają utracone",
    "client_signature": "Podpis klienta",
    "another_photo": "Kolejne zdjęcie",
    "try_again": "Spróbuj ponownie",
    "back_to_vehicle": "Powrót do pojazdu",
    "image_upload_finished": "Przesyłanie zdjęć zostało zakończone",
    "you_have_no_internet_connection": "Nie masz połączenia z internetem",
    "waiting_to_reconnect": "Oczekiwanie na ponowne połączenie",
    "plus_count_more": "+ {count} więcej",
    "document_is_missing": "Brak jednego dokumentu",
    "upload_document_name_now": "Prześlij teraz dokument \"{name}",
    "lead_per_mail": "Zasada Lead by e-mail",
    "create_rules_to_forward_emails": "Tworzenie reguł przekazywania wiadomości e-mail jako kopii do innych użytkowników. Jeśli aktywowana jest wtyczka \"Data e-mail\", można również przekazywać e-maile z ważnymi informacjami w formacie XML bezpośrednio do Customer One.",
    "lead_per_mail_rules": "Zasady Lead by email",
    "include_xml_data_in_email": "Wstawianie danych w formacie XML do wiadomości e-mail",
    "sad_activity": "Działalność SAD",
    "e_payments": "Płatności elektroniczne",
    "stripe_connect": "Stripe Connect",
    "we_will_handle_epayments_for_you": "Stripe Connect pozwala nam przetwarzać płatności kartą kredytową w Twoim imieniu. Po kliknięciu \"Connect to Stripe\" możesz użyć istniejącego konta Stripe, aby połączyć się z platformą Creacheck lub utworzyć nowe konto Stripe, jeśli jeszcze go nie masz. Mając własne konto Stripe, możesz zobaczyć całą historię płatności i wypłacić pieniądze w dowolnym momencie.",
    "connect_with_stripe": "Połącz się z Stripe",
    "stripe_accounts": "Konta Stripe",
    "stripe_account_connected": "Twoje konto Stripe jest teraz podłączone",
    "stripe_accounts_are_connected": "Twoje konto Stripe jest teraz połączone z {projectName}. {projectName} może teraz przyjmować płatności kartą kredytową w Twoim imieniu.",
    "money_won": "Wygrane pieniądze",
    "leads_won": "Pozyskane leady",
    "offered_by": "Twój dealer samochodowy",
    "pay_with_saved_credit_card": "Płać zapisaną kartą kredytową",
    "pay_with_new_credit_card": "Płać nową kartą kredytową",
    "settings": "Ustawienia",
    "account": "Funkcje",
    "clients": "Firmy",
    "payments": "Płatności",
    "calendar": "Kalendarz",
    "contact": "Kontakt",
    "login": "Zaloguj się",
    "logout": "Wylogowanie",
    "previous_odometer_reading": "Poprzedni przebieg",
    "current_odometer_reading": "Aktualny przebieg",
    "odometer_reading": "Przebieg",
    "tank_volume": "Pojemność zbiornika",
    "vehicle_fuel_costs": "Koszty tankowania pojazdu",
    "mileage_surcharge": "Dodatkowa dopłata za kilometr",
    "insurance_self_participation": "Nadwyżka ubezpieczeniowa",
    "additional_costs_due": "Dodatkowe koszty z tytułu",
    "no_additional_costs": "Brak dodatkowych kosztów",
    "charge_customer_additional_costs": "Obciążenie klienta dodatkowymi kosztami",
    "warning_you_chose_not_to_charge_customer_for_additional_costs": "Uwaga! Zdecydowałeś się nie obciążać klienta żadnymi dodatkowymi kosztami",
    "cancel_booking": "Anulowanie rezerwacji",
    "no_invoices_found": "Nie znaleziono żadnych faktur",
    "upload_drivers_license": "Załaduj prawo jazdy",
    "order_details": "Szczegóły zamówienia",
    "shipping_address": "Adres do wysyłki",
    "order_overview": "Przegląd zamówień",
    "booked_by_mistake": "Zarezerwowane przez pomyłkę",
    "booked_wrong_dates": "Zarezerwowano niewłaściwe daty",
    "found_better_price": "Znaleziono lepszą cenę",
    "change_of_plans": "Zmiana planu",
    "client_called_to_cancel": "Klient zadzwonił i poprosił o anulowanie",
    "client_wrote_email_to_cancel": "Klient wysłał e-mail z prośbą o anulowanie",
    "car_damaged_before_transport": "Pojazd został uszkodzony przed transportem",
    "car_damaged_in_transport": "Pojazd został uszkodzony podczas transportu",
    "item_not_available": "Artykuł nie jest już dostępny",
    "other_reason": "Inne",
    "license_plate_number": "Wskaźnik",
    "open_in_google_maps": "Otwórz w Google Maps",
    "access_identifier": "Kod dostępu",
    "branch": "Oddział",
    "new": "Nowy",
    "in_progress": "W trakcie realizacji",
    "finished": "Kończy się",
    "failed_refunds": "Nieudane zwroty",
    "list_all_failed_refund_payments": "Wymień wszystkie nieudane zwroty z podaniem szczegółów",
    "rent_sync_vamoso_reservation_success": "Pomyślnie zarezerwowane w systemie Vamoso. Numer rezerwacji to %reservationId%.",
    "rent_sync_vamoso_reservation_failure": "Nie było możliwości zarezerwowania samochodu w systemie Vamoso. System zwrócił następujący komunikat o błędzie: \"%errorText%\".",
    "rent_sync_vamoso_cancellation_success": "Rezerwacja w systemie Vamoso została pomyślnie anulowana",
    "rent_sync_vamoso_cancellation_failure": "Nie było możliwości anulowania rezerwacji w systemie Vamoso. System zwrócił następujący komunikat o błędzie: \"%errorText%\".",
    "rent_sync_vamoso_booking_success": "Pomyślna rezerwacja w systemie Vamoso",
    "rent_sync_vamoso_booking_failure": "Rezerwacja w systemie Vamoso nie była możliwa. System zwrócił następujący komunikat o błędzie: \"%errorText%\".",
    "rent_sync_vamoso_return_success": "Pojazd został pomyślnie oznaczony jako zwrócony w systemie Vamoso",
    "rent_sync_vamoso_return_failure": "Nie było możliwości powrotu samochodu do systemu Vamoso. System zwrócił następujący komunikat o błędzie: \"%errorText%\".",
    "view_lead_details": "Pokaż szczegóły dotyczące ołowiu",
    "change_category": "Kategoria zmian",
    "json_url_parameters": "Parametry JSON URL",
    "layout_version": "Wersja układu",
    "layout_wide": "Szeroki",
    "layout_narrow": "Wąska",
    "layout_detailed": "Szczegółowy",
    "layout_slider": "Slider",
    "layout_list": "Wykaz",
    "search_version": "Wersja modułu wyszukiwania",
    "not_sure_go_to_advisory_mode": "Nie jestem pewien: tutaj jest {link}",
    "link_to_advisory_mode": "Tryb konsultacji",
    "desired_pickup_location": "Twoje pożądane miejsce zbiórki",
    "incl_short": "incl.",
    "included": "W tym",
    "included_services": "Uwzględnione usługi",
    "insurance": "Ubezpieczenia",
    "liability_and_comprehensive_insurance_with_excess_amount_of_amount_per_claim": "Ubezpieczenie odpowiedzialności cywilnej i pełne ubezpieczenie kompleksowe z nadwyżką w wysokości {kwoty} na jedno roszczenie.",
    "tyres_suitable_for_winter": "Opony zimowe",
    "additional_driver": "Dodatkowy kierowca",
    "on_request": "Na życzenie",
    "navigation_system": "System nawigacji",
    "child_seat": "Fotelik dziecięcy",
    "order_comments_and_special_wishes": "Więcej życzeń",
    "ordering_as_person": "Zamawiam jako osoba prywatna",
    "ordering_as_company": "Zamawiam jako firma",
    "filter_by_date": "Filtrowanie według daty",
    "car_rental_max_days_count_exceeded": "Niestety, wybrany okres przekracza nasz maksymalny okres wynajmu wynoszący {liczba, mnoga, jeden {# dzień} inne {# dni}}.",
    "require_document_number": "Numer dokumentu wniosku",
    "require_document_issuing_city": "Wniosek o miejsce wydania dokumentu",
    "require_document_issuing_authority": "Wniosek do organu wydającego dokument",
    "require_document_issue_date": "Wnioskowana data wydania dokumentu",
    "require_document_expiration_date": "Żądanie daty ważności dokumentu",
    "doc_number": "Numer dokumentu",
    "doc_issuing_city": "Miejsce wystawienia dokumentu",
    "doc_issuing_authority": "Organ wydający dokument",
    "doc_issue_date": "Data wydania dokumentu",
    "doc_expiration_date": "Data ważności dokumentu",
    "chedri_plugins": "Wtyczki Creacheck",
    "in_order_to_use_our_software_in_its_full_potential_you_need_to_activate_plugins_in_order_to_do_that_please_confirm_that_you_may_sign_contracts_on_behalf_of_your_company": "<p>Aby móc korzystać z naszego oprogramowania, należy aktywować pożądane funkcje. Każda funkcja jest dostarczana w postaci wtyczki, co zwykle wiąże się z obowiązkiem zapłaty (opłatą).<br />Kiedy aktywujesz wtyczkę, zostaniesz poproszony o zaakceptowanie warunków wtyczki. Zanim jednak przystąpisz do działania, musisz potwierdzić, że jesteś upoważniony do działania w imieniu swojej firmy.</p>.",
    "i_declare_that_i_am_entitled_to_legally_sign_contracts_on_behalf_of_my_company": "Oświadczam, że jestem upoważniony do podpisywania prawnie wiążących umów w imieniu mojej firmy, czyli {firmy}.",
    "your_company_was_successfully_registered": "Udało nam się zarejestrować Ciebie i Twoją firmę w naszym systemie",
    "check_email_for_more_instructions_about_your_company_registration": "Na podany przez Ciebie adres e-mail wysłaliśmy informację o sposobie postępowania. Proszę sprawdzić swoją skrzynkę pocztową. Jeśli masz jakieś pytania lub nie wiesz jak postąpić, skontaktuj się z nami.",
    "dependent_on": "W zależności od",
    "we_have_more_plugins_that_further_enhance_the_functionality": "Posiadamy inne wtyczki, które dodatkowo poprawiają funkcjonalność {plugin}.",
    "finish_plugin_configuration": "Zakończ konfigurację wtyczki",
    "it_seems_that_you_havent_finished_configuring_plugins": "Wygląda na to, że nie zakończyłeś jeszcze konfiguracji aktywowanych wtyczek. W przypadku niektórych wtyczek należy zdefiniować zewnętrzne dane uwierzytelniające (np. dla interfejsu mobile.de lub danych uwierzytelniających Vamoso). Proszę przejść do ustawień i dodać brakujące konta.",
    "lead_created_from_an_email": "Ten lead został utworzony z wiadomości e-mail",
    "show_original_message": "Pokaż oryginalną wiadomość",
    "we_found_count_similar_leads": "Znaleźliśmy {liczba, mnoga, jeden {# podobny trop} inne {# podobne tropy}}",
    "show_similiar_leads": "Pokaż podobne tropy",
    "new_lead_from_failed_refund": "Nowy trop w związku z nieudaną refundacją",
    "you_can_apply_company_data_from_company_profile": "Dane firmy można przenieść z profilu firmy",
    "load_company_data": "Załaduj dane firmy",
    "company_lookup": "Poszukiwanie firmy",
    "match_lead_tags": "Dopasowanie znaczników wiodących",
    "is_active": "Jest aktywny",
    "is_renew_password_at_next_login": "Odnów hasło przy następnym logowaniu",
    "no_overdue_tasks": "Nie ma żadnych zaległych zadań",
    "great_job": "Dobra robota!",
    "no_leads_for_today": "Nie ma dziś dla ciebie żadnych tropów.",
    "address_not_set": "Adres nie jest ustawiony",
    "statistics": "Statystyki",
    "select_assignee": "Wybierz agenta",
    "kroschke_order_in_progress": "Zlecenie Kroschke z identyfikatorem pojazdu %kroschkeVehicleId% zostało pomyślnie zainicjowane.",
    "in_original": "W oryginale",
    "a_copy": "Jeden egzemplarz",
    "mark_documents_sent": "Oznaczanie dokumentów jako wysłanych",
    "i_sent_the_documents": "Wysłałem dokumenty",
    "documents_were_sent": "Dokumenty zostały wysłane",
    "documents_sent": "Przesłane dokumenty",
    "define_custom_license_plate_number": "Określenie żądanej tablicy rejestracyjnej",
    "about_car_registration": "Usługa rejestracji obejmuje.",
    "i_would_like_individual_license_plate_number": "Tak, chciałbym wybrać swój symbol",
    "we_gather_necessary_documents": "Rejestracja w swoim organie rejestracyjnym",
    "we_produce_license_plates": "Zamówienie i montaż tablic rejestracyjnych",
    "license_plate_reservation_number": "Numer rezerwacji tablicy rejestracyjnej",
    "with_custom_license_plate_number": "Z indywidualną tablicą rejestracyjną",
    "after_the_order_reserve_desired_license_plate_at_local_registration_office": "Po złożeniu zamówienia należy zarezerwować pożądaną tablicę rejestracyjną online w lokalnym urzędzie rejestracyjnym.",
    "inform_us_about_your_license_plate_reservation_so_we_can_start_the_process": "Gdy już to zrobisz, daj nam znać swój pożądany numer rejestracyjny i numer rezerwacji (który otrzymałeś z biura rejestracji).",
    "clarify": "Wyjaśnij",
    "notification": "Komunikacja",
    "license_plate_reservation_data_missing": "Brakuje danych dotyczących rezerwacji tablicy rejestracyjnej.",
    "license_plate_reservation_number_filled_out": "Wprowadzone dane rezerwacyjne dla tablic rejestracyjnych. Żądana tablica rejestracyjna: %licensePlateNumber%. Numer rezerwacji: %reservationNumber%.",
    "distance_planned": "Planowana trasa",
    "distance_driven": "Przejechana trasa",
    "planned_pickup_date": "Planowana data odbioru",
    "pickup_date": "Data odbioru",
    "planned_delivery_date": "Planowana dostawa",
    "your_initial_offer": "Twoja pierwsza oferta",
    "your_next_offer": "Twoja następna oferta",
    "car_number": "Numer pojazdu",
    "send_price_proposal": "Wyślij propozycję ceny",
    "our_price": "Nasza cena",
    "purchase_price": "Cena zakupu",
    "our_prices_are_already_optimized_but_if_you_think_price_is_too_high_negotiate_it": "Staramy się optymalizować nasze ceny dla Ciebie, ale jeśli uważasz, że cena jest nadal zbyt wysoka, daj nam znać, co możemy dla Ciebie zrobić.",
    "select_the_car_you_love": "Wybierz żądany samochód",
    "sign_up_or_log_in_if_you_already_have_an_account": "Zarejestruj się lub zaloguj, jeśli masz już konto",
    "enter_desired_price": "Wprowadź żądaną cenę",
    "send_the_form_our_employee_will_contact_you": "Wyślij formularz. Nasz personel skontaktuje się z Państwem tak szybko jak to możliwe",
    "if_we_settle_on_a_price_you_can_buy_the_car_online": "Jeśli uzgodnimy cenę, masz możliwość zakupu samochodu bezpośrednio na naszej stronie internetowej",
    "you_have_to_log_in_to_proceed": "Musisz się zalogować, aby kontynuować",
    "rent_a_car": "Wynajem pojazdów",
    "pending_price_negotiations_count": "Wybitne {liczba, liczba mnoga, jeden {# propozycja cenowa} inne {# propozycje cenowe}}",
    "my_price_negotiation": "Moja propozycja cenowa",
    "price_negotiation": "Propozycja ceny",
    "price_negotiations": "Propozycje cenowe",
    "new_price_negotiation_request": "Wniosek o negocjację nowej ceny",
    "expired": "Wygasła",
    "first_offer": "Pierwsza oferta",
    "current_offer": "Aktualna oferta",
    "expires": "Wygasa",
    "accept_the_offer": "Przyjmij ofertę",
    "send_a_new_offer": "Wyślij nową ofertę",
    "your_new_offer": "Twoja nowa oferta",
    "your_project_dashboard": "Pulpit nawigacyjny Twojego {projektu}",
    "add_my_vehicle": "Dodaj mój pojazd",
    "no_reply_yet": "Nie ma jeszcze odpowiedzi",
    "employee_replied": "Pracownik odpowiedział",
    "price_negotiation_details": "Szczegóły propozycji cenowej",
    "current_offer_is_amount_you_can_now_proceed_to_checkout": "Twoja aktualna oferta wynosi {kwota}. Możesz wymeldować się z wynegocjowaną ceną.",
    "show_timeline": "Pokaż historię",
    "communities": "Wspólnoty",
    "gain_coverage_with_community": "Zwiększaj swój zasięg dzięki nowym platformom. Przyciągnij nowych klientów jednym kliknięciem",
    "community": "Wspólnota",
    "is_community": "Wspólnota aktywna",
    "join_community": "Dołącz do społeczności",
    "leave_community": "Wyjście ze Wspólnoty",
    "join_jahreswagen_community_and_profit_from_additional_sales_channel": "<div><p>Jedną z rzeczy, która jest zupełnie nowa w Creacheck są społeczności. Dzięki oprogramowaniu Creacheck możliwe jest tworzenie platform, do których może dołączyć wiele firm.</p><p>Jedną z takich platform jest Jahreswagen.de. Można zapoznać się z ofertami Jahreswagen. Jeśli chcesz zostać członkiem, wejdź w ustawienia społeczności i dołącz do społeczności Jahreswagen.</p><p>Członkostwo jest bezpłatne. Obowiązują jednak opłaty transakcyjne.</p><p className='m-t-20 alert-info'>Jeśli masz własny pomysł na wspólnotę, skontaktuj się z nami. Znajdziemy wtedy rozwiązanie dla Ciebie.</p></div>",
    "car_description": "Opis pojazdu",
    "marketplace_terms": "Warunki korzystania z targowiska",
    "online_appointment_booking": "Rezerwacja wizyt online",
    "my_online_appointments": "Moje spotkania online",
    "employee": "Pracownicy",
    "choice_of_date": "Wybór daty",
    "works": "Praca",
    "make_selection": "Wybierz",
    "remove_selection": "Usuń",
    "tasks": "Zadania",
    "task": "Zadanie",
    "car_service": "Serwis",
    "car_services": "Usługi",
    "car_service_station": "Stacja robocza",
    "car_service_stations": "Stacje robocze",
    "services_offered_at_your_locations": "Zdefiniuj usługi w swoich lokalizacjach.",
    "service_stations_where_your_employees_work": "Zdefiniuj stacje robocze, aby móc śledzić wykorzystanie oraz zobaczyć zajęte i wolne zasoby.",
    "team_members": "Członkowie zespołu",
    "service_details": "Szczegóły usługi",
    "service_location": "Wybrane miejsce świadczenia usługi",
    "service_drop_off_time": "Wybrany przez Państwa czas trwania usługi",
    "car_service_appointments": "Terminy warsztatów",
    "car_service_booked_at": "Termin zarezerwowany",
    "show_booking_details": "Pokaż szczegóły rezerwacji",
    "saving_draft": "Projekt jest zapisany",
    "draft_saved": "Projekt zapisany",
    "define_custom_page_templates_to_meet_your_cd": "Dostarczamy system Creacheck ze zintegrowanymi szablonami. Tutaj możesz tworzyć własne szablony, aby lepiej pokryć swój firmowy projekt.",
    "edit_description": "Edytuj opis",
    "edit_language": "Edycja języka",
    "create_blank_page": "Utwórz pustą stronę",
    "create_from_template": "Tworzenie z szablonu",
    "use_template": "Użyj szablonu",
    "time_left": "Pozostały czas",
    "animated_header": "Animowany nagłówek",
    "header_size": "Wielkość nagłówka",
    "options": "Opcje",
    "effects": "Efekty",
    "animation": "Animacja",
    "parallax": "Paralaksa",
    "animation_repeat": "Powtarzanie animacji",
    "animation_intensity": "Intensywność animacji",
    "animation_duration": "Czas trwania animacji",
    "animation_delay": "Opóźnienie animacji",
    "animation_initial_opacity": "Początkowa nieprzezroczystość animacji",
    "animation_speed_curve": "Krzywa prędkości animacji",
    "parallax_intensity": "Intensywność paralaksy",
    "animation_direction": "Kierunek paralaksy",
    "parallax_initial_opacity": "Początkowa nieprzezroczystość paralaksy",
    "append_html": "Dołączanie HTML",
    "css_classes": "Klasy CSS",
    "forward_url": "Prześlij do tego adresu URL",
    "effect_fade": "Zanikanie",
    "effect_slide": "Zjeżdżalnie",
    "effect_zoom": "Zoom",
    "effect_bounce": "Plump",
    "effect_flip": "Flip",
    "effect_fold": "Zmarszczki",
    "effect_roll": "Rolki",
    "direction_center": "Centrum",
    "direction_left": "Linki",
    "direction_right": "Prawo",
    "direction_top": "Top",
    "direction_bottom": "Poniżej",
    "repeat_once": "Raz",
    "repeat_loop": "Pętla",
    "selected_template": "Wybrany szablon",
    "premade_layouts": "Prefabrykowane układy",
    "your_existing_pages": "Twoje istniejące strony",
    "count_templates": "{count} szablony",
    "background_attachment": "Załącznik informacyjny",
    "background_position": "Pozycja w tle",
    "background_repeat": "Powtórzenie tła",
    "background_size": "Rozmiar tła",
    "edit_mode": "Tryb edycji",
    "effects_active": "Efekty aktywne",
    "document_templates": "Szablony dokumentów",
    "code_document_templates_for_print_use_the_templates_for_individual_quotes_and_invoices": "Koduj własne szablony dokumentów do drukowania dla swoich klientów. Możesz również zaprojektować własne wersje ofert i faktur.",
    "currencies": "Waluty",
    "document_template": "Szablon dokumentu",
    "document_content": "Treść dokumentu",
    "number_prefix": "Prefiks numeru",
    "sales_documents": "Dokumenty sprzedaży",
    "theme": "Temat",
    "choose_template": "Wybierz szablon dokumentu",
    "default": "Standard",
    "favorites": "Ulubione",
    "favorites_list": "Lista ulubionych",
    "require_client_address": "Adres żądania klienta",
    "require_client_email": "Poproś o adres e-mail klienta",
    "require_client_phone": "Poproś o numer telefonu klienta",
    "require_message": "Komunikat z żądaniem",
    "subscription": "Abonament",
    "subscription_plan": "Plan abonamentowy",
    "main_plugin": "Główny plugin",
    "target_organisation": "Organizacja docelowa",
    "reference_number": "Numer referencyjny",
    "show_invoice": "Pokaż fakturę",
    "delivery_date": "Termin dostawy",
    "test_drive": "Jazda próbna",
    "find_your_perfect_car": "Znajdź idealny pojazd",
    "select_car_design": "Wybierz projekt",
    "multiple_selection_possible": "Możliwość wielokrotnego wyboru",
    "fuel_type": "Paliwo",
    "select_equipment_level": "Wybierz poziom wyposażenia",
    "engine": "Motoryzacja",
    "like_budget": "Jak budżet",
    "like_family": "Jak rodzina",
    "like_comfort": "Jak komfort",
    "we_did_not_find_any_results_for_your_search": "Przepraszamy, Twoje wyszukiwanie nie przyniosło żadnych rezultatów",
    "we_did_not_find_any_cars_at_this_location_for_the_selected_period": "Nie znaleźliśmy w tej lokalizacji żadnych samochodów w wybranym okresie czasu",
    "we_did_not_find_any_cars_for_your_seaech": "Niestety nie znaleźliśmy żadnych samochodów dla Twojego zapytania.",
    "all_cars": "Pokaż wszystkie samochody",
    "search_for_cars": "Wyszukiwanie samochodów",
    "used_car_search": "Wyszukiwanie samochodów używanych",
    "dropdown": "Lista rozwijana",
    "checkboxes": "Pole wyboru",
    "multiple_choice": "Wybór wielokrotny",
    "text_input": "Wprowadzanie tekstu",
    "number_input": "Wejście numeryczne",
    "multiline_input": "Wielowierszowe wprowadzanie tekstu",
    "paragraph": "Sekcja",
    "change_questionnaire": "Kwestionariusz zmian",
    "answers_to_a_questionnaire": "Odpowiedzi na pytania zawarte w kwestionariuszu",
    "request_filling_out_questionnaire": "Wyślij swoim klientom kwestionariusz",
    "send_questionnaire_as_message": "Wyślij kwestionariusz jako wiadomość",
    "ingoing": "Przychodzące",
    "outgoing": "Wychodzące",
    "vat_short": "VAT",
    "vat": "Podatek od towarów i usług",
    "price_net": "{Cena netto",
    "environment": "Środowisko",
    "inquire": "Zapytania",
    "continue_to_product_name": "Kontynuuj do {productName}",
    "you_can_find_this_and_other_vehicles_at_company": "Ten i inne pojazdy można znaleźć w {firmie}.",
    "more_vehicles_based_on_your_search": "Więcej pojazdów na podstawie wyszukiwania",
    "add_to_favorites": "Zapisz jako ulubione",
    "remove_from_favorites": "Usuń z ulubionych",
    "share_the_offer": "Podziel się ofertą",
    "any_question_the_company_team_is_at_your_disposal": "Czy ma pan jakieś pytania? Zespół {firmy} jest do Państwa dyspozycji.",
    "you_want_this_vehicle_but_the_price_isnt_right_submit_price_proposal": "Chcesz mieć ten pojazd, ale cena nie jest do końca odpowiednia? Zgłoś swoją propozycję ceny.",
    "you_want_to_rent_this_vehicle_at_project_name_you_can": "Chciałbyś pojeździć tym pojazdem przez dłuższy czas, w {projectName} masz możliwość wynajęcia swojego wymarzonego pojazdu.",
    "uploaded_video": "Prześlij film",
    "lead_autoresponse": "Autoresponsja dla liderów",
    "automatically_respond_to_incoming_leads": "Automatycznie reaguje na przychodzące tropy. Określ dni tygodnia i godziny, w których autoresponder jest aktywny.",
    "client_gave_count_answers_to_the_name_questionnaire": "Klient udzielił {count} odpowiedzi na pytania zawarte w kwestionariuszu \"{name}\".",
    "new_lead_from_comms_center": "Nowy trop po zamkniętej komunikacji",
    "customer_chat_ended": "Czat z klientem zakończony",
    "chatter_welcome_message": "Witamy na naszym czacie. Dziękujemy za wypróbowanie naszego czatu. Jak mogę ci dziś pomóc?",
    "please_rate_us": "Proszę nas ocenić",
    "reservation_fee": "Opłata za rezerwację",
    "item_name": "Nazwa przedmiotu",
    "deposit": "Depozyt",
    "balance_due": "Należne saldo",
    "authorize": "Zatwierdzić",
    "authorized_by_name_on_date": "Zatwierdzone przez {nazwisko} w dniu {data}.",
    "auto_generated": "Generowane automatycznie",
    "not_authorized": "Nie zatwierdzony",
    "settings_instructions": "Instrukcje dotyczące ustawień",
    "payment_config": "Konfiguracja płatności",
    "projects": "Projekty",
    "invoice_address": "Adres faktury",
    "deliver_adress": "Adres dostawy",
    "your_contract_partner": "Twój partner handlowy",
    "remaining_balance": "Wartość rezydualna",
    "item_filter_is_active": "Widoczny w Internecie",
    "item_filter_is_resource": "Jest zasobem",
    "item_filter_is_subscription": "Finansowanie",
    "cancelled_by_name_on_date": "Odwołany przez {nazwa} w dniu {data}",
    "add_credit_card_data_in_next_step": "W następnym kroku możesz dodać dane karty kredytowej",
    "upon_collection": "Do pobrania",
    "leads_manually_set_to_high_priority": "Leady ustawione ręcznie na wysoki priorytet",
    "leads_with_no_reaction_for_2_hours_since_creation": "Leady bez odpowiedzi przez 2 godziny od utworzenia",
    "leads_that_were_not_updated_for_2_days": "Leady, które nie były aktualizowane przez 2 dni",
    "use_this_element_as_reference": "Użyj tego elementu jako odniesienia",
    "you_can_reuse_this_element_on_multiple_pages": "Można odwoływać się do treści, które są ponownie wykorzystywane na kilku stronach internetowych. Elementy dla Express Page Builder nie mogą być zdefiniowane jako referencje. Takie elementy są zawsze kopiowane",
    "company_data": "Dane firmy",
    "company_singup_company_data_hint": "Abyśmy mogli stworzyć Twoją firmę i przypisać Ci domenę, potrzebujemy od Ciebie następujących informacji.",
    "company_singup_personal_data_hint": "<p>Abyś mógł otrzymać dostęp z własnymi danymi użytkownika, potrzebujemy następujących informacji.<br />Wtedy otrzymasz e-mail z osobistymi danymi dostępu.</p>.",
    "your_test_domaine": "Nazwa domeny testowej",
    "your_test_domaine_hint": "<p>Powstanie nazwa domeny do hostingu projektu. Domena jest dostępna natychmiast po rejestracji.<br />Pamiętaj, że możemy również hostować projekty pod wskazaną przez Ciebie nazwą domeny. Wystarczy skontaktować się z nami później.</p>",
    "features": "Cechy",
    "forms": "Formularze",
    "pricings": "Ceny",
    "testimonials": "Referencje",
    "show_your_page_structure_and_responsive_visibility": "Wyświetla strukturę strony z etykietami i responsywną widocznością",
    "toggle_edit_mode_for_page_preview": "Przełączanie trybu edycji dla podglądu strony",
    "toggle_animation_and_parallax_effects": "Włączanie i wyłączanie animacji i efektów paralaksy",
    "use_quick_page_builder_to_create_content_faster": "Użyj Quick Page Builder, aby tworzyć treści znacznie szybciej",
    "cancel_invoice": "Anuluj fakturę",
    "refunded": "Refundowane",
    "invoice_mark_refunded": "Sprawić, by faktura podlegała zwrotowi",
    "denied_to_pay": "Odmowa zapłaty",
    "invoice_mark_denied_to_pay": "Nie zapłaci",
    "registration_success": "Zarejestrowano z powodzeniem",
    "no_images_yet": "Nie ma jeszcze zdjęć.",
    "sortingPrice": "Cena sortowania",
    "main_menu_version": "Wersja menu głównego",
    "main_menu_versions": "Wersje menu głównego",
    "administration_of_main_menu_versions": "Zarządzanie wersjami menu głównego",
    "featured": "Podkreślone",
    "list_element_class": "Klasa CSS elementu listy (li)",
    "link_class": "Klasa CSS linku",
    "width": "Szeroki",
    "primary_menu_elements": "Elementy menu głównego",
    "secondary_menu_elements": "Elementy menu pomocniczego",
    "has_secondary_elements": "Posiada elementy drugorzędne",
    "active": "aktywny",
    "company_singup_wizard_step_subscription_plan": "Wybierz pakiety",
    "company_singup_wizard_step_subscription_plan_headline": "Wybierz pakiet, który chcesz przetestować.",
    "company_singup_wizard_step_additional_plugins": "Pakiety dodatkowe",
    "company_singup_wizard_step_subscription_plan_main_plugin_headline": "Chciałbym przetestować następujące funkcje:",
    "company_singup_wizard_step_company_data": "Dane kontaktowe Państwa firmy",
    "company_singup_wizard_step_company_data_headline": "Nazwa i dane kontaktowe Państwa firmy",
    "company_singup_wizard_step_personal_data": "Twój profil pracownika",
    "company_singup_wizard_step_personal_data_headline": "Twój profil pracownika",
    "company_singup_wizard_step_personal_data_hint": "Aby móc stworzyć dla Ciebie profil pracownika, potrzebujemy informacji o Tobie. To konto daje Ci prawa administracyjne do Twojego projektu %platformName%.",
    "company_singup_wizard_step_personal_data_domain_hint": "<p>Proszę o utworzenie nazwy domeny do hostingu projektu. Domena jest dostępna natychmiast po rejestracji.<br />Pamiętaj, że możemy również hostować projekty pod wskazaną przez Ciebie nazwą domeny. Wystarczy skontaktować się z nami później.</p>",
    "company_singup_wizard_free_trial_hint": "Przetestuj nasze oferty przez jeden miesiąc bezpłatnie i bez zobowiązań.",
    "company_signup_wizard_free_trial_plugin_hint": "Przetestuj jeden miesiąc za darmo, a następnie:",
    "included_in_subscription_plan": "Wliczone w abonament, w przeciwnym razie",
    "mostly_asked": "Najczęściej pytani",
    "test_package": "Pakiet testowy",
    "active_since": "aktywny od",
    "test_period_until": "Faza testowa do",
    "navigate_to_plugins_and_configure": "Do przeglądu i ustawień wtyczek",
    "termination_date": "Data zakończenia",
    "lead_taggers": "Lead Taggers",
    "lead_tagger": "Główny tagger",
    "share_with": "Podziel się z",
    "password_weak": "Słaba",
    "password_medium": "Medium",
    "password_strong": "Mocne",
    "plugin_already_added_in_whitelabel_project": "Wtyczka jest już przypisana do projektu Whitelabel.",
    "lead_channel": "Kanał",
    "lead_channel_web": "Strona internetowa",
    "lead_channel_mobile": "Aplikacja",
    "lead_channel_phone": "Telefon",
    "lead_channel_email": "E-mail",
    "lead_channel_personally": "Osobisty",
    "allow_others_to_share": "Umożliwić innym dzielenie się z większą liczbą osób",
    "additional_imprint_information": "Dodatkowe informacje dotyczące nadruku",
    "share_with_the_company_i_work_for": "Z firmą, w której pracuję, dzielę się",
    "share_with_all_companies_in_my_holding_structure": "Ze wszystkimi firmami w mojej strukturze holdingowej, akcje",
    "latest_lead": "Najnowszy trop",
    "latest_edit": "Ostatnia edycja",
    "reaction_time": "Czas reakcji",
    "no_reaction_time": "Brak reakcji",
    "gt_2_days": "> 2 dni",
    "lt_5_minutes": "< 5 minut",
    "lt_1_hour": "< 1 godz.",
    "lt_2_hours": "< 2 godz.",
    "lt_6_hours": "< 6 godz.",
    "lt_1_day": "< 1 dzień",
    "lt_2_days": "< 2 dni",
    "by_employee": "Według pracowników",
    "by_company": "Przez firmę",
    "by_location": "Przez lokalizację",
    "by_source": "Według źródła",
    "client_data": "Dane o klientach",
    "show_in_lead_description": "Pokaż w opisie wiodącym",
    "this_answer_will_be_shown_in_lead_description": "Odpowiedź ta jest wyświetlana w opisie leadu",
    "this_answer_will_not_be_shown_in_lead_description": "Ta odpowiedź nie jest wyświetlana w opisie leadu",
    "lead_assignment_strategy": "Strategia przydziału leadów",
    "lead_assignment_strategies": "Główne strategie alokacji",
    "change_the_lead_assignment_strategies_for_companies_and_pipelines": "Zmień sposób, w jaki Twoi pracownicy są przydzielani do leadów w oparciu o ich firmy i pipeliny.",
    "strategy": "Strategia",
    "deleted": "Usunięto",
    "assign_to_me": "Przydziel mi",
    "responsibilities": "Obowiązki",
    "escalation_rules": "Zasady eskalacji",
    "escalation_rule": "Zasada eskalacji",
    "define_rules_when_you_would_like_to_inform_users_about_overdue_leads": "Definiuje reguły, których zespoły mogą używać do identyfikacji leadów, które zostały porzucone lub na które członkowie zespołu nie odpowiadają.",
    "category_images": "Obrazy kategorii",
    "use_document_template": "Użyj szablonu dokumentu",
    "escalation_level_one": "Krok pierwszy - poinformowanie pracowników",
    "escalation_level_two": "Krok drugi - Poinformowanie lidera zespołu",
    "automatically_terminate_the_lead": "Automatycznie zakończyć prowadzenie (oznaczyć prowadzenie jako utracone)",
    "no_reaction": "Brak reakcji",
    "no_reaction_for": "Brak reakcji na",
    "no_update": "Brak aktualizacji",
    "no_update_for": "Brak aktualizacji dla",
    "escalation_level": "Poziom eskalacji",
    "time_settings": "Ustawienia czasu",
    "pending": "Wyróżnia się",
    "skipped": "Pominięto",
    "holding_structure": "Struktura holdingowa",
    "show_sibling_companies": "Firmy rodzeństwa pokazują",
    "show_descendant_companies": "Pokaż podległe firmy",
    "subscription_type": "Model finansowania",
    "no_subscription_type_selected": "Należy wybrać przynajmniej jeden model finansowania.",
    "financing": "Finansowanie",
    "monthly_payment": "Stawka miesięczna",
    "final_payment": "Ostatnia rata",
    "interest_rate": "Stopa procentowa",
    "availability": "Dostępność",
    "delivery_time_month": "Czas dostawy (w miesiącach)",
    "delivery_time": "Czas dostawy",
    "cancelation_period_month": "Okres wypowiedzenia (w miesiącach)",
    "enter_financing_data": "Wprowadzanie danych finansowych",
    "marketing_agency": "Agencja marketingowa",
    "edit_company_read_and_write_rights": "Edycja uprawnień do odczytu i zapisu firmy",
    "grant_data_access": "Udzielanie dostępu do danych",
    "deny_data_access": "Odmowa dostępu do danych",
    "allow_data_access_for_a_single_company": "Umożliwienie dostępu do danych dla pojedynczej firmy",
    "allow_data_access_for_a_whole_level": "Umożliwienie dostępu do danych dla całego poziomu",
    "deny_data_access_for_a_single_company": "Odmowa dostępu do danych dla pojedynczej firmy",
    "deny_data_access_for_a_whole_level": "Odmowa dostępu do danych dla całego poziomu",
    "closing_costs": "Opłata za zamknięcie",
    "nominal_interest_rate": "Stopa docelowa",
    "has_rate_insurance": "Ochrona stawek",
    "is_user_based": "Jest oparty na użytkowniku",
    "min_user_count": "Min. liczba użytkowników",
    "max_user_count": "Maksymalna liczba użytkowników",
    "price_per_user": "Cena za użytkownika",
    "monthly": "Miesięcznie",
    "instantly": "Natychmiast",
    "quarterly": "Kwartalnik",
    "annual": "Roczne",
    "monthly_fee": "Opłata miesięczna",
    "starting_fee": "Opłata za wejście",
    "included_templates_count": "Liczba dołączonych szablonów",
    "simple_templates_count": "Liczba dołączonych szablonów (Single)",
    "middle_templates_count": "Liczba uwzględnionych szablonów (średnia)",
    "complex_templates_count": "Liczba dołączonych szablonów (Complex)",
    "surcharge": "Dopłata",
    "base_surcharge": "Dopłata podstawowa",
    "max_surcharge": "Maksymalna dopłata",
    "dataproof_surcharge": "Dopłata za Dataproof",
    "aws_domain_hosting": "Hosting domen poprzez AWS",
    "domain_hosting": "Hosting domen",
    "desired_domain": "Pożądana domena",
    "redirect_uri": "Przekazanie",
    "check_availability": "Sprawdź dostępność",
    "net_amount": "Kwota netto",
    "gross_amount": "Kwota brutto",
    "is_debtor": "Sprzedawca",
    "is_debtor_number_provider": "Numer dłużnika Dostawca",
    "is_never_remind": "Nie wysyłaj przypomnień",
    "is_demo": "Tryb demonstracyjny",
    "is_vendor": "Dostawca",
    "should_user_pay": "Użytkownik powinien zapłacić",
    "receive_payment_from_users": "Otrzymywanie płatności od użytkowników",
    "use_payment_receiver": "Użyj opcji odbiorcy",
    "payment_receiver": "Odbiorca",
    "use_summary_invoice": "Zastosowanie faktury zbiorczej",
    "credit_limit": "Limit kredytowy",
    "commission_receiver": "Odbiorca Komisji",
    "budget_value": "Wartość budżetu",
    "billing_value": "Wartość rozliczeniowa",
    "coupon_billing": "Wartość rozliczenia dla wybranego okresu rozliczeniowego",
    "coupon_billing_period": "Okres rozliczeniowy",
    "coupon_recharge_period": "Bon na doładowanie",
    "coupon_print_type": "Ograniczenie vouchera",
    "coupon_never": "Nigdy",
    "coupon_unset": "Brak ograniczeń",
    "coupon_print_pdf": "Drukuj tylko PDF",
    "recurring": "Powtarzające się",
    "period": "Okres",
    "without_end_date": "Bez daty końcowej",
    "budget_settings": "Ustawienia budżetu",
    "no_budget_set": "Brak ustalonego budżetu",
    "current_period_budget_usage": "Wykorzystanie budżetu w bieżącym okresie",
    "user_entered_no_message": "Użytkownik nie wprowadził komunikatu",
    "coupons": "Kupony",
    "coupon": "Voucher",
    "create_discounts_and_subsidy_products": "Twórz kody rabatowe i dofinansowuj produkty dla swoich partnerów",
    "authorization_status": "Status zezwolenia",
    "user_budget": "Budżet użytkownika",
    "manual_vat_check": "Kontrola obniżonej stawki VAT",
    "manual_data_check": "Ręczne sprawdzanie danych",
    "completed": "Zakończono",
    "changes_requested": "Wnioskowane zmiany",
    "rejected": "Odrzucony",
    "request_changes": "Wniosek o zmiany",
    "reply": "Odpowiedzi",
    "coupon_monetary": "Stały rabat",
    "coupon_percentage": "Rabat procentowy",
    "calculations": "Obliczenia",
    "percent_discount_value": "Rabat procentowy",
    "monetary_discount_value": "Rabat gotówkowy",
    "company_budget": "Budżet przedsiębiorstwa",
    "enter_0_to_ignore_this_setting": "Wprowadź 0, aby zignorować to ustawienie",
    "min_order_value": "Minimalna wartość zamówienia",
    "max_order_discount": "Maksymalna zniżka na jedno zamówienie",
    "coupon_budget_exceeded": "Przekroczenie budżetu bonów towarowych",
    "billing_target": "Cel rozliczenia",
    "billing_settings": "Ustawienia dotyczące rozliczeń",
    "dataproof_textarea": "Czy jest coś, na co powinniśmy zwrócić uwagę?",
    "edit": "Edytuj",
    "edit_client": "Edycja danych klienta",
    "edit_gallery": "Edytuj szczegóły galerii",
    "edit_job": "Edytuj szczegóły pracy",
    "edit_position": "Edycja pozycji",
    "edit_product": "Produkt gotowy do spożycia",
    "edit_producttemplate": "Edytuj szablon",
    "edit_question": "Edycja pytania",
    "edit_template": "Edytuj szablon",
    "edit_step": "Edycja etapu rurociągu",
    "edit_payment": "Edycja płatności",
    "edit_team": "Zespół redakcyjny",
    "edit_document_type": "Edytuj typ dokumentu",
    "edit_brand": "Marka redakcyjna",
    "edit_model": "Edytuj model",
    "edit_category": "Edycja kategorii",
    "edit_attribute": "Edycja atrybutu",
    "edit_data_push": "Edycja danych pchnięcie",
    "edit_lead_catcher": "Edycja Lead Catcher",
    "edit_external_account": "Edytuj konto zewnętrzne",
    "edit_comment": "Edytuj komentarz",
    "edit_delivery_date": "Edycja daty dostawy",
    "edit_lead_tagger": "Edit Lead Tagger",
    "edit_commission_receiver": "Edycja odbiorcy prowizji",
    "edit_payment_receiver": "Edytuj odbiorcę",
    "edit_billing_target": "Edycja celu rozliczenia",
    "create_client": "Utwórz nową firmę",
    "create_gallery": "Utwórz nową galerię",
    "create_job": "Utwórz nową pracę",
    "create_product": "Tworzenie nowego produktu",
    "create_producttemplate": "Utwórz nowy szablon",
    "create_questionnaire": "Tworzenie nowego kwestionariusza",
    "create_question": "Utwórz nowe pytanie",
    "create_template": "Utwórz nowy szablon wiadomości e-mail",
    "create_cms_template": "Utwórz nowy szablon CMS",
    "create_pipeline": "Utwórz nowy rurociąg",
    "create_step": "Utwórz nowy etap rurociągu",
    "create_payment_schedule": "Utwórz nowy plan płatności",
    "create_payment": "Utwórz nową płatność",
    "create_message": "Napisz wiadomość",
    "create_text_message": "Pisanie wiadomości tekstowej (SMS)",
    "create_note": "Napisz notatkę",
    "create_user": "Utwórz nowego użytkownika",
    "create_users": "Utwórz użytkownika",
    "create_doc_type": "Tworzenie nowego typu dokumentu",
    "create_team": "Utworzyć zespół",
    "create_brand": "Stworzyć markę",
    "create_model": "Utwórz model",
    "create_category": "Utwórz kategorię",
    "create_attribute": "Utwórz atrybut",
    "create_attribute_group": "Tworzenie grupy atrybutów",
    "create_car": "Utwórz pojazd",
    "create_item": "Utwórz produkt",
    "create_lead": "Tworzyć ołów",
    "assign_lead": "Przydzielenie prowadzenia",
    "create_page": "Utwórz stronę",
    "create_data_push": "Utwórz nowe pchnięcie danych",
    "create_white_label_project": "Utwórz nowy projekt white label",
    "create_cms_element": "Utwórz nowy element CMS",
    "create_lead_catcher": "Utwórz nowy Lead Catcher",
    "create_white_label_plugin": "Utwórz nową wtyczkę typu white label",
    "create_dynamic_data_definition": "Tworzenie nowej definicji danych dynamicznych",
    "add_account": "Dodaj konto",
    "create_external_account": "Dodaj nowe konto zewnętrzne",
    "create_model_group": "Utwórz nową grupę modeli",
    "create_model_asset": "Tworzenie nowego obrazu modelu",
    "create_lead_per_mail_rule": "Utwórz nowego lead'a według reguły emailowej",
    "duplicate_page": "Duplikat strony",
    "duplicate_cms_element": "Duplikat elementu CMS",
    "duplicate_cms_template": "Duplikat szablonu CMS",
    "create_task": "Utwórz zadanie",
    "create_car_service": "Utwórz usługę",
    "create_car_service_station": "Utwórz stację roboczą",
    "create_doc_template": "Tworzenie nowego szablonu dokumentu",
    "create_lead_autoresponse": "Stwórz nową autoresponsję dla leadów",
    "create_main_menu_version": "Tworzenie wersji menu głównego",
    "create_lead_tagger": "Utwórz Lead Tagger",
    "create_lead_assignment_strategy": "Tworzenie strategii przypisywania leadów",
    "create_escalation_rule": "Utwórz regułę eskalacji",
    "create_coupon": "Utwórz voucher",
    "client_data_saved": "Zapisane dane klientów",
    "user_data_saved": "Zapisane dane użytkownika",
    "job_data_saved": "Zapisane dane o pracy",
    "product_data_saved": "Dane produktu zapisane",
    "template_data_saved": "Zapisane dane szablonu",
    "company_logo_saved": "Logo zostało zachowane",
    "payment_schedule_data_saved": "Plan płatności został zapisany",
    "questionnaire_filled_out": "Wypełniony kwestionariusz",
    "your_message_has_been_sent": "Twoja wiadomość została wysłana",
    "email_with_password_reset_instructions_sent": "Wysłano wiadomość e-mail z instrukcją resetowania hasła",
    "password_changed_after_reset": "Twoje hasło zostało zmienione. Witaj z powrotem",
    "quote_accepted_saved": "Oferta przyjęta",
    "quote_rejected_saved": "Oferta odrzucona",
    "quote_saved": "Oferta zapisana",
    "message_sent": "Wiadomość została wysłana",
    "note_saved": "Notatka została zapisana",
    "holding_info_saved": "Przechowywane informacje",
    "new_password_set": "Zostało ustawione nowe hasło",
    "questionnaire_data_saved": "Zapisany kwestionariusz",
    "doc_type_saved": "Zapisany typ dokumentu",
    "team_saved": "Zespół uratowany",
    "document_saved": "Zapisany dokument",
    "brand_saved": "Marka uratowana",
    "model_saved": "Model zapisany",
    "category_saved": "Kategoria zapisana",
    "attribute_saved": "Zapisany atrybut",
    "item_data_saved": "Dane produktu zapisane",
    "car_data_saved": "Zapisane dane pojazdu",
    "variant_saved": "Wariant zapisany",
    "pipeline_saved": "Uratowany rurociąg",
    "comment_saved": "Komentarz zapisany",
    "lead_saved": "Zachowany ołów",
    "order_saved": "Zamówienie zapisane",
    "document_reviewed": "Dokument poddany przeglądowi",
    "locations_saved": "Zapisane lokalizacje",
    "email_confirmed": "E-mail potwierdzony",
    "page_saved": "Strona zapisana",
    "template_saved": "Szablon zapisany",
    "data_push_saved": "Zapisanie danych do pchnięcia",
    "white_label_saved": "Projekt white label zapisany",
    "attribute_group_saved": "Grupa atrybutów zapisana",
    "cms_element_saved": "Zapisany element CMS",
    "lead_catcher_saved": "Uratowany główny łapacz",
    "image_data_saved": "Zapisane dane obrazu",
    "white_label_plugin_saved": "White label plugin zapisany",
    "dynamic_data_definition_saved": "Zapisana dynamiczna definicja danych",
    "company_data_saved": "Przechowywane dane przedsiębiorstwa",
    "car_order_approved": "Sprzedaż samochodu zatwierdzona",
    "vin_number_updated": "Numer podwozia pojazdu zaktualizowany",
    "ein_number_updated": "Aktualizacja elektronicznego potwierdzenia ubezpieczenia",
    "order_marked_as_paid": "Zamówienie oznaczone jako zapłacone",
    "payment_instructions_sent": "Przekazy pieniężne wysyłane",
    "order_cancelled": "Zamówienie anulowane",
    "sales_contract_uploaded": "Przesłana umowa sprzedaży",
    "bank_data_updated": "Aktualizacja danych bankowych",
    "pickup_invite_sent": "Wysłane zaproszenie do odbioru",
    "order_picked_up": "Zamówienie odebrane",
    "order_assignee_kroschke_documents_sent": "Dealer samochodowy przesłał dokumenty wymagane do rejestracji pojazdu",
    "order_client_kroschke_documents_sent": "Klient przesłał dokumenty wymagane do rejestracji swojego pojazdu",
    "plugin_partial_activated": "Wtyczka częściowo aktywowana",
    "plugin_request_activate_sent": "Wysłano żądanie aktywacji wtyczki",
    "plugin_activated": "Wtyczka aktywowana",
    "plugin_terminated": "Wtyczka zakończona",
    "changes_saved": "Zapisane zmiany",
    "app_secret_saved": "Sekret aplikacji zapisany",
    "page_access_token_saved": "Zapisany token dostępu do strony",
    "text_message_sent": "Wysłany SMS",
    "account_saved": "Konto zapisane",
    "model_group_saved": "Zapisana grupa modeli",
    "model_asset_saved": "Zapisany obraz modelu",
    "sepa_agreement_saved": "Uratowany mandat SEPA",
    "document_uploaded": "Dokument został załadowany",
    "customer_sent_message": "Klient wysłał wiadomość",
    "lead_created": "Utworzony lead",
    "lead_watching": "Zaczęło się od obserwacji tropów",
    "lead_unwatching": "Kończy obserwację tropów",
    "lead_per_mail_rule_saved": "Lead zapisany przez regułę email",
    "drivers_license_uploaded": "Załadowane prawo jazdy",
    "plugin_saved": "Wtyczka zapisana",
    "settings_saved": "Zapisane ustawienia",
    "page_duplicated": "Strona powielona",
    "cms_template_duplicated": "Szablon CMS powielony",
    "cms_element_duplicated": "Powielony element CMS",
    "price_negotiation_started": "Rozpoczęto negocjacje cenowe",
    "new_price_negotiation_message_offer_sent": "Wysłano nową ofertę negocjacji cen",
    "you_joined_community": "Przyłączyłeś się do społeczności",
    "you_left_community": "Odszedłeś ze społeczności",
    "car_service_booked": "Rezerwacja terminu online",
    "car_service_saved": "Zachowana usługa",
    "car_service_station_saved": "Zapisane stanowisko pracy",
    "team_member_added": "Członek zespołu dodał",
    "team_member_removed": "Członek zespołu usunięty",
    "doc_template_saved": "Szablon dokumentu zapisany",
    "invoice_issued": "Wystawiona faktura",
    "request_to_fill_out_questionnaire_saved": "Prośba o wypełnienie ankiety zapisana",
    "request_to_fill_out_questionnaire_name_saved": "Prośba o wypełnienie ankiety \"{nazwa}\" zapisana",
    "lead_autoresponse_saved": "Zapisana autoresponsja dla liderów",
    "main_menu_version_saved": "Zapisana wersja menu głównego",
    "lead_tagger_saved": "Lead Tagger uratowany",
    "share_settings_updated": "Aktualizacja ustawień udostępniania",
    "lead_assignment_strategy_saved": "Zapisana strategia alokacji ołowiu",
    "escalation_rule_saved": "Zapisana zasada eskalacji",
    "value_type": "Typ",
    "value_precision": "Dokładność",
    "category_already_in_attribute": "Kategoria jest już przypisana do atrybutu.",
    "no_attributes_for_variants": "Musisz zdefiniować atrybuty, aby tworzyć warianty.",
    "budget_saved": "Zaoszczędzony budżet",
    "budget_removed": "Budżet usunięty",
    "coupon_saved": "Zachowany kupon",
    "authorization_data_saved": "Przechowywane dane dotyczące autoryzacji",
    "template_data": "Ogólne",
    "template_pages": "Ustawienia strony",
    "template_editor": "Ustawienia edytora i PDF",
    "template_timeline": "Oś czasu",
    "template_blocks": "Bloki treści",
    "template_import": "Import",
    "template_export": "Eksport",
    "template_generate": "Generator (TEST)",
    "template_import_select_template": "Wybierz folder szablonów",
    "template_blocks_template": "Blok HTML",
    "template_category_thumb": "Klasa ikony miniatury (np. fad fa-circle)",
    "add_block_category": "Nowa kategoria",
    "edit_block_category": "Edycja kategorii",
    "add_block_variant": "Nowy wariant",
    "edit_block_variant": "Wariant edycji",
    "add_block": "Nowy blok",
    "copy_block": "Blok do kopiowania",
    "edit_block": "Blok edycyjny",
    "edit_takeit": "Przejąć kontrolę",
    "edit_import": "Import",
    "edit_import_warning": "Bezpieczny? Spowoduje to nadpisanie wszystkich niezapisanych wpisów!",
    "template_has_content_blocks": "Zawartość zmienna",
    "template_in_test": "Tryb testowy dla zamówień",
    "placeholder": "Oznaczenie miejsca na list seryjny",
    "select_customer": "Wybierz klientów",
    "company_added": "Firma dodana",
    "company_removed": "Firma usunięta",
    "item_added": "Produkt dodany",
    "item_removed": "Produkt usunięty",
    "category_added": "Kategoria dodana",
    "category_removed": "Kategoria usunięta",
    "select_user_set": "Wybierz uprawnienia użytkownika",
    "sent_reminders": "Wspomnienia wysłane",
    "number_of_sent_reminders": "Liczba wysłanych przypomnień",
    "set_number": "Numer zestawu",
    "email_to_the_customer_on_save": "Wyślij do klienta e-mailem przy zapisie",
    "email_on_save": "Zapisz e-mail",
    "shown_name": "Nome dell'indicatore",
    "filename_thumbnail": "Nazwa pliku dla miniatury",
    "name_of_imagefile": "Nome del file immagine, senza directory. Es.: thumb1.jpg",
    "block_position": "Pozycja bloku w liniach siatki, 0 dla samej góry, czyni blok absolutnym",
    "defined_raster_space": "predefiniowana przestrzeń rastrowa",
    "needed_raster_space": "wymagana przestrzeń rastrowa",
    "size_group_info_text": "Wszystkie bloki z tą samą grupą SizeGroup mogą być wymiarowane w edytorze",
    "size_group": "Grupa rozmiarowa",
    "group_index_info_text": "Wszystkie bloki z tą samą grupą SizeGroup i tym samym rozmiarem bloku można przełączać za pomocą indeksu. Z indeksu 1.",
    "group_index": "Indeks grupy",
    "bottom_info_text": "UWAGA: bottom pozycjonuje blok bezwzględnie na dole strony, z ustawionym odstępem w PX",
    "bottom_label": "Pozycja bloku bezwzględnie na dole",
    "fixed_block_label": "Blok stały",
    "fixed_block_info_text": " Blok nie może być przeniesiony",
    "once_per_document_label": "Una volta per documento",
    "once_per_document_info_text": "dozwolone tylko raz w całym dokumencie",
    "no_copies_label": "Blocco non copiabile",
    "no_copies_info_text": "blok nie może być skopiowany",
    "no_options_label": "Nie wyświetlaj opcji",
    "no_options_info_text": "Blok nie ma opcji w edytorze po wklejeniu.",
    "once_per_page_label": "Once per Page",
    "once_per_page_info_text": "dozwolone tylko raz na stronie",
    "once_per_variant_label": "Una volta per variante",
    "once_per_variant_info_text": "dozwolone tylko raz na wariant",
    "once_per_category_label": "Una volta per categoria",
    "once_per_category_info_text": "only one per category allowed",
    "restricted_to_page_label": "Dozwolone na stronie",
    "restricted_to_page_info_text": "dostępne tylko na tej stronie, -1 = dozwolone wszędzie",
    "exclude_pages_label": "Wykluczyć strony (Ex: 1,2,3...)",
    "exclude_pages_info_text": "Niedozwolone na tych stronach, oddziel przecinkiem",
    "only_last_label": "Solo l'ultima pagina",
    "only_last_info_text": "Blok można wstawić tylko na ostatniej stronie",
    "container_block_label": "Blok kontenerowy",
    "container_block_info_text": "Ten blok zawiera kontener dla innych bloków",
    "inline_block_label": "Inline Block",
    "inline_block_info_text": "Blok jest traktowany jako display:inline-block",
    "inner_label": "Insertable into Block Container",
    "inner_info_text": "Blok można wstawić do kontenera z blokami",
    "container_class_label": "Limit do bloku kontenerowego",
    "container_class_info_text": "Nazwa klasy kontenera, do którego można wstawić blok.",
    "only_inside_block_label": "Możliwość wstawienia tylko do kontenera blokowego",
    "only_inside_block_info_text": "Blok może być wstawiony tylko w kontenerze bloku",
    "container_space_label": "Przestrzenie siatki w bloku kontenera",
    "container_space_info_text": "dostępne linie siatki w obrębie bloku (ta sama siatka co strona!)",
    "container_cols_label": "kolumny w bloku kontenerowym",
    "container_cols_info_text": "dostępne linie siatki są pomnożone przez tę wartość",
    "website_only": "Tylko dla stron internetowych",
    "navName": "nazwa dla nawigacji",
    "nav_link_label": "link do nawigacji",
    "nav_link_info_text": "Anchor link do ID z bloku",
    "nav_options": "Opcje dla nawigacji",
    "combi_parent_label": "Element Combi (Parent)",
    "combi_parent_info_text": "Element rodzicielski, może być wstawiony w dowolnym momencie",
    "combi_child_label": "Element łączony (dziecko)",
    "combi_child_info_text": "Elementy dziecięce można ustawić tylko w połączeniu z elementem nadrzędnym",
    "events": {
      "TimelineMailPasswordReset": "Klient zażądał zmiany hasła",
      "TimelineMailRegistration": "Klient zarejestrował się w Creacheck.com",
      "TimelineMailOauthRegistration": "Klient zarejestrował się w Creacheck.com z logowaniem do mediów społecznościowych",
      "TimelineMailInvitation": "Klient został zaproszony do korzystania z Creacheck.com",
      "TimelineMailContactForm": "Klient wysłał wiadomość poprzez formularz kontaktowy",
      "TimelineMailInvitationAccepted": "Klient przyjął zaproszenie",
      "TimelineMailNewInvoice": "Wystawiłeś fakturę dla klienta",
      "TimelineMailNewQuote": "Wysłałeś ofertę do klienta",
      "TimelineMailNewMessage": "Wysłałeś wiadomość do klienta",
      "TimelineQuoteAccepted": "Klient zaakceptował Twoją ofertę",
      "TimelineQuoteRejected": "Niestety, klient odrzucił twoją ofertę",
      "TimelineOrderCreated": "Nowe zamówienie",
      "TimelineMailNewCustomerMessage": "Wiadomość e-mail od klienta",
      "TimelineMonitoringPaymentReceipt": "Monitorowanie płatności przychodzących",
      "TimelineClosingManualDataCheck": "Ręczne sprawdzanie danych zamknięte",
      "TimelineUpdatedByForeignStatus": "Aktualizacja statusu zamówienia",
      "TimelineMailedForeignOrderStatusOrderCanceled": "Anulowany przez dostawcę",
      "TimelineMailedForeignOrderStatusInDelivery": "w dostawie",
      "TimelineMailedForeignOrderStatusInProduction": "w produkcji",
      "TimelineMailedForeignOrderStatusInReview": "w porozumieniu",
      "TimelineMailedForeignOrderStatusInOrder": "w porządku",
      "TimelineMailedOrderedWebAndDownloadPDF": "Web-enabled i pobierz PDF wysłany do odbiorców poczty elektronicznej.",
      "TimelineMailedOrderedDownloadPDF": "Pobranie pliku PDF wysłanego do odbiorcy e-maila.",
      "TimelineMailedOrderedWebPDF": "Web-enabled wysyłane do odbiorców poczty elektronicznej.",
      "TimelineDomainHostingHasBeenAuthorized": "Zezwolono na hosting domeny",
      "TimelineDomainNotAvailable": "Domena nie jest już dostępna",
      "TimelineExceptionCheckDomainAvailability": "Błąd podczas sprawdzania dostępności domeny {0}. Błąd: {2}",
      "TimelineDomainFailRegistering": "Nie udało się zarejestrować domeny {0}",
      "TimelineExceptionRegisterDomain": "Rejestracja domeny {0} nie powiodła się z błędem: {2}.",
      "TimelineDomainSuccessfullyRegistered": "Domena {0} została pomyślnie zarejestrowana.",
      "TimelineDomainSuccessfullyRedirected": "Domena została pomyślnie przekierowana",
      "TimelineDomainHostingCompleted": "Zakończono",
      "TimelineMissingClientDataFirstAndLastName": "Brakujące imię i nazwisko klienta!",
      "TimelineDomainHostingDomainValidated": "Domena została zatwierdzona",
      "TimelineDomainCreatingCertificate": "Certyfikat dla domeny {0} został utworzony z błędem: {1}",
      "TimelineDomainCreatingDistributionFailed": "Dystrybucja domeny {0} nie powiodła się z błędem: {1}",
      "TimelineDomainCreatingSuccessfullyHosted": "Domena {0} została pomyślnie hostowana",
      "TimelineDomainCreatingFailedHosting": "Domena {0} nie może być hostowana z błędem: {1}.",
      "TimelineMissingClientDataPhoneNumber": "Brakujący numer telefonu klienta!",
      "TimelineDomainCreatingSuccessfullyFinished": "Domena {0} została pomyślnie ukończona"
    },
    "attributeName": {
      "select": "Pole wyboru",
      "html": "Pole HTML",
      "checkbox": "Checkbox",
      "text": "Pole tekstowe",
      "colors": "Wybór koloru",
      "number": "Pole numeryczne",
      "boolean": "Tak/Nie",
      "date": "Data"
    },
    "attributeType": {
      "select": "Można zdefiniować kilka opcji do wyboru. Użytkownik może wtedy wybrać jeden z nich",
      "html": "Użytkownik może napisać dłuższy tekst za pomocą Rich Content Editora",
      "checkbox": "Można zdefiniować kilka opcji do wyboru. Użytkownik może wtedy wybrać kilka z nich",
      "text": "Użytkownik może wprowadzić prosty tekst",
      "colors": "Użytkownik może wybrać jeden z określonych tu kolorów",
      "number": "Użytkownik może wprowadzić liczbę",
      "boolean": "Użytkownik może wybrać pomiędzy tak i nie",
      "date": "Użytkownik może wybrać datę"
    },
    "attributeValueType": {
      "string": "Tekst",
      "number": "Numer",
      "date": "Data"
    },
    "attributePrecision": {
      "year": "Rok",
      "month": "Miesiąc",
      "day": "Dzień",
      "time": "Czas"
    },
    "categoryDisplay": {
      "select": "Tak/nie",
      "number_range": "Zakres liczbowy",
      "date_range": "Zakres dat",
      "list": "Wybór listy"
    },
    "invoice_actions": {
      "tab_title": "Czynności na fakturze",
      "refunded": {
        "title": "Zwracane ręcznie",
        "label": "Oznaczenie jako zwrócone",
        "info_text": "Ręczne oznaczenie faktury jako już zwróconej bez tworzenia faktury anulującej"
      },
      "denied_to_pay": {
        "title": "Odrzucenie płatności",
        "label": "Oznaczenie jako odrzucone",
        "info_text": "Zaznacz, że faktura nigdy nie zostanie zapłacona"
      },
      "amount_paid": {
        "title": "Wpisz wypłaconą kwotę",
        "placeholder": "Wpisz wypłaconą kwotę",
        "button": "Zapisywanie wpłaconej kwoty"
      },
      "sent_reminders": {
        "title": "Wysyłane przypomnienia",
        "placeholder": "Liczba wysłanych przypomnień",
        "button": "Zapisz numer"
      }
    },
    "mail": {
      "registration": {
        "subject": "Dziękujemy za rejestrację w %company%.",
        "subject_robethood": "Dziękujemy za zapisanie się do %company%.",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>Dziękuję za rejestrację. Prosimy o potwierdzenie adresu e-mail w ciągu 24 godzin.</p><p>Tylko z potwierdzonym adresem e-mail można otrzymać nowe hasło internetowe lub informację o zmianach.</p>.",
        "explanation_robethood": "<p>Witam %firstName% %lastName%,</p><p>Dziękuję za rejestrację. Prosimy o potwierdzenie adresu e-mail w ciągu 24 godzin.</p><p>Tylko z potwierdzonym adresem e-mail możesz otrzymać nowe hasło lub informacje o zmianach.</p>.",
        "possible_actions": "Po potwierdzeniu adresu e-mail, natychmiast uzyskasz dostęp do wszystkich funkcji, które dla Ciebie przygotowaliśmy.",
        "possible_actions_robethood": "Po potwierdzeniu adresu e-mail, natychmiast uzyskasz dostęp do wszystkich funkcji, które dla Ciebie przygotowaliśmy.",
        "call_to_action": "Potwierdź mój adres e-mail"
      },
      "ordered_web_pdf": {
        "subject": "Twój internetowy plik PDF do zamawiania %orderId% od %company%",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękujemy za zamówienie. Możesz otworzyć i pobrać plik PDF, klikając poniższy link</p>.",
        "possible_actions": "Możesz zalogować się na Creacheck.com i wyświetlić swoje zamówienie online.",
        "call_to_action": "Pokaż kolejność"
      },
      "ordered_download_pdf": {
        "subject": "Twój plik PDF do zamówienia %orderId% od %company%",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękujemy za zamówienie. Możesz otworzyć i pobrać plik PDF, klikając poniższy link </p>.",
        "possible_actions": "Możesz zalogować się na Creacheck.com i wyświetlić swoje zamówienie online.",
        "call_to_action": "Pokaż kolejność"
      },
      "order_vat_data_check_done": {
        "subject": "Twoje zlecenie ręcznego sprawdzenia danych dla zlecenia %orderId% od %company%.",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękuję za zamówienie i zlecenie ręcznego sprawdzenia danych. Status sprawdzania danych można zobaczyć klikając na \"Zobacz status\". </p>",
        "possible_actions": "Możesz zalogować się na Creacheck.com i przeglądać swoje zamówienie online.",
        "call_to_action": "Pokaż status"
      },
      "chedri_registration": {
        "subject": "Twoja rejestracja w %firmie%.",
        "subject_fiendly": "Twoja rejestracja w %company%.",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>Dziękuję za rejestrację.</p><p>Pomyślnie utworzyliśmy konto testowe dla Ciebie i Twojej firmy.</p>.",
        "possible_actions": "Po potwierdzeniu adresu e-mail możesz się zalogować, używając <strong>%username%</strong> jako swojej nazwy użytkownika i hasła wybranego podczas rejestracji.",
        "call_to_action": "Potwierdź mój adres e-mail"
      },
      "invitation": {
        "subject": "Firma %company% zaprosiła Cię do Creacheck.com",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>%firma% chciałaby, abyś dołączył do Creacheck.com.</p>.",
        "login_data": "Jeśli przyjmiesz zaproszenie, użyj tych danych do zalogowania się: <strong>%username%</strong> jako swojej nazwy użytkownika i <strong>%password%</strong> jako swojego hasła. Pamiętaj, aby po zalogowaniu się zmienić hasło.",
        "call_to_action": "Przyjmij zaproszenie"
      },
      "new_quote": {
        "subject": "Nowa oferta od %company% na Creacheck.com",
        "explanation": "<p>Witaj %firstName% %lastName%,</p><p>%firma% przesyła Ci ofertę na usługę, o którą prosiłeś.</p>.",
        "possible_actions": "Masz teraz możliwość przejrzenia i zaakceptowania oferty. Możesz też odrzucić ofertę i zostawić wiadomość dlaczego.",
        "call_to_action": "Oferta przeglądu"
      },
      "new_invoice": {
        "subject": "Nowa faktura od %company% na Creacheck.com",
        "explanation": "<p>Witaj %firstName% %lastName%,</p><p>%firma% przesyła Ci fakturę za usługę, o którą prosiłeś.</p><p>Fakturę można znaleźć na stronie Creacheck.com. Do tej wiadomości dołączyliśmy również fakturę.</p>.",
        "possible_actions": "Możesz zalogować się na Creacheck.com i przeglądać swoje faktury online.",
        "call_to_action": "Pokaż fakturę"
      },
      "new_questionnaire": {
        "subject": "%firma% chciałaby, abyś wypełnił kwestionariusz",
        "explanation": "<p>Witaj %firstName% %lastName%,</p><p>%firma% przesyła Ci nowy kwestionariusz.</p>.",
        "possible_actions": "Masz możliwość obejrzenia i wypełnienia kwestionariusza online.",
        "call_to_action": "Zobacz kwestionariusz"
      },
      "questionnaire_filled_out": {
        "subject": "Kwestionariusz został właśnie wypełniony",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>Kwestionariusz wymagany przez %targetFirstName% został właśnie wypełniony.</p>.",
        "possible_actions": "Odpowiedzi można przeglądać na osi czasu leadów.",
        "call_to_action": "Otwarty trop"
      },
      "contact_form": {
        "subject": "Nowy kontakt od %name%.",
        "info": "<p>Został wykorzystany formularz kontaktowy. Teraz zadbaj o jak najlepszą obsługę klienta :) Powodzenia</p>."
      },
      "password_renew": {
        "subject": "Odnów swoje hasło",
        "explanation": "<p>Witam %email%,<br><br>próbowałeś zalogować się na %platformęName%. Twoje hasło wygasło. Musisz ustawić nowe hasło, aby zalogować się w przyszłości.</p><p>Kliknij na poniższy link, aby wprowadzić nowe hasło.",
        "possible_actions": "Kliknij tutaj, aby ustawić nowe hasło",
        "call_to_action": "Ustaw nowe hasło"
      },
      "password_reset": {
        "subject": "Zażądałeś zresetowania swojego hasła",
        "explanation": "<p>Witaj %email%,</p><p>właśnie zażądano nowego hasła od %platformName% za pośrednictwem naszej platformy.</p><p>Jeśli złożyłeś to żądanie, kliknij poniższy link.</p>",
        "possible_actions": "Masz możliwość ustawienia nowego hasła. Wystarczy kliknąć na poniższy przycisk.",
        "call_to_action": "Ustaw nowe hasło"
      },
      "message": {
        "explanation": "%firma% wysłała do Ciebie wiadomość",
        "possible_actions": "Możesz odpowiedzieć na tę wiadomość, klikając ten przycisk:",
        "call_to_action": "Odpowiedzi"
      },
      "customerMessage": {
        "explanation": "Klient wysłał do Ciebie wiadomość"
      },
      "lead_comment_mention": {
        "subject": "Zostałeś wymieniony w %title% lead.",
        "explanation": "%creator% wspomniał o Tobie w komentarzu.",
        "call_to_action": "Otwarty trop"
      },
      "lead_assignee_changed": {
        "subject_assigned": "Jesteś teraz przypisany do czołówki %title%.",
        "subject_unassigned": "Nie są one już przypisane do leadu %title%.",
        "explanation_assigned": "Jesteś teraz przypisany do tropu %title%. Poprzednim redaktorem był %oldAssignee%.",
        "explanation_unassigned": "Nie są one już przypisane do leadu %title%. Nowy agent to %newAssignee%.",
        "call_to_action": "Otwarty trop"
      },
      "bank_data_reminder": {
        "subject": "Potrzebujemy Twoich danych bankowych do złożenia zamówienia",
        "explanation": "Zarezerwowałeś usługi, do których wymagane są dane bankowe.",
        "possible_actions": "Proszę przejść do zamówienia i wprowadzić ewentualne brakujące dane.",
        "call_to_action": "Wprowadź dane bankowe"
      },
      "order_approved": {
        "subject": "Twoje zamówienie z %company% zostało właśnie zatwierdzone",
        "explanation": "Miło nam poinformować, że Twoje zamówienie %orderId% zostało zatwierdzone.",
        "possible_actions": "Możesz chcieć przejść do swojego zamówienia, aby zobaczyć szczegóły.",
        "call_to_action": "Kolejność pokazów"
      },
      "sales_contract_uploaded": {
        "subject": "Umowa kupna dla Twojego zamówienia jest już dostępna"
      },
      "order_cancelled": {
        "subject": "Twoje zamówienie z %company% zostało anulowane.",
        "explanation": "Przykro nam, ale musieliśmy anulować Twoje zamówienie %orderId%.",
        "possible_actions": "Przejdź do swojego zamówienia, aby zobaczyć szczegóły.",
        "call_to_action": "Kolejność pokazów"
      },
      "payment_instructions": {
        "subject": "Informacje dotyczące płatności za zamówienie w %company%",
        "explanation": "Poniżej znajdziesz informacje o płatności dla Twojego zamówienia %orderId%:",
        "possible_actions": "Przejdź do swojego zamówienia, aby zobaczyć szczegóły.",
        "call_to_action": "Kolejność pokazów"
      },
      "pickup_invite": {
        "subject": "Twoje zamówienie jest gotowe do odbioru",
        "explanation": "Twoje zamówienie o numerze %orderId% jest gotowe do odbioru.",
        "possible_actions": "Przejdź do swojego zamówienia, aby zobaczyć szczegóły.",
        "call_to_action": "Kolejność pokazów"
      },
      "order_picked_up": {
        "subject": "Dziękujemy za zamówienie"
      },
      "request_plugin_activation": {
        "subject": "Wymagana aktywacja wtyczki",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>%creatorFirstName% %creatorLastName% chciałby aktywować wtyczkę <strong>%pluginName%</strong> dla projektu %platformaName%.</p>.",
        "possible_actions": "Zalogować się i skorzystać z formularza aktywacyjnego można poprzez naciśnięcie poniższego przycisku.",
        "call_to_action": "Aktywuj wtyczkę"
      },
      "plugin_activated": {
        "subject": "Wtyczka aktywowana",
        "explanation": "<p>Witam %firstName% %lastName%,</p><p>Chcielibyśmy poinformować, że %pluginName% został aktywowany dla projektu %platformaName%.</p>.",
        "call_to_action": "Zobacz to w akcji"
      },
      "lead_data": {
        "subject": "Nowy trop: %title%.",
        "call_to_action": "Pokaż ołów"
      },
      "order": {
        "item_sales": {
          "subject": "Twoje zamówienie z %firmy%.",
          "title": "Twoje zamówienie",
          "explanation": "Dane do Twojego zamówienia są ponownie wymienione poniżej.",
          "possible_actions": "Wszystkie informacje na temat zamówienia znajdziesz również na swoim koncie klienta.",
          "call_to_action": "Podgląd na koncie klienta"
        }
      },
      "rent_sync_vamoso_error": {
        "subject": "Zamówienie #%orderId%: Błąd w pluginie Rent Sync for Vamoso: %errorType%.",
        "explanation": "Niestety, nasza wtyczka nie mogła wykonać zadania w twoim systemie Vamoso. Prosimy o ręczne sprawdzenie stanu rezerwacji. <br/>Typ błędu: %errorType% <br/>Wiadomość o błędzie: %errorText%"
      },
      "lead_deadline_reminder": {
        "subject": "Są one przypisane do leadów, które mają być wykonane jutro",
        "explanation": "Tutaj znajdziesz listę przypisanych do Ciebie leadów. Te tropy są nadal otwarte i mają być gotowe na jutro."
      },
      "chat_history": {
        "subject": "Twoja historia czatu",
        "explanation": "Dziękujemy za kontakt z nami. W załączniku znajdziesz swoją historię czatu z %firstName% %lastName%. Mam nadzieję, że udało nam się pomóc we wszystkich pytaniach lub problemach. Jeśli masz jakieś dodatkowe pytania, zapraszamy do ponownego kontaktu z nami w dowolnym momencie.",
        "greatingchat_history": "Historia czatu",
        "greating": "Dziękujemy za odwiedzenie czatu %platformyName%. Twoim partnerem na czacie był %firstName% %lastName% Poniżej możesz zobaczyć historię ich czatów od %date%.",
        "adaption": "Mam nadzieję, że udało nam się pomóc we wszystkich pytaniach lub problemach. Jeśli masz jakieś dodatkowe pytania, zapraszamy do ponownego kontaktu z nami w dowolnym momencie.",
        "privacy_policy": "Nasza polityka prywatności znajduje się pod adresem <a href=\"%link%\" target=\"_blank\">'%link%</a>.",
        "call_to_action": "Odwiedź nas ponownie"
      },
      "lead_pool_notification": {
        "subject": "Nowy trop w puli: %title%.",
        "explanation": "W systemie dostępny jest nowy trop. Nie wyznaczyliśmy jeszcze pracownika. Kliknij przycisk poniżej, aby zobaczyć szczegóły.",
        "call_to_action": "Otwarty trop"
      },
      "lead_escalation_level1": {
        "subject": "[LEVEL1] %name%.",
        "explanation": "Otrzymujesz tę wiadomość, ponieważ jeden lub więcej leadów osiągnęło pierwszy poziom eskalacji określony w regule %name%. Proszę sprawdzić tropy, aby zobaczyć, co trzeba zrobić."
      },
      "lead_escalation_level2": {
        "subject": "[LEVEL2] %name%",
        "explanation": "Otrzymujesz tę wiadomość, ponieważ jeden lub więcej leadów osiągnęło drugi poziom eskalacji określony w regule %name%. Proszę przejrzeć wskazówki i spróbować zmotywować swoje zespoły do większych starań."
      },
      "campaign_budget_auth_request": {
        "subject": "Ostrzeżenie: Przekroczony budżet kampanii",
        "call_to_action": "Kolejność pokazów"
      },
      "campaign_budget_auth_request_unsuccessful": {
        "subject": "Ostrzeżenie: Problem z autoryzacją budżetu kampanii",
        "call_to_action": "Kolejność pokazów"
      },
      "user_budget_auth_request": {
        "subject": "Ostrzeżenie: Przekroczony budżet użytkownika",
        "call_to_action": "Kolejność pokazów"
      },
      "user_budget_auth_request_unsuccessful": {
        "subject": "Ostrzeżenie: Problem z autoryzacją budżetu użytkownika",
        "call_to_action": "Kolejność pokazów"
      },
      "order_auth_changes_requested": {
        "subject": "Info: wnioskowane zmiany",
        "call_to_action": "Kolejność pokazów"
      },
      "order_auth_changes_implemented": {
        "subject": "Info: Wprowadzone zmiany",
        "call_to_action": "Kolejność pokazów"
      },
      "manage_notification": "Zarządzaj powiadomieniami e-mailowymi",
      "unsubscribe": "Zrezygnuj z subskrypcji",
      "confidentiality_notice": "Uwaga dotycząca poufności: Ten e-mail jest przeznaczony wyłącznie dla określonego odbiorcy i może zawierać informacje poufne i/lub zastrzeżone. Jeśli nie jesteś właściwym odbiorcą lub otrzymałeś tę wiadomość e-mail w wyniku błędu, prosimy o natychmiastowe poinformowanie nadawcy i zniszczenie tej wiadomości. Nieuprawnione kopiowanie lub rozpowszechnianie tego e-maila jest zabronione.",
      "no_legal_binding_notice": "Niniejsza wiadomość służy wyłącznie wymianie informacji i nie ma żadnych skutków prawnych. Ze względu na łatwość manipulowania wiadomościami e-mail, nie możemy przyjąć żadnej odpowiedzialności za ich treść.",
      "invoice_due_reminder": {
        "subject": "Przypomnienie o płatności"
      },
      "last_seen_reminder": {
        "subject": "Last seen Reminder"
      },
      "order_foreign_status": {
        "subject": "Zmiana statusu zamówienia",
        "explanation": "Status Twojego zamówienia uległ zmianie.",
        "in_delivery": {
          "subject": "Twoje zamówienie jest w trakcie wysyłki",
          "explanation": "Twoje zamówienie jest produkowane i przekazywane kurierowi do dostarczenia",
          "possible_actions": "Przesyłkę można śledzić na stronie internetowej kuriera",
          "call_to_action": "Śledź swoje zamówienie",
          "tracking_numbers": "Numery śledzenia"
        }
      },
      "order_foreign_status_in_production": {
        "subject": "Zmiana statusu zamówienia",
        "possible_actions": "Status nowego zamówienia można zobaczyć w historii zamówień.",
        "call_to_action": "Do historii zamówień"
      },
      "new_sales_commission": {
        "subject": "Nowa prowizja od %company%.",
        "explanation": "<p>Witaj %firstName% %lastName%,</p><p>%firma% wysyła Ci prowizję za usługę, którą zamówiłeś.</p><p>Fakturę znajdziesz na %domenie%. Do tej wiadomości dołączyliśmy również fakturę.</p>.",
        "possible_actions": "Możesz zalogować się do %domeny% i zobaczyć swoją prowizję online.",
        "call_to_action": "Wykazać prowizję"
      },
      "contact_form_confirm": {
        "subject": "Proszę potwierdzić swój e-mail",
        "explanation": "<p>Twój e-mail został wprowadzony do formularza kontaktowego na naszej stronie.</p><p>Jeśli wypełniłeś nasz formularz kontaktowy, proszę kliknij przycisk Potwierdź.</p><p>W przeciwnym razie po prostu zignoruj tę wiadomość.</p>.",
        "call_to_action": "Potwierdzić"
      },
      "order_reduced_vat_authorized": {
        "subject": "Twój wniosek o obniżoną stawkę VAT dla zamówienia %orderId% został zatwierdzony.",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękujemy za zamówienie. Zatwierdziliśmy zamówienie dla obniżonej stawki VAT. Status zamówienia można sprawdzić, klikając opcję \"Pokaż status\". </p>",
        "possible_actions": "Możesz zalogować się na Creacheck.com i wyświetlić swoje zamówienie online.",
        "call_to_action": "Pokaż status"
      },
      "order_reduced_vat_rejected": {
        "subject": "Twój wniosek o obniżoną stawkę VAT dla zamówienia %orderId% nie został zatwierdzony.",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękujemy za zamówienie. Sprawdziliśmy zamówienie i stwierdziliśmy, że nie kwalifikuje się ono do obniżonej stawki VAT. Zastosowana zostanie normalna stawka VAT. Status zamówienia można sprawdzić, klikając opcję \"Wyświetl status\". </p>",
        "possible_actions": "Możesz zalogować się na Creacheck.com i wyświetlić swoje zamówienie online.",
        "call_to_action": "Pokaż status"
      },
      "order_content_check_status": {
        "subject": "sprawdzenie zawartości dla zamówienia %orderId% było %status%",
        "explanation": "<p>Witam %salutation% %lastName%,</p><p>Dziękujemy za zamówienie. Mamy %status% zamówienia po sprawdzeniu zawartości.</p>",
        "possible_actions": "Możesz wywołać swoje zamówienie, aby wyświetlić szczegóły.",
        "call_to_action": "Wyświetl zamówienie"
      },
      "lead_follow_up_reminder": {
        "subject": "Sprawdź przydzielone zadania",
        "explanation": "Tutaj znajdziesz listę zadań przypisanych do Ciebie. Zadania te są nadal otwarte."
      }
    },
    "formGroup": {
      "basic_information": "Podstawowe informacje",
      "contact_person": "Kontakt",
      "address_information": "Adres",
      "address_settings": "Ustawienia adresu",
      "bank_account": "Dane bankowe",
      "company_information": "Informacje o firmie",
      "user_roles": "Role użytkowników",
      "subscription_roles": "Subskrypcja użytkownika",
      "opening_hours": "Godziny otwarcia",
      "position_on_map": "Pozycja na mapie",
      "white_label_parent": "Forerunner",
      "user_teams": "Zespoły użytkowników",
      "contact_data": "Dane kontaktowe"
    },
    "hints": {
      "small_hint_for_you": "Mała wskazówka dla ciebie",
      "task_is_automated": "Zadanie to jest zautomatyzowane. Musisz poczekać, aż zadanie automatyzacji zostanie uruchomione. Następnie oznaczymy go jako wypełniony dla Ciebie.",
      "please_complete_previous_tasks": "Nie możesz teraz edytować tego zadania. Proszę najpierw zająć się poprzednimi zadaniami.",
      "companyLogoNew": "<p>Nie umieściłeś jeszcze swojego logo. Aby przesłać jeden, wystarczy przeciągnąć i upuścić obraz (jpeg lub png) na tę stronę.</p>.",
      "companyLogoChange": "<p>To jest logo, które przesłałeś. Aby go zmienić, wystarczy przeciągnąć i upuścić obraz (jpeg lub png) na tę stronę.</p>.",
      "companyFinancial": "<div><p>Proszę wypełnić informacje wymagane do wystawienia faktury</p><p>Dane bankowe, które tu wypełnisz, będą wyświetlane w stopce na Twoich ofertach i fakturach</p></div>.",
      "companyPaymentInfo": "<p>Ta informacja jest wyświetlana na każdej tworzonej fakturze.</p>."
    },
    "vendors": {
      "association": "Powiązanie z danymi klienta",
      "vendor_api": "Nazwa usługi",
      "pricing": "Cennik",
      "operating_mode": "Tryb pracy",
      "price_update_method": "Metoda aktualizacji cen",
      "order_processing": "Realizacja zamówienia",
      "order_method": "Sposób zamawiania",
      "order_email": "Adres e-mail do składania zamówień",
      "phone_number": "Numer telefonu",
      "web_shop_url": "URL sklepu internetowego",
      "trial": "próba",
      "live": "na żywo",
      "prices_by_vendor": "Ceny są zarządzane przez usługodawcę",
      "prices_by_employee": "Ceny są sprawdzane i utrzymywane przez pracownika",
      "prices_by_api": "Ceny są aktualizowane przez API",
      "notified_by_email": "Zostaniesz powiadomiony o nadchodzących zamówieniach przez e-mail",
      "accepts_only_email": "Przyjmuje zamówienia tylko przez e-mail",
      "use_webshop": "Zamówienia przez sklep internetowy",
      "order_by_api": "Zamówienia przez API",
      "order_by_api_and_webshop": "Zamówienia przez API lub sklep internetowy"
    },
    "client_account": "Konto klienta",
    "deleted_campaigns": "Usunięte kampanie",
    "deleted_editions": "Usunięte edycje",
    "deleted_folders": "Usunięte foldery",
    "deleted_media": "Usunięte media",
    "root": "Katalog główny",
    "trash_bin": "Kosz na śmieci",
    "delete_trash_bin": "Pusty kosz",
    "pls_wait": "Proszę czekać. Żądana akcja jest wykonywana.",
    "go_back": "Powrót",
    "restore": "Przywróć",
    "archived_campaigns": "Zarchiwizowane kampanie",
    "load_all_campaigns": "Załaduj wszystkie kampanie",
    "load_creacheck_campaigns": "Załaduj kampanie Creacheck",
    "archived_editions": "Wydania archiwalne",
    "sorting_name": "Nazwa",
    "sorting_date_ASC": "Najpierw najświeższe",
    "sorting_date_DESC": "Najstarszy pierwszy",
    "sorting_owner": "Firma",
    "sorting_creator": "Stworzony przez",
    "campaign_title": "Kampania",
    "dataproof": "Kontrola danych",
    "not_ordered": "Nie zamawiane",
    "supplier_order": "Zamówienie od dostawcy",
    "change_of_address": "Zmiana adresu",
    "not_available": "Niedostępne",
    "selected_shipping_method": "Wybrana metoda wysyłki",
    "ordered_items": "Zamówione artykuły",
    "standard": "Standard",
    "express": "Express",
    "overnight": "Nocleg",
    "create_printData": "Tworzenie danych do druku",
    "created_new_printData": "Utworzono nowe dane do druku",
    "uploaded_printData_successful": "Dane do druku zostały załadowane pomyślnie",
    "no_printData": "Brak danych do druku",
    "no_images": "Brak dostępnych plików graficznych",
    "not_the_original_printFile": "Uwaga: To nie jest oryginalny plik do druku",
    "printDataFiles": "Drukuj plik(i) danych",
    "image_files": "Pliki obrazów",
    "customer_comment": "Komentarz klienta",
    "actions_": " Działania",
    "import_success": "Twój import został wykonany",
    "import_rejected": "Twój import został anulowany",
    "import_exec": "Twój import jest wykonywany",
    "import_successRE": "Twój import został zresetowany",
    "import_rejectedRE": "Operacja została anulowana",
    "import_execRE": "Twój import został zresetowany",
    "choice_csv": "Proszę wybrać plik CSV",
    "user_import_success": "Import zakończony sukcesem",
    "user_duplicate_import": "Znaleziono duplikat wpisu",
    "start_import": "Rozpocząć import",
    "reverse_import": "Cofnij import",
    "upload_local_changes": "Przesyłanie zmian lokalnych",
    "dataproof_master_copies_upload": "Tutaj możesz przesłać lokalnie edytowany szablon(y) / plik(i) danych za pomocą przycisku [Upload].",
    "edit_edition": "Edycja materiałów reklamowych",
    "dataproof_master_copies_recreate": "W tym miejscu można użyć opcji [Utwórz dane do druku], aby rozpocząć nowe tworzenie szablonu/pliku (plików) danych do druku na podstawie oryginału lub można edytować szablon/plik danych do druku lokalnie za pomocą opcji [Edytuj].",
    "hint": "Uwaga",
    "dataproof_hint_master_copies_upload": "Aby zmiana została wprowadzona po zakończeniu przetwarzania końcowego, zmieniony lokalnie plik (pliki) szablonu/danych do druku musi zostać przesłany za pomocą polecenia [Prześlij].",
    "edit_": "Edytuj",
    "send_invoice": "Wyślij fakturę",
    "sended_invoice": "Faktura została wysłana na adres",
    "send_email_tracking": "Śledzenie wysyłek pocztą elektroniczną",
    "sended_email": "E-mail został wysłany!",
    "tracking": "Śledzenie przesyłek",
    "send_tracking_to_customer": "Wysyłanie śledzenia do klientów",
    "to_the_product": "O produkcie",
    "order_sended": "Zamówienie zostało wysłane!",
    "failure_when_ordering": "Podczas składania zamówienia wystąpił błąd!",
    "please_create_orderhistory_email": "Zamówienie zostało wysłane drogą mailową! Proszę utworzyć historię zamówień!",
    "new_status_set": "Nowy status został ustalony!",
    "change_of_status": "Zmiana statusu",
    "statusQuery": "Wniosek o nadanie statusu",
    "totalStatus": "Stan ogólny:",
    "printData": "Dane do wydruku",
    "current_printdata_sended": "Aktualne dane do druku zostały wysłane!",
    "orderHistory": "Proces zamawiania",
    "orderHistory_created": "Historia zamówienia została utworzona!",
    "order_created": "Zamówienie zostało pomyślnie utworzone!",
    "enter_trackingLink": "Wprowadź link śledzenia",
    "query_orderStatus": "Zapytanie o status zamówienia",
    "foreignId": "Zamówienie podmiotu trzeciego nr.",
    "orderStatus": "Status zamówienia",
    "orderDate": "Data zamówienia",
    "options_": "Opcje",
    "type_": "Art.",
    "comment_": "Komentarz",
    "orderOptions": "Opcje zamawiania",
    "ordering_by_webshop": "Zamówienie przez sklep internetowy",
    "ordering_by_email": "Zamówienie przez e-mail",
    "info_to_the_emailOrder": "Dodatkowe informacje o zamówieniu mailowym",
    "add_or_edit_foreignId": "Dodanie lub edycja numeru zamówienia strony trzeciej",
    "create_trackingLink": "Utwórz link śledzenia",
    "campaign": {
      "copy_edition": "Duplikat",
      "created_by": "Stworzony przez:",
      "no_edition": "Nie zredagowałeś jeszcze żadnego materiału reklamowego!",
      "configuration": "Opcje ogólne",
      "select_all": "Wszystkie produkty",
      "budget": "Budżet kampanii",
      "access": "Prawa dostępu",
      "inactive": "Kampania blokady",
      "delete": "Usunięcie kampanii",
      "order_all": "Zamówienie całej kampanii",
      "share": "Kampania informacyjna",
      "archive": "Kampania archiwalna",
      "recent_editions": "Ostatnia edycja",
      "marked_editions": "Oznakowane materiały reklamowe",
      "marked_campaigns": "Kampanie oznaczone",
      "own_campaigns": "Kampanie własne",
      "shared_editions": "Udostępnianie materiałów reklamowych",
      "last_edited": "Edytowane na:",
      "generated": "Stworzony na:",
      "edition_edit": "Rozpocząć pracę redaktora",
      "edition_item": "Wybrany produkt",
      "edition_configuration": "2. ustawienia",
      "edition_order": "Dodaj do koszyka",
      "edition_reorder": "Ponowne zamówienie",
      "ordered": "Zamówione!",
      "edition_delete": "Usuń",
      "edition_preview": "Podgląd",
      "edition_edit_alt": "Edytuj",
      "edition_error_empty": "Masz %s nieedytowanych stron",
      "new": "Utwórz nową kampanię",
      "back_to_list": "Wszystkie kampanie",
      "new_edition": "Tworzenie nowych materiałów reklamowych",
      "settings": "Zarządzaj kampanią",
      "campaign_archived": "Twoja kampania została zarchiwizowana",
      "successfully_archived": "Archiwizacja zakończona sukcesem",
      "save_settings": "Zapisz",
      "cancel_settings": "Anuluj",
      "title": "Nazwa kampanii",
      "edition_title": "Oznaczenie",
      "publisher": "Dane wydawcy.",
      "creator": "Kampania stworzona przez:",
      "editions": "Materiały reklamowe",
      "edition": "Materiały reklamowe",
      "sidebar": "Kampanie",
      "mark_edition": "Oznaczenie materiałów reklamowych",
      "unmark_edition": "Usunąć znacznik",
      "campaign_title_valid": "Prosimy o nadanie nazwy dla kampanii.",
      "campaign_publisher_valid": "Proszę wprowadzić dane dotyczące praw autorskich.",
      "choose_company_to_load_campaign": "Aby załadować kampanie, proszę wybrać firmę lub kliknąć przycisk \"Załaduj wszystkie kampanie\".",
      "no_product_selected": "Nie wybrano żadnego produktu",
      "new_edition_title": "Nowa edycja",
      "added_to_cart": "Twoja kampania została dodana do koszyka!",
      "edition_add_to_cart_title": "Produkt w koszyku",
      "edition_add_to_cart_button_label": "Świetnie",
      "edition_add_to_cart_label": "Do koszyka",
      "edition_added_to_cart_message": " został dodany do Twojego koszyka.",
      "edit_disabled": "Edycja edycji została tymczasowo wyłączona z powodu aktualizacji szablonu.",
      "export_image": "Eksportuj obraz",
      "unknown": "nieznany",
      "already_ordered": "To wydanie zostało już zamówione i nie może być już edytowane. Można jednak zduplikować edycję i ją edytować. Zobacz menu",
      "transfer_title": "Przeniesienie kampanii do innego użytkownika",
      "campaign_owner": "Właściciel kampanii",
      "campaign_creator": "Twórca kampanii",
      "change_owner": "Zmiana właściciela kampanii",
      "change_creator": "Zmień twórcę kampanii",
      "submission_item": "Wybrane zgłoszenie",
      "submissions": "Szablony",
      "modal_tabs": {
        "default_edition": "Ogólne materiały reklamowe",
        "edition_from_submission": "Materiały reklamowe z szablonu"
      }
    },
    "uom": {
      "piece": "Kawałek",
      "gram": "Gram",
      "kilogram": "Kilogram",
      "running_meter": "Licznik przebiegu",
      "liter": "Litry",
      "package": "Pakiet",
      "kilometer": "Kilometry"
    },
    "uom_symbole": {
      "gram": "g",
      "kilogram": "kg",
      "running_meter": "metr bieżący",
      "liter": "l",
      "package": "Pkt.",
      "kilometer": "km"
    },
    "pipelineViews": {
      "self": "Przypisany do mnie",
      "unassigned": "Bez przydziału",
      "pastdeadline": "Przekroczenie terminu",
      "duetoday": "Do zapłaty w dniu dzisiejszym"
    },
    "leadPriority": {
      "critical": "Krytyczny",
      "high": "High",
      "normal": "Normalna",
      "low": "Niski"
    },
    "orderTypes": {
      "item_sales": "Sprzedaż",
      "car_rent": "Wynajem samochodów",
      "car_sales": "Sprzedaż samochodów",
      "car_service": "Termin warsztatów"
    },
    "genderOptions": {
      "male": "Mężczyzna",
      "female": "Kobieta"
    },
    "salutationOptions": {
      "mr": "Pan",
      "mrs": "Pani"
    },
    "team_service": "Zespół serwisowy",
    "team_dispo": "Zespół ds. dyspozycji",
    "team_rent": "Zespół wynajmu",
    "team_sales": "Zespół sprzedaży",
    "car_documents": "Dokumenty pojazdu",
    "nav_module_chip": "Moduł / chip nawigacji",
    "safety_vest": "Kamizelka o wysokiej widoczności",
    "parking_disk": "Tarcza parkingowa",
    "ice_scraper": "Skrobaczka do lodu",
    "key_supplement_heating_taxis": "Dodatek do kluczy (ogrzewanie postojowe/ znak taksówkowy)",
    "shelf_blind": "Półka na kapelusze / roleta",
    "onboard_folder": "Teczka zarządu",
    "first_aid_kit": "Apteczka pierwszej pomocy",
    "warning_triangle": "Trójkąt ostrzegawczy",
    "tirefit_spare_wheel": "Wyposażenie w opony / koło zapasowe",
    "handover_damage": {
      "front": "Front",
      "back": "Tył",
      "left": "Linki",
      "right": "Prawo",
      "top": "Top",
      "interior": "Wnętrze"
    },
    "dark": "Jest ciemno",
    "garage": "W garażu",
    "snow_ice": "Śnieg / Lód",
    "rain_wet": "Pada deszcz / samochód jest mokry",
    "countries": {
      "de": "Niemcy",
      "pl": "Polska",
      "fr": "Francja"
    },
    "cookie_description": {
      "PHPSESSID": "Identyfikuje bieżącą sesję przeglądarki",
      "tempTarget": "Używamy tymczasowego docelowego pliku cookie do identyfikacji produktów, których szukasz i Twoich zainteresowań",
      "chedriCookiesBoxClosed": "Używamy tego pliku cookie, aby wskazać, że użytkownik widział i zaakceptował nasze informacje o plikach cookie.",
      "chedriCookiesPerformance": "Używane do określenia, czy użytkownik akceptuje nasze ciasteczka wydajnościowe",
      "chedriCookiesTargeting": "Używane do określenia, czy użytkownik akceptuje nasze targetujące pliki cookie",
      "ga": "Wykorzystywane do rozróżniania użytkowników w usłudze Google Analytics",
      "gid": "Wykorzystywane do rozróżniania użytkowników w usłudze Google Analytics",
      "act": "To jest plik cookie Facebooka używany do analiz i badań.",
      "c_user": "Facebook login dla logowań użytkowników w celu serwowania reklam bardziej dopasowanych do użytkowników i ich zainteresowań",
      "datr": "Używane przez Facebook do identyfikacji przeglądarki użytkownika",
      "fr": "Zawiera unikalny identyfikator przeglądarki i użytkownika, który jest wykorzystywany do celów reklamy ukierunkowanej",
      "sb": "Używane przez Facebook do ulepszania propozycji znajomych",
      "xs": "Plik cookie Facebooka używany do zarządzania sesją. Działa on w połączeniu z plikiem cookie c_user w celu uwierzytelnienia tożsamości użytkownika w serwisie Facebook"
    },
    "cookie_ttl": {
      "6_months": "6 miesięcy",
      "60_days": "60 dni",
      "2_years": "2 lata",
      "1_day": "1 dzień"
    },
    "upload_and_manage_media_files": "Tutaj możesz przesłać i zarządzać swoimi mediami.",
    "profile_information_avatar_contact_address": "Tutaj możesz edytować informacje o swoim profilu. Avatar, dane kontaktowe, adres rozliczeniowy, informacje finansowe.",
    "define_sales_points_address_position_map_opening_hours": "Zdefiniuj swoje punkty sprzedaży: Adres, położenie na mapie, godziny otwarcia. Ważne dla zarządzania produktami i pracownikami.",
    "check_incoming_and_outgoing_invoices_check_details_and_download_as_pdf": "Możesz sprawdzić faktury przychodzące i wychodzące wygenerowane przez system lub innych użytkowników. Zobacz szczegóły i pobierz w formacie PDF.",
    "found_api_interesting_personal_api_key_here": "Czy uważasz nasze API za interesujące? Chcesz to wypróbować? Swój osobisty klucz API możesz znaleźć tutaj.",
    "need_our_data_in_own_system_configure_data_push": "Czy potrzebujesz naszych danych we własnym systemie? Tutaj możesz skonfigurować usługi push danych, aby subskrybować zdarzenia danych.",
    "projects_running_on_different_domains": "Projekty działające w różnych domenach",
    "administration_of_your_website_logo_menu_pages": "Zarządzaj swoją stroną internetową. Logo, menu główne, strony systemowe",
    "create_users_manage_profile_financial_roles_teams": "Twórz użytkowników, którzy pracują w Twojej organizacji, zarządzaj ich profilem i informacjami finansowymi, przeglądaj i ustawiaj role bezpieczeństwa oraz przypisuj zespoły.",
    "import_users_via_csv": "Tworzenie użytkowników poprzez import pliku CSV",
    "import_users": "Importuj użytkownika",
    "create_update_teams_assign_system_types": "Twórz, edytuj zespoły, które znajdują się w Twojej organizacji. Przypisz typy systemów do swoich zespołów.",
    "create_document_types_use_for_process_automation": "Twórz własne typy dokumentów, dzięki czemu możesz je wykorzystać w integracjach lub do automatyzacji procesów.",
    "write_email_templates_send_to_clients": "Twórz szablony wiadomości e-mail, które mogą być używane podczas wysyłania wiadomości do klientów lub do automatyzacji niektórych przepływów pracy.",
    "define_reusable_cms_elements": "Zdefiniuj elementy wielokrotnego użytku, które mogą być używane na każdej stronie.",
    "manage_brands_edit_name_description": "Zarządzaj markami produktów, edytuj ich nazwy i opisy w wielu językach.",
    "manage_car_models_and_aliases": "Zarządzaj modelami samochodów, z których użytkownicy mogą wybierać. Zdefiniuj aliasy dla importu.",
    "display_and_manage_category_tree": "Przeglądaj i manipuluj drzewem kategorii. Można zmieniać nazwy i opisy.",
    "display_and_manage_product_templates": "Twórz i zarządzaj szablonami i pozwól użytkownikom na kreatywność.",
    "define_product_attributes_search_and_variants": "Zdefiniuj dodatkowe atrybuty, które możesz określić w swoich produktach. Użyj tych atrybutów, aby pomóc użytkownikom znaleźć produkty. Tworzenie wariantów produktów na podstawie atrybutów.",
    "group_attributes_to_better_manage_and_inform": "Możesz grupować atrybuty, aby lepiej zarządzać doświadczeniem użytkownika w backendzie i wyraźniej prezentować atrybuty przedmiotów swoim klientom.",
    "entity_fields_missing_add_new": "Jeśli brakuje Ci niektórych pól w Twoich formularzach, możesz je dodać tutaj. Przydatne w kampaniach marketingowych i integracjach.",
    "define_manage_pipelines_and_stages": "Zdefiniuj i dostosuj rurociągi do swoich przepływów pracy. Dodawanie, edytowanie, usuwanie etapów.",
    "create_questionnaires_for_workflows_and_campaigns": "Twórz kwestionariusze, które mogą być wykorzystywane w przepływach pracy lub różnych kampaniach marketingowych.",
    "catch_leads_from_other_sources_with_custom_email": "Wyłapuj leady z wielu źródeł dzięki naszemu Lead Catcherowi. Skonfiguruj indywidualne adresy e-mail dla każdego żądanego źródła.",
    "group_car_models_into_families_for_users_to_easily_find": "Grupuj modele pojazdów w rodziny, aby jeszcze bardziej ułatwić użytkownikom wyszukiwanie samochodów.",
    "enrich_car_search_functionality_with_own_model_images": "Wzbogać funkcję wyszukiwania samochodów o własne zdjęcia modeli. Przypisz zdjęcia do modeli lub grup modeli.",
    "tag_leads_with_custom_regular_expressions": "Rozszerz funkcjonalność naszego systemu tagów o niestandardowe tagi. Wymagana jest znajomość wyrażenia regularnego.",
    "unknown_error": "Wystąpił nieznany błąd",
    "username_required": "Wpisz swoją nazwę użytkownika",
    "email_required": "Proszę wpisać swój e-mail",
    "email_invalid": "E-mail jest nieprawidłowy",
    "client_name_required": "Proszę wpisać swoje imię i nazwisko",
    "password_required": "Proszę podać hasło",
    "password_length": "Hasło musi składać się z co najmniej 8 znaków",
    "repeat_password_required": "Proszę powtórzyć swoje hasło",
    "repeat_password_length": "Powtarzane hasło musi składać się z co najmniej 8 znaków",
    "message_required": "Proszę wpisać wiadomość",
    "second_password_incorrect": "Drugie hasło nie jest takie samo jak pierwsze",
    "registration_not_confirmed": "Twoja rejestracja nie została jeszcze potwierdzona. Proszę sprawdzić swoją skrzynkę pocztową i kliknąć przycisk, aby potwierdzić swój adres e-mail",
    "account_deleted": "To konto zostało usunięte!",
    "account_inactive": "Subskrypcja tego konta została zakończona!",
    "company_required": "Proszę wpisać nazwę firmy",
    "first_name_required": "Proszę wpisać imię",
    "last_name_required": "Proszę wpisać nazwisko",
    "country_required": "Proszę wybrać kraj",
    "phone_required": "Proszę wpisać numer telefonu",
    "street_required": "Proszę wpisać nazwę ulicy",
    "house_number_required": "Proszę wpisać numer domu",
    "zip_code_required": "Proszę wpisać kod pocztowy",
    "zip_code_invalid": "Kod pocztowy \"{{ wartość }}\" nie jest prawidłowym kodem pocztowym",
    "city_required": "Proszę wpisać nazwę miasta",
    "vat_id_required": "Proszę wpisać NIP",
    "timezone_required": "Proszę wybrać strefę czasową",
    "select_job": "Proszę wybrać stanowisko",
    "title_required": "Proszę wpisać tytuł",
    "type_required": "Proszę wybrać rodzaj",
    "location_required": "Proszę podać lokalizację",
    "questionnaire_required": "Proszę wybrać kwestionariusz",
    "subject_required": "Proszę wpisać temat",
    "amount_required": "Proszę wpisać kwotę",
    "time_count_required": "Proszę wpisać ilość czasu",
    "name_required": "Proszę wpisać nazwę",
    "price_required": "Proszę podać cenę",
    "description_required": "Proszę wprowadzić opis",
    "question_required": "Proszę wpisać pytanie",
    "content_required": "Proszę wprowadzić treść",
    "template_required": "Proszę wybrać szablon",
    "payment_schedule_required": "Proszę wybrać plan płatności",
    "answer_required": "Proszę wpisać odpowiedź",
    "website_required": "Proszę wpisać adres strony internetowej",
    "fax_required": "Proszę wprowadzić numer faksu",
    "currency_required": "Proszę wybrać walutę",
    "vat_name_required": "Proszę wpisać nazwę podatku VAT",
    "vat_id_name_required": "Proszę wpisać nazwę identyfikatora VAT",
    "vat_rates_required": "Proszę wpisać stawki VAT",
    "coc_number_required": "Proszę wpisać numer COC",
    "registered_at_required": "Proszę podać dane, pod którymi zarejestrowana jest Państwa firma",
    "bank_name_required": "Proszę wpisać nazwę banku",
    "account_holder_required": "Proszę wpisać pełną nazwę posiadacza rachunku",
    "account_number_required": "Proszę wpisać numer konta",
    "bank_location_required": "Proszę podać lokalizację banku",
    "bank_code_number_required": "Proszę wpisać kod banku",
    "iban_required": "Proszę wpisać IBAN",
    "min_message": "Ta wartość jest zbyt krótka. Powinien mieć {{ limit }} znaki lub więcej",
    "max_message": "Ta wartość jest zbyt długa. Powinien mieć {{ limit }} znaki lub mniej",
    "min_max_length": "Wartość ta powinna zawierać się pomiędzy {{ min }} a {{ max }}. znaki długie",
    "greater_than_or_equal": "Wartość ta powinna być większa lub równa {{ compared_value }}.",
    "price_type_invalid": "Typ ceny jest nieprawidłowy",
    "This value should not be blank": "Wartość ta nie powinna być pusta",
    "required_message": "Wartość ta nie może być pusta",
    "This value is not a valid URL": "Ta wartość nie jest prawidłowym adresem URL",
    "must_upload_a_file": "Musisz przesłać plik",
    "file_format_not_supported": "Plik, który chcesz przesłać nie jest obsługiwany",
    "category_not_empty": "Kategoria nie jest pusta",
    "brand_has_items": "Marka ma przypisane produkty",
    "template_has_items": "Produkty są przypisane do szablonu",
    "item_has_variants": "Produkt ma przypisane warianty",
    "no_valid_variant": "Nie jest to ważny wariant",
    "no_stage_set": "Nie ustalono poziomu",
    "no_pipeline_set": "Nie ustalono żadnego rurociągu",
    "no_users_found": "Nie znaleziono użytkowników",
    "no_team_set": "Żadna drużyna nie została obsadzona",
    "budget_required": "Proszę określić budżet",
    "client_required": "Proszę przypisać klienta",
    "order_required": "Proszę o przypisanie zamówienia",
    "item_required": "Proszę przypisać produkt",
    "document_required": "Proszę upewnić się, że dokumenty są dostępne i ważne",
    "brand_required": "Proszę wybrać markę",
    "model_required": "Proszę wybrać model",
    "order_type_invalid": "Nieprawidłowy typ zamówienia",
    "item_already_reserved": "Niektóre produkty nie są dostępne w wybrane dni",
    "wrong_credentials": "Twoja nazwa użytkownika lub hasło zostały wprowadzone nieprawidłowo. Spróbuj ponownie lub kliknij na \"Zapomniane hasło\".",
    "no_car_found": "Nie znaleziono pojazdu dla tego tropu",
    "data_push_event_invalid": "Zdarzenie pchania danych jest nieważne",
    "data_push_auth_invalid": "Typ uwierzytelniania Data push jest nieprawidłowy",
    "cart_type_invalid": "Typ koszyka jest nieprawidłowy",
    "system_type_invalid": "Typ systemu jest nieprawidłowy",
    "menu_version_invalid": "Wersja menu jest nieprawidłowa",
    "logo_version_invalid": "Wersja logo jest nieprawidłowa",
    "payment_method_invalid": "Nie mogliśmy przetworzyć podanej przez Ciebie metody płatności",
    "nationality_required": "Proszę wpisać swoją narodowość",
    "place_of_birth_required": "Proszę podać swoje miejsce urodzenia",
    "date_of_birth_required": "Proszę wpisać swoją datę urodzenia",
    "id_required": "Proszę podać identyfikator",
    "meta_identifier_required": "Proszę wybrać identyfikator",
    "payment_status_invalid": "Status płatności nie jest ważny",
    "iban_invalid": "Wprowadzona wartość nie jest prawidłowym numerem konta",
    "swift_bic_required": "Proszę wprowadzić prawidłowy numer SWIFT/BIC",
    "reference_required": "Proszę podać numer referencyjny",
    "service_status_invalid": "Status usługi nie jest ważny",
    "date_proposal_type_invalid": "Proponowany typ daty jest nieprawidłowy",
    "mobile_phone_invalid": "Numer telefonu komórkowego jest nieważny",
    "mobile_phone_required": "Proszę podać swój numer telefonu komórkowego",
    "phone_invalid": "Numer telefonu jest nieważny",
    "fax_invalid": "Numer faksu jest nieprawidłowy",
    "salutation_required": "Proszę wybrać pozdrowienie",
    "gender_required": "Proszę wybrać płeć",
    "stripe_error": "Błąd podczas łączenia się z Stripe",
    "stripe_connect_error_with_type": "Nie mogliśmy połączyć CreaCheck z Twoim kontem Stripe. Kod błędu: {typ}.",
    "car_rental_pickup_time_invalid": "Żądany czas odbioru jest poza godzinami otwarcia danej lokalizacji",
    "car_rental_drop_off_time_invalid": "Żądany czas podstawienia samochodu jest poza godzinami otwarcia placówki",
    "accept_terms_and_cancellation_before_continuing": "Prosimy o potwierdzenie, że zapoznali się Państwo z naszymi Ogólnymi Warunkami Handlowymi oraz polityką anulowania rezerwacji.",
    "problem_processing_your_credit_card": "Mamy problem z przetwarzaniem Twojej karty kredytowej",
    "invoice_type_invalid": "Typ faktury jest niepoprawny",
    "doc_number_required": "Proszę wpisać numer dokumentu",
    "doc_issuing_city_required": "Proszę wskazać miasto, które wydało decyzję",
    "doc_issuing_authority_required": "Proszę wskazać organ wydający",
    "doc_issue_date_required": "Proszę wpisać datę wydania",
    "doc_expiration_date_required": "Proszę wpisać datę ważności",
    "test_domain_required": "Proszę wprowadzić nazwę domeny testowej",
    "iban_has_wrong_format": "Format IBAN jest nieprawidłowy",
    "car_cash_payment_data_missing_or_invalid": "Brak danych dotyczących płatności gotówkowej lub są one nieważne",
    "car_registration_service_only_available_in_germany": "Usługa rejestracji jest obecnie dostępna tylko w Niemczech",
    "car_transport_only_available_in_germany": "Nasza usługa transportowa jest obecnie dostępna tylko w Niemczech",
    "target_type_invalid": "Nieprawidłowy typ celu",
    "company_email_must_be_different_from_users_email": "Adres e-mail firmy musi być inny niż adres e-mail użytkownika",
    "car_transport_distance_too_short": "Transport samochodowy jest możliwy tylko w miejscach oddalonych o ponad 100 km",
    "first_offer_price_too_low": "Twoja pierwsza oferta jest zbyt niska i nie została przyjęta",
    "first_offer_price_too_high": "Twoja pierwsza oferta jest wyższa niż pierwotna cena i nie została przyjęta",
    "current_offer_too_low": "Twoja obecna oferta jest zbyt niska",
    "not_your_turn_to_negotiate_the_price": "Nie możesz teraz zaktualizować swojej oferty. Proszę czekać na odpowiedź od naszego pracownika",
    "the_question_must_be_answered": "Należy odpowiedzieć na pytanie \"{{ pytanie }}\"",
    "validation_problems_with_item_attributes": "Sprawdź, czy atrybuty są prawidłowo wypełnione. Występujące problemy są zaznaczone na czerwono",
    "the_field_name_contains_following_errors": "Pole {fieldName} zawiera następujący błąd: {helpText}",
    "plugin_required": "Proszę wybrać plan abonamentowy.",
    "invalidRegex": "Podane wyrażenie regularne jest nieprawidłowe",
    "assignment_strategy_type_invalid": "Typ strategii przypisania jest nieprawidłowy",
    "cannot_remove_role_company": "Nie można usunąć roli użytkownika ROLE_COMPANY",
    "coupon_type_invalid": "Proszę wybrać ważny rodzaj bonu",
    "subscription_starting_fee": "Abonamentowa opłata wstępna",
    "comms_center_monthly_fee": "Centrum Komunikacji w Creacheck",
    "comms_center_chat": "Centrum Komunikacji Creacheck - Czat Klienta",
    "comms_center_call": "Centrum Komunikacji Creacheck - Rozmowa z klientem",
    "0": "<strong>Error podczas logowania</strong>.",
    "You are not authenticated": "Niestety nie znamy maila i hasła",
    "access_denied": "Aby się zalogować, musisz zaakceptować dostęp dla Creacheck.com",
    "oauth_email_missing": "Nie możemy zalogować Cię przez media społecznościowe. Prosimy o zalogowanie się za pomocą adresu e-mail.",
    "User already exists": "Wprowadzony przez Ciebie adres e-mail istnieje już w naszej bazie danych. Zapomniałeś hasła?",
    "next": "Więcej",
    "create_comment": "Napisz komentarz",
    "new_pipeline": "Nowy rurociąg",
    "new_stage": "Nowy poziom",
    "quantity": "Ilość",
    "login_error": "Błąd podczas logowania",
    "not_found": "Nie znaleziono",
    "deal_information": "Informacje o umowie",
    "login_domain": "Domena logowania",
    "login_domain_successfully_changed": "Domena logowania została pomyślnie zmieniona.",
    "missing_lead_information": "Proszę podać brakujące informacje o ołowiu",
    "missing_informations": "Brakujące informacje",
    "missing_client_signature": "Brak podpisu klienta",
    "previous": "Wcześniej",
    "current": "Aktualne",
    "customCssInvalid": "Niestandardowy CSS jest nieprawidłowy ({{ błąd }})",
    "accountAndLogin": "Konto i logowanie",
    "invalidEIN": "Nieważny numer eVB (elektroniczne potwierdzenie ubezpieczenia)",
    "radio": "Radio",
    "airConditioning": "Klimatyzacja",
    "parkingAssistanceRear": "System wspomagania parkowania tyłem",
    "airConditioningAutomatic": "Klimatyzacja automatyczna",
    "navigation": "Navi",
    "alloyRims": "Felgi aluminiowe",
    "parkingAssistanceFrontRear": "System wspomagania parkowania z przodu i z tyłu",
    "metallicPaint": "Lakier metaliczny",
    "cruiseControl": "Tempomat",
    "seatHeating": "Ogrzewanie siedzeń",
    "leatherSeats": "Siedzenia skórzane",
    "equipmentLevel": "Poziom wyposażenia",
    "motorPower": "Power",
    "currentLocation": "Aktualna lokalizacja",
    "distance": "Odległość",
    "selected": "wybrane",
    "noBrandSelected": "Nie wybrano żadnej marki",
    "showMore": "Pokaż więcej",
    "showLess": "Pokaż mniej",
    "optional": "Opcjonalnie",
    "altogether": "Razem",
    "monday": "Poniedziałek",
    "tuesday": "Wtorek",
    "wednesday": "Środa",
    "thursday": "Czwartek",
    "friday": "Piątek",
    "saturday": "Sobota",
    "sunday": "Niedziela",
    "payment_data_missing_or_invalid": "Brak danych dotyczących płatności lub są one nieważne",
    "previousSearchRequests": "Poprzednie poszukiwania",
    "reset": "Reset",
    "number_days": "{dni, liczba mnoga, zero {# dni} jeden {# dzień} inne {# dni}}",
    "number_months": "{miesiące, liczba mnoga, zero {# miesięcy} jeden {# miesięcy} inne {# miesięcy}}",
    "outdated_browser": "Twoja przeglądarka jest nieaktualna!",
    "update_browser_text": "Proszę zaktualizować swoją przeglądarkę, aby poprawnie wyświetlała tę stronę.",
    "update_browser_btn_text": "Zaktualizuj przeglądarkę teraz",
    "save_successfully": "Zapisano pomyślnie",
    "add_quickly": "Dodaj szybko",
    "load_data": "Dane dotyczące obciążenia",
    "car_data_import_vin_info": "Wprowadź prawidłowy numer VIN, aby automatycznie wypełnić formularz danych pojazdu.",
    "car_data_import_missing_attr_values": "Brakuje niektórych wartości atrybutów - są one zaznaczone w formularzu.",
    "vin_invalid": "FIN jest nieważny",
    "others": "Inne",
    "activate_plugin_to_enable_feature": "Ta funkcja jest dostępna tylko z następującą wtyczką. Aktywuj wtyczkę, aby nadal korzystać z tej funkcjonalności.",
    "car_data_import_failed": "Import danych pojazdu nie był możliwy dla tego numeru VIN. Sprawdź, czy podany numer VIN jest prawidłowy.",
    "send_mail_via_outlook": "E-mail jest wysyłany przy użyciu konta Microsoft Outlook ({email}) i jest później dostępny w folderze \"Wysłane\".",
    "permission_required": "Wymagane pozwolenia",
    "phone_call_permissions_required": "Ta aplikacja musi mieć dostęp do kont telefonicznych, aby wykonywać połączenia.",
    "calling": "Zadzwoń do mnie",
    "callingTo": "Zadzwoń do",
    "startingCall": "Inicjowanie połączenia",
    "callEnded": "Połączenie zakończone",
    "inCall": "'W wezwaniu",
    "callCancelled": "Połączenie anulowane",
    "callRejected": "Połączenie odrzucone",
    "is_calling": "%name% wzywa...",
    "contacts": "Kontakty",
    "addresses": "Książka adresowa",
    "chat": "Czat",
    "calls": "Połączenia",
    "endCustomerNewMessage": "Wiadomość od nowego klienta",
    "returnToTheActiveCall": "Powrót do aktywnego połączenia",
    "agentStatus": "Status agenta",
    "switchOnAgentNote": "Aktywuj akceptowanie czatów i połączeń wideo od klientów",
    "switchOffAgentNote": "Wyłącz, aby nie akceptować czatów klientów i połączeń wideo",
    "activateAgent": "Aktywuj akceptację czatów klientów",
    "deactivateAgent": "Wyłączenie akceptacji czatów klientów",
    "startAudioCallWith": "Rozpocznij rozmowę telefoniczną od {{do}}",
    "startVideoCallWith": "Rozpocznij połączenie wideo za pomocą {{do}}",
    "terms_and_conditions": "Zasady i warunki",
    "form_incorrect_data": "Wprowadzone dane nie są poprawne. Prosimy o sprawdzenie swoich zgłoszeń i ponowne wysłanie ich.",
    "accept_terms_and_condition_start_chat": "Klikając na \"Rozpocznij czat\", akceptujesz warunki i zasady",
    "start_chat": "Rozpocząć czat",
    "connecting_with": "Połącz się z",
    "connected_with": "Połączony z",
    "do_calling": "wzywa",
    "chat_inactivity_warning": "Czat był zbyt długo nieaktywny i wkrótce zostanie zamknięty.",
    "get_in_contact_with_us": "Skontaktuj się z nami",
    "no_agent_available": "Niestety, żaden z agentów nie jest online. Proszę zostawić wiadomość, a my skontaktujemy się z Państwem tak szybko, jak to możliwe.",
    "hello": "Witam!",
    "we_are_here_for_you": "Jesteśmy tu dla Ciebie i czekamy na Twoje pytania lub opinie.",
    "start_conversation": "Rozpocząć rozmowę",
    "welcome_customer": "Nazywam się {firstName} {lastName}. Jak mogę ci pomóc?",
    "end_chat": "Wyjście",
    "send_request": "Wyślij wniosek",
    "checkout_payment_agreement": "Wyrażam zgodę na rozpoczęcie przez {firmę} świadczenia usług dodatkowych przed rozpoczęciem okresu rezygnacji i rozumiem, że utracę prawo do rezygnacji z usług po ich całkowitym wykonaniu.",
    "checkout_buy_order_legal_text": "Do zakupu mają zastosowanie {ogólne_terminy_i_warunki} oraz {polityka_i_formularz_odwołania} firmy} ({privacy_policy}).",
    "checkout_services_terms_cancelation_legal_text": "Dla zarezerwowanych usług dodatkowych ({booked_services}) obowiązują {ogólne_terminy_i_warunki} oraz {polityka_i_formularz_anulacyjny} firmy {company} ({privacy_policy}).",
    "no_credit_cards": "Brak kart kredytowych",
    "minimize_video": "Zminimalizuj widok wideo",
    "maximize_video": "Maksymalne wykorzystanie widoku wideo",
    "enable_fullscreen": "Aktywuj tryb pełnoekranowy",
    "disable_fullscreen": "Wyłączenie trybu pełnoekranowego",
    "enable_screensharing": "Podziel się pulpitem",
    "disable_screensharing": "Zakończenie udostępniania pulpitu",
    "mute_microphone": "Wyciszenie mikrofonu",
    "unmute_microphone": "Wycisz mikrofon",
    "enable_camera": "Włączenie kamery",
    "disable_camera": "Wyłączyć kamerę",
    "end_call": "Zakończ połączenie",
    "end_videocall": "Zakończenie strumienia wideo",
    "muted": "Wyciszony",
    "overall_feedback": "Jak oceniasz swój kontakt z nami?",
    "connection_quality_feedback": "Jak oceniasz jakość połączenia?",
    "send_feedback": "Wyślij informację zwrotną",
    "customer_chat_ended_info": "Twój czat został zakończony.",
    "checking_connection": "Połączenie jest sprawdzane",
    "call_again": "Zadzwoń ponownie",
    "end_call_local_disconnected": "Zakończenie połączenia z powodu problemów z połączeniem",
    "end_call_remote_disconnected": "Zakończenie połączenia z powodu problemów z połączeniem na stronie {remoteUserName}",
    "network_disconnected_warning": "Obecnie nie ma połączenia z internetem.",
    "network_disconnected": "Połączenie przerwane",
    "network_want_reconnect": "Twoje połączenie zostało przerwane. Czy chciałbyś nawiązać ponowne połączenie?",
    "leave_as_an_email_message": "Zostaw nam wiadomość e-mail",
    "continue_call": "Kontynuuj połączenie",
    "continue_text_chat": "Wznowienie czatu tekstowego",
    "continue_conversation": "Kontynuuj rozmowę",
    "disconnected": "Oddzielnie",
    "disconnect_reason": "Możliwa przyczyna",
    "disconnect_reason_transport_close": "Opuść stronę",
    "disconnect_reason_ping_timeout": "Brak połączenia z Internetem",
    "customer_may_return": "Klient może wrócić w najbliższym czasie.",
    "mobile": "Telefon komórkowy",
    "headquarter": "Centralny",
    "extension-number": "Numer wewnętrzny",
    "add_contact": "Dodaj kontakt",
    "add_address": "Dodaj adres",
    "choose_contact": "Wybierz kontakt",
    "number": "Numer",
    "new_number": "Nowy numer",
    "address_mail": "Adres pocztowy",
    "address_delivery": "Adres dostawy",
    "address_invoice": "Adres faktury",
    "new_address": "Nowy adres",
    "find_address": "Znajdź adres",
    "searching": "Szukaj...",
    "address_change": "Zmiana adresu",
    "address_ask_change": "Zmiana tego adresu wpływa na wszystkie kontakty z tym adresem. Czy chcesz zmienić adres?",
    "designation": "Oznaczenie",
    "net": "Netto",
    "gross": "Gross",
    "exp_delivery_time": "vsl. czas dostawy",
    "workdays": "Dni robocze",
    "special_offer": "Działanie",
    "transportation_cost": "Koszty wysyłki",
    "discount": "Rabat",
    "total": "Razem",
    "total_gross": "Razem (z VAT)",
    "product_details": "Szczegóły produktu",
    "type_of_order": "Rodzaj zamówienia",
    "type_of_order_choices": "Regularne drukowanie lub pobieranie danych do druku w formie pliku PDF",
    "type_of_order_website": "Udostępnianie niniejszej strony internetowej",
    "print_production": "Produkcja druków",
    "pdf_download": "pobranie PDF",
    "website_upload": "Załaduj stronę",
    "production_time": "Czas produkcji",
    "production_time_description": "Proszę wybrać żądaną opcję",
    "production_standard": "Produkcja standardowa",
    "production_express": "Produkcja ekspresowa",
    "production_overnight": "Produkcja z dnia na dzień",
    "choose_edition": "Wydanie wybrane",
    "choose_edition_description": "Edycje z cenami warstwowymi. Rabaty i promocje są wyróżnione, jeśli są dostępne.",
    "more_options": "Więcej możliwości",
    "more_options_description": "Dodaj więcej opcji do swojego zamówienia.",
    "manual_data_review": "Ręczna kontrola danych (w tym ubezpieczenie)",
    "manual_item_entry": "Ręczne wprowadzanie pozycji",
    "web_enabled_pdf": "Dane do druku dodatkowo otrzymywane są jako PDF kompatybilny z internetem.",
    "cart_production_type_change_warning_title": "Obieg jest regulowany",
    "cart_production_type_change_warning": "Wybrane wydanie nie jest dostępne dla {{shippingType}}. Zostanie on zmieniony na maksymalną dostępną edycję. Czy na pewno chcesz kontynuować?",
    "cart_no_warranty_without_manual_data_check": "Uwaga: Nie wybrano ręcznego sprawdzania danych.",
    "campaign_budget_exceed_warning": "Budżet kampanii przekroczony. Wymagana zgoda!",
    "user_budget_exceed_warning": "Przekroczony budżet użytkownika. Potrzebne zwolnienie!",
    "order_quantity": "Ilość zamówienia",
    "data_check": "Kontrola danych",
    "split_shipping": "Dostawa częściowa",
    "cart_not_logged_in": "Brak zalogowanego użytkownika",
    "cart_contact_or_address_not_found_invoice": "Proszę wybrać adres do faktury",
    "cart_contact_or_address_not_found_shipping": "Proszę wybrać adres dostawy",
    "cart_edtion_item_or_variant_not_found": "Nie znaleziono wydania, artykułu lub wariantu",
    "cart_no_print_type_found": "Nie znaleziono rodzaju druku",
    "cart_print_type_invalid": "Nieprawidłowy typ wydruku:",
    "cart_no_shipping_type_found": "Nie znaleziono metody wysyłki",
    "cart_checkout_info_missing": "Brakuje informacji o polu wyboru:",
    "cart_reduced_vat_rate_check_not_supported": "Prośba o sprawdzenie obniżonej stawki VAT dla pozycji, która jej nie obsługuje:",
    "cart_no_price_found": "Nie można było znaleźć ceny",
    "cart_price_mismatch": "Cena nie odpowiada cenie, którą przedstawiliśmy użytkownikowi",
    "cart_web_pdf_price_mismatch": "Cena PDF na stronie internetowej nie odpowiada cenie, którą przedstawiliśmy użytkownikowi",
    "cart_contact_or_address_not_found_split_shipping": "Proszę wybrać adres do wysyłki dzielonej",
    "cart_quantity_not_found_split_shipping": "Nie znaleziono parametru ilości dla wysyłki dzielonej",
    "cart_split_shipping_quantity_mismatch": "Przypisana ilość wysyłkowa nie odpowiada ilości produkcyjnej",
    "cart_coupons_mismatch": "Użyte kupony nie pasują do siebie",
    "cart_coupon_cant_be_used": "Żądany kupon stracił ważność lub nie może być użyty.",
    "cart_coupon_value_mismatch": "Wartość kuponu jest nieprawidłowa",
    "cart_camaign_budget_processing_error": "Wystąpił nieoczekiwany problem podczas przetwarzania budżetu kampanii",
    "cart_campaign_budget_has_changed": "Budżet kampanii uległ zmianie",
    "cart_user_budget_has_changed": "Budżet użytkownika uległ zmianie",
    "cart_user_budget_processing_error": "Podczas przetwarzania budżetu użytkownika wystąpił nieoczekiwany problem",
    "cart_domain_not_active": "Domena nie jest aktywna",
    "cart_missing_desired_domain": "Brakuje specyfikacji pożądanej domeny",
    "lead_monitor_order_payment_receipt": "Monitorowanie płatności przychodzących",
    "lead_format_message_description_route53_register_domain": "Zarejestruj domenę {0} i przekieruj do {1}.",
    "lead_title_route53_register_domain": "Zarejestruj domenę AWS",
    "domain_not_available": "Domena niedostępna",
    "invoice_payment_option": {
      "enabled": "Aktywuje",
      "disabled": "Niepełnosprawni",
      "inherited": "Dziedziczone",
      "title": "Zapłata faktury",
      "loading": "Załaduj odziedziczone ustawienie",
      "effective_setting": "skuteczne dostosowanie"
    },
    "remind_period": {
      "days": "Dni",
      "inherited_setting": "Ustawienie dziedziczone",
      "title": "Termin płatności faktury Termin przypomnienia"
    },
    "sellDownloadPdf": "Download Sell PDF",
    "success_management": {
      "title": "Zarządzanie sukcesem",
      "manager": "Menedżer sukcesu",
      "switch_title": "Aktywuj wspomnienia z ostatniego widzenia",
      "interval": "Ostatnio oglądany okres, dni",
      "last_seen": "Last seen",
      "error_no_self": "Nie można przypisać siebie jako menedżera sukcesu",
      "error_no_same_parent": "Success Manager musi być podporządkowany innej firmie"
    },
    "cart_edition_title": "Oznaczenie:",
    "cart_recent_edition": "Ostatnio edytowane:",
    "cart_campaign_title": "Kampania:",
    "cart_last_saved": "Ostatnio zapisany:",
    "remove_item": "Usunąć produkt",
    "config": "Skonfiguruj",
    "submit_config": "Potwierdzenie konfiguracji",
    "complete_order": "Kompletne zamówienie",
    "payment_method_description": "Proszę wybrać żądaną metodę płatności",
    "cart_hint": "Podpowiedź:",
    "cart_hint_description_part_1": "Proszę wpisać tutaj tylko ogólne uwagi. Uwagi dotyczące produktów mogą być uwzględnione tylko wtedy, gdy wybrano opcję",
    "cart_hint_description_part_2": "Ręczne sprawdzanie danych",
    "cart_hint_description_part_3": "i wpisał komentarz dla danego produktu.",
    "your_message": "Twoja wiadomość dla nas",
    "hint_dataproof_1": "Zrezygnowałeś z ręcznego sprawdzania danych przez naszego eksperta dla jednej lub więcej pozycji.",
    "hint_dataproof_2": "Zwracamy uwagę, że w tym przypadku sam ponosisz pełną odpowiedzialność za swój projekt. W przypadku błędów w danych, nieprawidłowych kolorów na zdjęciach itp. reklamacja jest wykluczona. Obowiązują nasze OWU.",
    "hint_dataproof_3": "Jeśli zdecydujesz się na ręczne sprawdzenie danych, Twój plik zostanie sprawdzony przez eksperta pod kątem ewentualnych błędów (sprawdzenie techniczne, nie prawne). W przypadku przeoczenia błędu, bierzemy na siebie odpowiedzialność. Bez ryzyka dla Ciebie!",
    "hint_missing_order_quantity": "Brak ilości zamówienia!",
    "missing_order_quantity": "Nie wybrano ilości zamówienia dla jednej lub więcej pozycji.",
    "no_invoice_address": "Nie utworzono adresu rozliczeniowego",
    "no_delivery_address": "Nie utworzono adresu dostawy",
    "use_invoice_contact": "Użyj kontaktu w sprawie rozliczeń",
    "order_item": "Artykuł",
    "order_price": "Cena",
    "order_copies": "Wydanie",
    "order_totals": "Sumy zamówień",
    "subtotal": "Suma cząstkowa",
    "invoice_amount": "Kwota faktury",
    "remainder_available": "Niepodzielona pozostała ilość dostępna",
    "reduce_edition": "Aby dodać nowy adres, należy najpierw zmniejszyć nakład poprzedniego adresu.",
    "split_delivery_item_hint": "Podział całkowitej ilości nie został jeszcze zakończony. Ilość musi być wartością pomiędzy 1 a pozostałą ilością do rozdysponowania lub nakładem; obecnie jest to wartość co najwyżej",
    "number_of_copies": "Wydanie",
    "custom_font_folder": "Wybierz katalog czcionek",
    "custom_font": "Prześlij własną czcionkę",
    "disable_group_label": "Opcje grupowe",
    "disable_group_info_text": "Tutaj możesz zdefiniować grupy, które wzajemnie się wykluczają. np. P#Grupa1,Grupa2 i D#Grupa2,Grupa1. Parametry definicji - P = ważne dla strony, D = ważne dla dokumentu.",
    "is_client_registration_allowed": "Aktywacja rejestracji",
    "is_email_validation_enabled": "Zatwierdzenie wiadomości e-mail",
    "email_validation_pattern": "Regex dla walidacji wiadomości e-mail",
    "confirmation_email_cc": "CC dla potwierdzenia rejestracji",
    "client_registration_title": "Ustawienia rejestracji",
    "registration_fields_show": "Pola wyświetlacza",
    "registration_fields_require": "Pola obowiązkowe",
    "cart_domain_not_available": "Żądana domena nie jest dostępna",
    "cart_domain": "Pożądana domena",
    "cart_is_available": "jest dostępny",
    "cart_is_not_available": "nie jest dostępny",
    "cart_edit_now": "Edytuj teraz",
    "cart_budget_campaign": "Ta edycja jest częścią kampanii budżetowej.",
    "cart_remaining_campaign_budget": "Pozostały budżet kampanii",
    "cart_remaining_campaign_budget_after_order": "Pozostałość po zamówieniu",
    "cart_budget_user": "Dla użytkownika ustalany jest budżet.",
    "cart_ramaining_user_budget": "Pozostały budżet użytkownika",
    "cart_remaining_user_budget_after_order": "Pozostałość po zamówieniu",
    "cart_order_check": "Zlecam sprawdzenie, czy ten produkt kwalifikuje się do obniżonej stawki VAT. Zapoznałem się z <a href='#'>warunkami</a> w tym zakresie i potwierdzam, że akceptuję je wraz z zamówieniem.",
    "categoryitems_customer": "Klient",
    "categoryitems_template": "Szablon",
    "cart_split_delivery_address_already_used": "Wybrany adres jest już używany do doręczeń",
    "cart_split_delivery_title": "Oznaczenie",
    "cart_split_delivery_campaign": "Kampania",
    "cart_split_delivery_add_delivery_address": "Dodaj adres dostawy",
    "accept_terms_of_use_before_continuing": "Zanim przejdziesz dalej, musisz zaakceptować nasze warunki użytkowania",
    "provisionDoc": {
      "provision": "Komisja",
      "provision_calculation": "Obliczanie prowizji",
      "client": "Klient",
      "invoice_no_date": "Nr faktury / data",
      "payedDate": "Wypłacone w dniu",
      "serviceType": "Rodzaj usługi",
      "amount": "Kwota",
      "provisionRate": "Stawka prowizji",
      "provisionValue": "Komisja",
      "totalAmount": "Kwota ogółem",
      "provisions": "Komisje",
      "provision_for": "Komisja ds.",
      "download_pdf": "Pobierz PDF"
    },
    "provision_service": "Usługi zarezerwowane",
    "provision_service_description": "Tutaj możesz tworzyć, edytować lub usuwać nowe typy usług",
    "provision_service_title": "Tytuł",
    "provision_service_type": "Nazwa",
    "provision_service_description_text": "Opis",
    "provision_service_primary_rate": "Prowizja w procentach za prim. Właściciel",
    "provision_service_secondary_rate": "Prowizja w procentach dla właściciela sek.",
    "provision_service_type_status": "Status",
    "add_provision_type": "Dodaj typ prowizji",
    "edit_provision_type": "Edytuj",
    "create_provision_type": "Utwórz typ prowizji",
    "service_type_onboarding": "Onboarding (instalacja)",
    "service_type_subscriptions": "Subskrypcje (MRR, subskrypcje i opłaty dla użytkowników)",
    "service_type_additional_services": "Usługi dodatkowe (szablony)",
    "service_type_product_sales": "Sprzedaż produktów",
    "sales": "Dystrybucja",
    "primary_owner": "Właściciel główny",
    "secondary_owner": "Drugi właściciel",
    "provision_start": "Start",
    "provision_ending": "Koniec",
    "provision_actions": "Działania",
    "add_provision_service": "Utwórz prowizję",
    "edit_provision_service": "Prowizorka montażowa",
    "save_provision_type": "Zapisz",
    "prov_service_client_name": "Nazwa",
    "provision_service_documents": "Komisje",
    "commission_service_documents": "Prowizje - Dokumenty",
    "assign_service_type": "Przypisanie nowego typu usługi",
    "provision_service_documents_description": "Tutaj możesz zobaczyć wszystkie prowizje",
    "provision_service_documents_download": "Pobierz dokumenty",
    "provision_service_documents_download_start": "Pobierz",
    "provision_service_documents_name": "Nazwa",
    "provision_service_documents_title": "Tytuł",
    "provision_service_documents_description_text": "Opis",
    "provision_service_documents_serviceType": "Typ",
    "provision_service_documents_provisionRate": "Stawka prowizji",
    "provision_service_documents_provisionValue": "Wartość prowizji",
    "provision_service_documents_provisionAssignee": "Odbiornik",
    "provision_service_documents_provisionPayedDate": "Wypłacone w dniu",
    "provision_service_documents_IsActive": "Status",
    "provision_service_documents_Client": "Klient",
    "provision_service_documents_choose_month": "Proszę wybrać żądany miesiąc",
    "commission_service_documents_description": "Tutaj możesz zobaczyć i pobrać wszystkie faktury i szczegóły dotyczące prowizji",
    "commission_service_documents_download": "Pobierz dokumenty",
    "commission_service_documents_download_start": "Pobierz",
    "commission_client": "Klient",
    "commission_invoice_no": "Numer faktury",
    "commission_payed_data": "Wypłacone w dniu",
    "commission_service_type": "Rodzaj usługi",
    "commission_amount": "Kwota",
    "commission_provision": "Komisja",
    "subscription_settings": "Subskrypcje",
    "client_subscription_settings": "Klienci i subskrypcje produktów",
    "subscription_settings_description": "Tutaj możesz stworzyć podstawową subskrypcję i przypisać jej typ",
    "client_subscription_settings_description": "Tutaj można przypisać abonament podstawowy do klienta lub artykułu w zależności od rodzaju i dostosować ceny.",
    "subscriptions_": "Subskrypcje",
    "subscription_name": "Nazwa",
    "subscription_title": "Tytuł",
    "subscription_description": "Opis",
    "subscription_fee": "Opłata",
    "subscription_startingFee": "Opłata za wejście (opcjonalnie)",
    "subscription_start": "Start",
    "subscription_end": "Koniec",
    "subscription_status": "Status",
    "subscription_action": "Działania",
    "subscription_items": "Produkty",
    "subscription_clients": "Klienci",
    "subscription_companies": "Firmy",
    "subscription_basic": "Podstawowa subskrypcja",
    "add_subscription": "Dodaj subskrypcję",
    "create_subscription": "Utwórz subskrypcję",
    "edit_subscription": "Oszczędzaj na subskrypcji",
    "subscription_language": "Wybór języka",
    "period_status": "Dezaktywacja na koniec okresu",
    "subscription_edit": "Edytuj",
    "omit_subscription_fee": "Pominięcie opłaty startowej",
    "invoice_email": "Adres e-mail dla faktur",
    "display_and_manage_products": "Zarządzaj swoimi produktami lub dodaj nowe produkty tutaj. Wymagane połączenie z wiadomościami",
    "copy": "Kopia",
    "order_processing_contract": "Umowa o realizację zamówienia",
    "accept_order_processing_contract_before_continuing": "Przed przystąpieniem do realizacji zamówienia należy wyrazić zgodę na naszą umowę dotyczącą realizacji zamówienia.",
    "subscription_clients_and_companies": "Klienci i firmy",
    "save_subscription": "Zapisz",
    "go_to": "Idź do",
    "no_invoices_to_display": "Brak rachunków do wyświetlenia",
    "url_settings": "Ustawienia Url",
    "no_image_title": "Nie znaleziono tytułu obrazu. Kliknij tutaj, aby edytować.",
    "no_image_description": "Nie znaleziono opisu obrazu. Kliknij tutaj, aby edytować",
    "no_image_copyright": "Nie znaleziono informacji o prawach autorskich. Kliknij tutaj, aby edytować",
    "no_text": "Nie znaleziono tekstu. Kliknij tutaj, aby edytować",
    "update_notification": "Zarządzanie aktualizacją",
    "update_notification_description": "Opis",
    "update_notification_settings_description": "Tutaj możesz zarządzać powiadomieniami o aktualizacjach",
    "update_name": "Nazwa",
    "update_notification_meta": {
      "title": "Zarządzanie aktualizacją",
      "description": "Zarządzaj swoimi powiadomieniami o aktualizacjach tutaj",
      "name": "Zarządzanie aktualizacją"
    },
    "new_update_notification": "Tworzenie nowych powiadomień o aktualizacjach",
    "update_from": "z",
    "update_to": "do",
    "edit_update_notification": "Edycja Powiadomienie o aktualizacji",
    "individual_prices": "Ceny indywidualne",
    "alternative_recepient": "Alternatywny odbiornik",
    "enter_email_address": "Proszę wpisać prawidłowy adres e-mail",
    "countries_for_prices": {
      "de": "Niemcy",
      "ch": "Szwajcaria",
      "at": "Austria",
      "es": "Hiszpania"
    },
    "choose_country": "Proszę wybrać kraj",
    "product_groups": "Grupy produktów - Dostawcy",
    "product_groups_description": "Tutaj można zarządzać grupami produktów dostawców",
    "new_product_group": "Dodaj nową grupę produktów",
    "edit_product_group": "Edytuj",
    "create_product_group": "Utwórz",
    "product_group_number": "Numer grupy produktów",
    "save_product_group": "Zapisz",
    "template_pdf_profile_x3": "Create PDF in X-3 format",
    "product_group_actions": "Działania",
    "product_group_status": "Status",
    "hide_preview": "Wyłączenie podglądu w edytorze",
    "editor_settings": "Edytor ustawień",
    "share_edition": "Podziel się wydaniem",
    "canceled_quote": "Oferta odrzucona",
    "active_quote": "Oferta w toku",
    "internal_status": "Status wewnętrzny",
    "edit_quote": "Oferta redakcyjna",
    "copy_quote": "Oferta kopiowania",
    "open_lead": "Open Lead",
    "manual_quote_status": "Status ofert",
    "invalid_manual_quote_status": "Nieważny status oferty",
    "error_loading_paypal_scripts": "Skrypty PayPal nie mogły zostać załadowane. Proszę zamknąć to okienko i otworzyć je ponownie.",
    "missing_invoice_shipping_address": "Falta la dirección de facturación o de entrega. Por favor, seleccione una dirección.",
    "paypal_buttons_loading": "Załaduj przyciski PayPal...",
    "please_wait_saving_order": "Zapisz zamówienie. Proszę czekać...",
    "upload_pdf": "Upload and link PDF",
    "upload_pdf_title": "PDF Upload",
    "upload_pdf_status_done": "Twój plik PDF został pomyślnie załadowany",
    "upload_pdf_status_error": "Przesyłanie plików PDF nie powiodło się.",
    "check_your_email_to_confirm": "Proszę sprawdzić swoją pocztę elektroniczną, aby potwierdzić, że ten formularz kontaktowy został wysłany.",
    "contact_form_confirm": {
      "success": {
        "heading": "Twój wniosek został wysłany",
        "body": "<p>Dziękujemy bardzo za kontakt z nami!</p><p>Otrzymaliśmy Twoje zapytanie i skontaktujemy się z Tobą tak szybko, jak to możliwe.</p>."
      },
      "already_confirmed": {
        "heading": "Wniosek ten został już potwierdzony",
        "body": "<p>Otrzymaliśmy Twoją prośbę i skontaktujemy się z Tobą tak szybko jak to możliwe.</p>."
      },
      "not_found": {
        "heading": "Nie znaleziono",
        "body": "<p>Upewnij się, że kliknąłeś na przycisk w naszym mailu, aby się tu dostać.</p>."
      }
    },
    "placeholder_upload_error": "Podczas przesyłania wystąpił problem!",
    "linkedin_insight_tag": "LinkedIn Insight Tag",
    "linkedin_partner_id": "Partner Id",
    "tracking_pixel": "Piksel śledzący np. Meta Piksel",
    "jsWebsite": "Javascript",
    "tracking_pixel_data": "Źródło i parametry",
    "upload_website_favicon": "Favicon",
    "upload_website_favicon_label": "Przesyłanie i podgląd obrazów",
    "upload_website_favicon_info": "Uwaga!!! Wymagany format pliku to PNG. Optymalna rozdzielczość wynosi od 32 x 32px do maksymalnie 64 x 64px, w zależności od używanego urządzenia. Możesz również użyć innych rozmiarów, o ile są kwadratowe i nie przekraczają maksymalnej rozdzielczości.",
    "upload_favicon_error": "Obraz nie ma wymaganej rozdzielczości",
    "go_back_to_campaign": "Powrót do kampanii",
    "no_orders_to_display": "Brak zleceń do wyświetlenia",
    "no_editions_to_display": "Brak wydań do wyświetlenia",
    "google_tag_manager": "Google Tag Manager",
    "google_tag_manager_id": "IDENTYFIKATOR GTM",
    "website_analyse": "Analiza strony internetowej",
    "legal_information": "Informacje prawne",
    "contact_info": "Informacje kontaktowe",
    "fill_data_policy_before_autosave": "Automatyczne zapisywanie nie powiodło się. Wypełnij wszystkie dane dotyczące ochrony danych. Znajdziesz je w ustawieniach",
    "invoice_customer_info": "ID - Firma / Nazwa",
    "invoice_search_debtor": "Numer klienta",
    "invoice_search_vat": "VAT",
    "invoice_search_amount": "Kwota",
    "search_field_name": "Wybierz pole wyszukiwania",
    "search_field_info_text": "Jeśli chcesz wyszukać wartość liczbową w polu wyszukiwania, musisz wybrać pole",
    "image_permission_title": "Uwaga!",
    "image_permission_warning": "Czy prawa do wizerunku są dostępne/uzyskano zgodę wszystkich osób?",
    "other_settings": "Inne ustawienia",
    "image_rights_query": "Zapytanie o prawa do obrazu",
    "your_export": "Twój eksport",
    "export_download_info": "Plik został utworzony i można go teraz używać.",
    "export_download": "Pobierz",
    "export_file": "Plik",
    "export_share": "Udział",
    "direct_ordering_label": "Zamówienie bezpośrednie",
    "direct_ordering_info_text": "W przypadku zamówienia bezpośredniego utworzonej edycji nie można już edytować. Jest ona umieszczana bezpośrednio w koszyku.",
    "subscription_automation": {
      "title": "Cel rozliczeniowy dla subskrypcji nowych użytkowników",
      "payer": "Płatnik",
      "fee_for_role_user": "Opłata za ROLE_USER",
      "fee_for_role_admin": "Opłata za ROLE_ADMIN",
      "fee_for_role_wl_admin": "Opłata za ROLE_WL_ADMIN",
      "hint_title": "Uwaga",
      "hint_body": "Utwórz i aktywuj subskrypcję firmową dla tej firmy, aby objąć nią wszystkich użytkowników utworzonych później.",
      "debtor_ancestor": "Każda subskrypcja użytkownika jest obciążana %billingTargetName%.",
      "debtor_ancestor_missing": "Żadna poprzednia firma nie jest oznaczona jako dłużnik. Prosimy o poprawienie tego."
    },
    "undelete": "Przywracanie",
    "undelete_user_confirm": "Przywrócić użytkownika?",
    "publisher_info_text": "Wydawca jest automatycznie umieszczany we wszelkich niezbędnych materiałach reklamowych zgodnie z wytycznymi prawnymi.",
    "mark_campaign": "Kampania Marka",
    "template_exports": {
      "download_complete": "Pobieranie zakończone",
      "export": "Eksport",
      "download_files": "Pobieranie plików",
      "synchronize": "Synchronizacja"
    },
    "info_import_and_export": {
      "note": "Ogólne informacje na temat importu i eksportu",
      "import": "Importuj: Importuje wszystkie informacje o ustawieniach szablonu (CSS, bloki treści, inne ustawienia) i plikach. Tworzy początkowy plik zip do eksportu. Istniejące pliki zip są nadpisywane.",
      "upload": "Prześlij: Dodaje więcej plików do katalogu szablonu S3. Pliki te są dodawane do pliku zip w celu eksportu.",
      "sync": "Synchronizuj: Synchronizuje ustawienia szablonu (CSS, bloki treści, inne ustawienia) z plikami (index.html, seite.css, pdf.css, printpdf.css, website.css, website.js) w katalogu szablonów S3 i plikiem zip (eksport).",
      "export": "Export: Tworzy strukturę index.html do kopiowania i wklejania.",
      "download": "Pobierz pliki: Pobiera istniejący plik zip. (Wykonaj synchronizację przed pobraniem, aby uzyskać najnowsze dane).",
      "copy": "Kopiuj szablon: Funkcja \"Kopiuj szablon\" kopiuje tylko ustawienia szablonu, ale nie katalogi i pliki."
    },
    "template_upload_title": "Prześlij pliki do katalogu szablonu",
    "pls_choose_text": "Wybierz tekst",
    "discounts": {
      "discounts_tab_title": "Rabaty",
      "discount_type_invalid": "Typ rabatu jest nieprawidłowy",
      "intro_text": "Wprowadź numer grupy produktów FlyerAlarm oraz odpowiedni typ i wartość rabatu. Zostaną one zastosowane do wszystkich użytkowników w bieżącej firmie podczas płatności.",
      "none_yet_add_some": "Nie zdefiniowano jeszcze żadnych zniżek. Prosimy o ich dodanie.",
      "number_must_be_unique": "Numer musi być unikalny",
      "must_be_0_to_100": "Musi wynosić od 0 do 100"
    },
    "need_content_authorization": "Wymagana autoryzacja zawartości",
    "link_to_uploaded_pdf": "Adres URL przesłanego pliku PDF",
    "upload_qrcode_logo": "Prześlij logo dla QRCode",
    "choose_file": "Wybierz plik",
    "upload_successful": "Przesyłanie powiodło się",
    "upload_failed": "Przesyłanie nie powiodło się",
    "qr_logo": "Logo",
    "qr_example": "Przykład",
    "qr_settings": "Ustawienia kodu QR",
    "qr_margin": "Odległość",
    "qr_upload": "Prześlij logo QRCode",
    "google_search_console": "Google Search Console",
    "gsc_html_tag": "Weryfikacja tagów HTML",
    "content_id": "Content-Id",
    "gsc_html_tag_example": "Użyj weryfikacji tagów HTML. Skopiuj identyfikator, np. Xu9c238409d8JDSF8.... z atrybutu treści metatagu otrzymanego od Google w celu weryfikacji i wklej identyfikator tutaj. Przykład: <meta name='google-site-verification' content='Xu9c238409d8JDSF8...' />",
    "order_complete": {
      "good_luck": "Powodzenia w kampanii!",
      "order_complete": "Zamówienie zostało pomyślnie zrealizowane",
      "pls_check_inbox": "Prosimy o sprawdzenie skrzynki odbiorczej.",
      "order_info": "Wszystkie szczegóły zamówienia zostały wysłane na Twój adres e-mail zapisany w naszym pliku. Historię zamówień można wyświetlić w dowolnym momencie na koncie użytkownika pod adresem",
      "orders": "Zamówienia",
      "view": "widok.",
      "start_next_campaign": "Rozpocznij kolejną kampanię już teraz"
    },
    "no_product_selected": "Nie wybrano żadnego produktu",
    "mail_messages": {
      "header": {
        "header_title": "Inteligentny portal projektowy online",
        "support": "Pomoc i FAQ",
        "login": "LOGIN"
      },
      "footer": {
        "email_info": "Otrzymujesz tę wiadomość e-mail, ponieważ zarejestrowałeś się w %company%.",
        "dont_reply": "Ta wiadomość została wysłana z adresu, który nie może odbierać przychodzących wiadomości e-mail. </Prosimy o nie odpowiadanie na tę wiadomość. W razie jakichkolwiek pytań lub wątpliwości prosimy o kontakt pod adresem",
        "agb": "AGB",
        "privacy_policy": "Ochrona danych",
        "imprint": "Nadruk"
      }
    },
    "content_check": "Kontrola zawartości",
    "cancel_impersonation": "identyfikować się",
    "impersonate": "podszywanie się",
    "template_deleted_warning": "Uwaga! Szablon edycji nie jest już dostępny.",
    "terms_of_payment": "Warunki płatności",
    "terms_of_payment_edit": "Edycja warunków płatności",
    "click_to_enable_editing": "Kliknij tutaj, aby aktywować edycję na bieżącej karcie.",
    "click_to_send_a_request_to_enable_editing": "Kliknij tutaj, aby wysłać prośbę o aktywację edycji",
    "waiting_for_form_release": "Oczekiwanie na wydanie",
    "already_edited_by_another_user": "Ta edycja może być już edytowana przez innego użytkownika.",
    "please_wait": "Proszę czekać.",
    "user_already_requested_release": "Złożył już wniosek o zwolnienie",
    "user_requested_that_you_give_up_the_editing": "prosi o pozwolenie na edycję.",
    "emergency_release": "Wymuś zwolnienie. Używaj na własne ryzyko. Edycja może zostać nadpisana przez innego użytkownika, jeśli pracuje nad nią w danym momencie.",
    "alt_debtor_number": "Alternatywny identyfikator dłużnika",
    "use_bootstrap_label": "Bootstrap",
    "use_bootstrap_infotext": "Włączenie tej opcji spowoduje dołączenie bibliotek Bootstrap.",
    "last_queried_attributes": "Ostatnie żądane ceny",
    "transfer_campaign": "Transmisja",
    "duplicate_campaign_description": "Powiel kampanię i przypisz ją do poszczególnych użytkowników lub wszystkich użytkowników firmy.",
    "duplicate_campaign": "Duplikat",
    "clone_to_single_user": "Utwórz duplikat dla jednego lub więcej użytkowników",
    "clone_to_all_users_of_company": "Tworzenie duplikatów dla wszystkich użytkowników firmy",
    "enum_option_invalid": "Nieprawidłowa opcja",
    "pdf_download_option": {
      "enabled": "Aktywuje się",
      "disabled": "Wyłączony",
      "inherited": "Odziedziczone",
      "title": "Pobieranie plików PDF dozwolone",
      "loading": "Wczytaj odziedziczone ustawienie",
      "effective_setting": "skuteczna regulacja"
    },
    "choose_image_for_filter": "Wybierz zdjęcie",
    "invoice_email_bcc": {
      "send_new_invoice_email_bcc": "Wyślij nową fakturę przez e-mail BCC",
      "email_address_bcc": "Adres e-mail BCC",
      "info_text": "Na ten adres wysyłana jest również ukryta kopia wiadomości e-mail z nową fakturą."
    },
    "reduced_vat_rate": {
      "cart_item_hint": "Ta pozycja kwalifikuje się do obniżonej stawki VAT po ręcznym sprawdzeniu przez pracownika Creacheck"
    },
    "forgot_password_infotext": "Jeśli zapomniałeś hasła, możesz je zresetować tutaj. Wprowadź swój zarejestrowany adres e-mail w poniższym formularzu i kliknij \"Kontynuuj\". Następnie wyślemy wiadomość e-mail z dalszymi informacjami.",
    "forgot_password_infotext_robethood": "Jeśli zapomniałeś hasła, możesz je zresetować tutaj. Wprowadź swój zarejestrowany adres e-mail w poniższym formularzu i kliknij \"Kontynuuj\". Następnie wyślemy wiadomość e-mail z dalszymi informacjami.",
    "forgot_password_info_email_not_used": "Jeśli nie korzystasz już z adresu e-mail powiązanego z Twoim kontem Creacheck, skontaktuj się z nami za pośrednictwem naszego formularza kontaktowego:",
    "forgot_password_info_email_not_used_robethood": "Jeśli nie korzystasz już z adresu e-mail powiązanego z Twoim kontem, skontaktuj się z nami za pośrednictwem naszego formularza kontaktowego:",
    "remove_all_item_variant": "Usuń wszystkie edycje",
    "subscription_companies_detailed_role": "Użytkownik/rola w firmie",
    "invoice_greeting_male": "Szanowny Panie",
    "invoice_greeting_female": "Szanowna Pani",
    "invoice_greeting_text": "Bardzo dziękujemy za złożenie zamówienia za pośrednictwem %company%. Naliczymy opłatę za następujące usługi:",
    "bank_account": "Dane bankowe",
    "invoice_payment_threshold": {
      "title": "Wartość progowa",
      "placeholder": "w przykładzie 100",
      "no_effect": "Brak efektu",
      "loading": "Ładowanie odziedziczonych ustawień",
      "info_text": "Minimalna wartość zamówienia dla płatności fakturą",
      "effective_threshold": "Efektywny próg",
      "not_defined": "nieokreślony"
    },
    "mandatory_field": "Zadeklaruj to jako pole obowiązkowe",
    "custom_checkbox": "Niestandardowe pole wyboru",
    "set_label_checkbox": "Przypisz etykietę do pola wyboru",
    "set_checkbox_link": "Link do etykiety znajduje się tutaj",
    "change_checkbox_link": "Zmień łącze",
    "checkbox_infotext": "Możesz połączyć etykietę, umieszczając odpowiedni obszar w znakach $. np. Zgadzam się na $Privacy Policy$.",
    "perforation": {
      "cart_radiobox_title": "Opcje wypełniania perforacji",
      "attribute_is_custom_fa_setting": "Możliwość dostosowania wstępnie wybranych opcji perforacji FA",
      "set_perforation_options": "Ustawianie opcji perforacji",
      "preset": "Ustawienie domyślne",
      "how_to": "Wyszukaj identyfikator grupy produktów, wybierz kilka wariantów, wypróbuj różne ilości i metody wysyłki. Następnie wybierz opcję perforacji, która ma być wstępnie wybrana z tym atrybutem. Można dodać kilka opcji.",
      "select_variant": "Wybierz wariant, aby wyświetlić jego ilości i metody wysyłki.",
      "select_shipping_type": "Kliknij metodę wysyłki, aby zobaczyć dostępne opcje.",
      "select_option_value": "Kliknij opcję, aby dodać ją do listy wyboru.",
      "please_try_other": "Wypróbuj inny wariant, ilość lub metodę wysyłki",
      "options": "Opcje",
      "other_options": "Inne opcje",
      "selected_options": "Wybrane opcje",
      "perforation_options": "Opcje perforacji",
      "product_group": "Grupa produktów",
      "variants": "Warianty",
      "quantities_in_variant": "Ilości w wariancie"
    },
    "tracking_pixel_help_text": "Należy pamiętać, że implementacja może się różnić w zależności od dostawcy. W naszym przykładzie używamy piksela śledzącego od Meta. Integracja wymaga przede wszystkim weryfikacji domeny. Aby to zrobić, musisz zintegrować metatag, który w naszym przykładzie został dostarczony przez Meta. Zobacz przykładowy kod poniżej. Należy pamiętać, że weryfikacja może potrwać do 72 godzin, w zależności od dostawcy. W drugim kroku należy dodać kod bazowy dla integracji piksela śledzącego. Aby uzyskać więcej informacji, zapoznaj się z dokumentacją dostarczoną przez odpowiedniego dostawcę.",
    "reg_greeting_male": "Szanowny Panie",
    "reg_greeting_female": "Szanowna Pani",
    "reg_gender_male": "Pan",
    "reg_gender_female": "Pani",
    "reg_name": "Powitanie i imię",
    "reg_phone_number": "Numer telefonu",
    "reg_domain": "Domena",
    "reg_ancestors": "Identyfikatory struktur",
    "reg_explanation": "<p>Dziękujemy za rejestrację. Prosimy o potwierdzenie adresu e-mail w ciągu 24 godzin.</p><p>Tylko z potwierdzonym adresem e-mail możesz otrzymać nowe hasło internetowe lub informacje o zmianach.</p>",
    "only_whitelabel_admin_can_modify_label": "Tylko administrator Whitelabel",
    "only_whitelabel_admin_can_modify_info_text": "To pole może zostać zmienione wyłącznie przez administratora whitelabel. Powinno być używane, gdy administrator whitelabel tworzy szablon.",
    "load_flyeralarm_campaigns": "Ładowanie kampanii Flyeralarm",
    "load_designgenie_campaigns": "Kampanie Load DesignGenie",
    "categoryitems_stock": "Kawałek",
    "template_print_data": "Drukuj dane",
    "template_import_select_print_data_document": "Wybierz dokument danych drukowania",
    "template_upload_print_data_title": "Prześlij dane drukowania do katalogu szablonów",
    "template_upload_print_data_actual_file_title": "Przesłane dane drukowania",
    "template_upload_print_data_info": "Dodaje plik do katalogu szablonów S3. Plik ten jest używany dla produktów, gdy są one tworzone i nie są generowane żadne dane drukowania.",
    "csv_content": "Zawartość CSV",
    "warning_and_notes": "Ostrzeżenia i uwagi",
    "start_remove": "Rozpoczęcie usuwania",
    "reverse_remove": "Cofnij usunięcie",
    "remove_users_via_csv": "Usuwanie użytkowników poprzez import pliku CSV",
    "remove_users": "Usuń użytkownika",
    "company_name": "Nazwa firmy",
    "company_data_timeline_tab_title": "Oś czasu danych firmy",
    "updated_by": "Zaktualizowane przez",
    "update_company_data": "Zmiana nazwy firmy",
    "company_data_success": "Dane firmy zostały pomyślnie zmienione!",
    "company_data_error": "Błąd podczas zmiany danych firmy!",
    "widget_order_stats": {
      "title": "Całkowita liczba zamówień",
      "orders_count": "Liczenie zamówień",
      "orders_gross_total": "Zamówienia brutto ogółem",
      "no_orders_in_date_range": "Brak zamówień w wybranym okresie",
      "loading": "Ładowanie",
      "this_month": "W tym miesiącu",
      "previous_month": "Ostatni miesiąc",
      "last_3_months": "Ostatnie 3 miesiące",
      "last_6_months": "Ostatnie 6 miesięcy",
      "last_12_months": "Ostatnie 12 miesięcy",
      "for_companies": "dla spółek",
      "for_clients": "dla klientów"
    },
    "vendor_item_must_define_attributes": "Aby utworzyć warianty, należy zdefiniować atrybuty.",
    "vendor_item_has_no_attributes": "Ta grupa produktów nie ma atrybutów",
    "vendor_item_all_n_quantities": "Pokazuje wszystkie ilości {quantityCount}",
    "textile_select_exactly_n_items": "Wybierz dokładnie {łącznie}",
    "textile_exact_number_selected": "Wszystko dobrze: dokładnie {całkowicie} wybrane artykuły",
    "textile_order_quantity_mismatch": "Liczba rozmiarów materiału musi być zgodna z wybraną edycją.",
    "cart_domain_available": "jest dostępny!",
    "cart_domain_not_available_title": "Domena niedostępna",
    "pages_to_delete": "Następujące strony zostaną usunięte:",
    "page_to_delete": "Strona",
    "sales_doc_reverse_charge": "Faktura jest wystawiana bez podatku VAT, ponieważ w tym przypadku ma zastosowanie procedura odwrotnego obciążenia. VAT musi zostać zadeklarowany i zapłacony przez odbiorcę usługi.",
    "invoice_for_service": "Faktura za usługę",
    "billing_address_form_is_not_submitted": "Adres rozliczeniowy nie został podany. Prosimy o wypełnienie formularza.",
    "shipping_address_form_is_not_submitted": "Adres dostawy nie został podany. Prosimy o wypełnienie formularza.",
    "contact_data_saved": "Zapisane dane kontaktowe",
    "no_changes_made": "Nie wprowadzono żadnych zmian",
    "phone_invalid_country": "Kod kraju numeru telefonu jest nieprawidłowy",
    "mobile_phone_invalid_country": "Kod kraju numeru telefonu komórkowego jest nieprawidłowy",
    "fax_invalid_country": "Kod kraju numeru faksu jest nieprawidłowy",
    "search_campaign": "Wyszukiwanie kampanii",
    "coupon_usage": "Wykorzystanie kuponu",
    "coupon_balance_title": "Bilans kuponowy",
    "get_coupon_balance": "Zapytanie o pozostałą kwotę",
    "total_coupon_budget": "Całkowity budżet:",
    "remaining_coupon_budget": "Pozostały budżet:",
    "spent_coupon_budget": "Wydany budżet:",
    "coupon_balance_success": "Zapytanie powiodło się",
    "upload_print_data_previews": "Przesyłanie obrazów podglądu danych drukowania",
    "uploaded_print_data_previews": "Przesłane dane drukowania Podgląd obrazów",
    "confirm_upload": "Potwierdzenie",
    "add_allowed_domain": "Dodaj autoryzowaną domenę",
    "update_allowed_domain": "Aktualizacja autoryzowanej domeny",
    "start_pipeline": "Uruchomienie rurociągu",
    "pipeline_started": "Rurociąg uruchomiony",
    "failed": "Nie powiodło się",
    "not_started": "Nie rozpoczęto",
    "aws_iframe_hosting": "Hosting AWS Iframe",
    "aws_hosting_html_file_for_iframe_downloaded": "AWS Hosting Plik HTML dla ramki iframe z tytułem: %title%",
    "lead_stage_change_confirm_title": "Zmiana statusu lidera",
    "lead_stage_change_confirm_body": "Czy naprawdę chcesz zmienić status leada?",
    "iframe_implementation_file": "Plik implementacyjny iframe",
    "iframe_implementation_file_download_failed": "Nie można pobrać pliku implementacji Iframe: %error%",
    "lead_stage_change_error_domain_hosting_in_progress": "Lead nie może zostać zmieniony, ponieważ zadanie hostingu domeny nie zostało jeszcze ukończone.",
    "allowed_domain_already_exists": "Domena %domain% znajduje się już na liście autoryzowanych domen.",
    "allowed_domain_domain_name_should_not_be_empty": "Nazwa domeny nie może być pusta.",
    "allowed_domains_title": "Dozwolone domeny",
    "allowed_domains_description": "Tutaj można dodać domeny, które mogą być używane do implementacji ramek iframe.",
    "allowed_domains_add": "Dodaj domenę",
    "allowed_domains_domain_name": "Nazwa domeny",
    "allowed_domains_default_src": "Default-Src",
    "allowed_domains_script_src": "Script-Src",
    "allowed_domains_connect_src": "Connect-Src",
    "allowed_domains_style_src": "Style-Src",
    "allowed_domains_img_src": "Img-Src",
    "allowed_domains_font_src": "Font-Src",
    "allowed_domains_frame_src": "Frame-Src",
    "created_at": "Utworzono dnia",
    "created_by": "Stworzony przez",
    "cart_edtion_item_not_available": "Artykuł %item_name% nie jest już dostępny"
  }
}
